// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bruno+Ace+SC&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: "Open Sans", sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root, [data-theme] {
  color: hsl(var(--heroui-foreground));
  background-color: hsl(var(--heroui-background));
}

:root, [data-theme=light] {
  color-scheme: light;
  --heroui-background: 0 0% 100%;
  --heroui-foreground-50: 0 0% 98.04%;
  --heroui-foreground-100: 240 4.76% 95.88%;
  --heroui-foreground-200: 240 5.88% 90%;
  --heroui-foreground-300: 240 4.88% 83.92%;
  --heroui-foreground-400: 240 5.03% 64.9%;
  --heroui-foreground-500: 240 3.83% 46.08%;
  --heroui-foreground-600: 240 5.2% 33.92%;
  --heroui-foreground-700: 240 5.26% 26.08%;
  --heroui-foreground-800: 240 3.7% 15.88%;
  --heroui-foreground-900: 240 5.88% 10%;
  --heroui-foreground: 201.81999999999994 24.44% 8.82%;
  --heroui-divider: 0 0% 6.67%;
  --heroui-focus: 212.01999999999998 100% 46.67%;
  --heroui-overlay: 0 0% 0%;
  --heroui-content1: 0 0% 100%;
  --heroui-content1-foreground: 201.81999999999994 24.44% 8.82%;
  --heroui-content2: 240 4.76% 95.88%;
  --heroui-content2-foreground: 240 3.7% 15.88%;
  --heroui-content3: 240 5.88% 90%;
  --heroui-content3-foreground: 240 5.26% 26.08%;
  --heroui-content4: 240 4.88% 83.92%;
  --heroui-content4-foreground: 240 5.2% 33.92%;
  --heroui-default-50: 0 0% 98.04%;
  --heroui-default-100: 240 4.76% 95.88%;
  --heroui-default-200: 240 5.88% 90%;
  --heroui-default-300: 240 4.88% 83.92%;
  --heroui-default-400: 240 5.03% 64.9%;
  --heroui-default-500: 240 3.83% 46.08%;
  --heroui-default-600: 240 5.2% 33.92%;
  --heroui-default-700: 240 5.26% 26.08%;
  --heroui-default-800: 240 3.7% 15.88%;
  --heroui-default-900: 240 5.88% 10%;
  --heroui-default-foreground: 0 0% 0%;
  --heroui-default: 240 4.88% 83.92%;
  --heroui-primary-50: 212.5 92.31% 94.9%;
  --heroui-primary-100: 211.84000000000003 92.45% 89.61%;
  --heroui-primary-200: 211.84000000000003 92.45% 79.22%;
  --heroui-primary-300: 212.24 92.45% 68.82%;
  --heroui-primary-400: 212.14 92.45% 58.43%;
  --heroui-primary-500: 212.01999999999998 100% 46.67%;
  --heroui-primary-600: 212.14 100% 38.43%;
  --heroui-primary-700: 212.24 100% 28.82%;
  --heroui-primary-800: 211.84000000000003 100% 19.22%;
  --heroui-primary-900: 211.84000000000003 100% 9.61%;
  --heroui-primary-foreground: 0 0% 100%;
  --heroui-primary: 212.01999999999998 100% 46.67%;
  --heroui-secondary-50: 270 61.54% 94.9%;
  --heroui-secondary-100: 270 59.26% 89.41%;
  --heroui-secondary-200: 270 59.26% 78.82%;
  --heroui-secondary-300: 270 59.26% 68.24%;
  --heroui-secondary-400: 270 59.26% 57.65%;
  --heroui-secondary-500: 270 66.67% 47.06%;
  --heroui-secondary-600: 270 66.67% 37.65%;
  --heroui-secondary-700: 270 66.67% 28.24%;
  --heroui-secondary-800: 270 66.67% 18.82%;
  --heroui-secondary-900: 270 66.67% 9.41%;
  --heroui-secondary-foreground: 0 0% 100%;
  --heroui-secondary: 270 66.67% 47.06%;
  --heroui-success-50: 146.66999999999996 64.29% 94.51%;
  --heroui-success-100: 145.71000000000004 61.4% 88.82%;
  --heroui-success-200: 146.2 61.74% 77.45%;
  --heroui-success-300: 145.78999999999996 62.57% 66.47%;
  --heroui-success-400: 146.01 62.45% 55.1%;
  --heroui-success-500: 145.96000000000004 79.46% 43.92%;
  --heroui-success-600: 146.01 79.89% 35.1%;
  --heroui-success-700: 145.78999999999996 79.26% 26.47%;
  --heroui-success-800: 146.2 79.78% 17.45%;
  --heroui-success-900: 145.71000000000004 77.78% 8.82%;
  --heroui-success-foreground: 0 0% 0%;
  --heroui-success: 145.96000000000004 79.46% 43.92%;
  --heroui-warning-50: 54.55000000000001 91.67% 95.29%;
  --heroui-warning-100: 37.139999999999986 91.3% 90.98%;
  --heroui-warning-200: 37.139999999999986 91.3% 81.96%;
  --heroui-warning-300: 36.95999999999998 91.24% 73.14%;
  --heroui-warning-400: 37.00999999999999 91.26% 64.12%;
  --heroui-warning-500: 37.02999999999997 91.27% 55.1%;
  --heroui-warning-600: 37.00999999999999 74.22% 44.12%;
  --heroui-warning-700: 36.95999999999998 73.96% 33.14%;
  --heroui-warning-800: 37.139999999999986 75% 21.96%;
  --heroui-warning-900: 37.139999999999986 75% 10.98%;
  --heroui-warning-foreground: 0 0% 0%;
  --heroui-warning: 37.02999999999997 91.27% 55.1%;
  --heroui-danger-50: 339.13 92% 95.1%;
  --heroui-danger-100: 340 91.84% 90.39%;
  --heroui-danger-200: 339.3299999999999 90% 80.39%;
  --heroui-danger-300: 339.11 90.6% 70.78%;
  --heroui-danger-400: 339 90% 60.78%;
  --heroui-danger-500: 339.20000000000005 90.36% 51.18%;
  --heroui-danger-600: 339 86.54% 40.78%;
  --heroui-danger-700: 339.11 85.99% 30.78%;
  --heroui-danger-800: 339.3299999999999 86.54% 20.39%;
  --heroui-danger-900: 340 84.91% 10.39%;
  --heroui-danger-foreground: 0 0% 100%;
  --heroui-danger: 339.20000000000005 90.36% 51.18%;
  --heroui-divider-weight: 1px;
  --heroui-disabled-opacity: .5;
  --heroui-font-size-tiny: 0.75rem;
  --heroui-font-size-small: 0.875rem;
  --heroui-font-size-medium: 1rem;
  --heroui-font-size-large: 1.125rem;
  --heroui-line-height-tiny: 1rem;
  --heroui-line-height-small: 1.25rem;
  --heroui-line-height-medium: 1.5rem;
  --heroui-line-height-large: 1.75rem;
  --heroui-radius-small: 8px;
  --heroui-radius-medium: 12px;
  --heroui-radius-large: 14px;
  --heroui-border-width-small: 1px;
  --heroui-border-width-medium: 2px;
  --heroui-border-width-large: 3px;
  --heroui-box-shadow-small: 0px 0px 5px 0px rgb(0 0 0 / 0.02), 0px 2px 10px 0px rgb(0 0 0 / 0.06), 0px 0px 1px 0px rgb(0 0 0 / 0.3);
  --heroui-box-shadow-medium: 0px 0px 15px 0px rgb(0 0 0 / 0.03), 0px 2px 30px 0px rgb(0 0 0 / 0.08), 0px 0px 1px 0px rgb(0 0 0 / 0.3);
  --heroui-box-shadow-large: 0px 0px 30px 0px rgb(0 0 0 / 0.04), 0px 30px 60px 0px rgb(0 0 0 / 0.12), 0px 0px 1px 0px rgb(0 0 0 / 0.3);
  --heroui-hover-opacity: .8;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.\\!top-1\\/2 {
  top: 50% !important;
}
.-bottom-3 {
  bottom: -0.75rem;
}
.-right-1 {
  right: -0.25rem;
}
.-right-2 {
  right: -0.5rem;
}
.-right-px {
  right: -1px;
}
.-top-2 {
  top: -0.5rem;
}
.-top-px {
  top: -1px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-6 {
  bottom: 1.5rem;
}
.bottom-\\[10\\%\\] {
  bottom: 10%;
}
.bottom-\\[5\\%\\] {
  bottom: 5%;
}
.end-1 {
  inset-inline-end: 0.25rem;
}
.end-1\\.5 {
  inset-inline-end: 0.375rem;
}
.end-3 {
  inset-inline-end: 0.75rem;
}
.end-auto {
  inset-inline-end: auto;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-6 {
  left: 1.5rem;
}
.left-\\[10\\%\\] {
  left: 10%;
}
.left-\\[5\\%\\] {
  left: 5%;
}
.left-\\[calc\\(37\\.5\\%\\)\\] {
  left: calc(37.5%);
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.right-4 {
  right: 1rem;
}
.right-6 {
  right: 1.5rem;
}
.right-\\[10\\%\\] {
  right: 10%;
}
.right-\\[5\\%\\] {
  right: 5%;
}
.start-0 {
  inset-inline-start: 0px;
}
.start-1\\.5 {
  inset-inline-start: 0.375rem;
}
.start-2 {
  inset-inline-start: 0.5rem;
}
.start-3 {
  inset-inline-start: 0.75rem;
}
.start-auto {
  inset-inline-start: auto;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-2 {
  top: 0.5rem;
}
.top-4 {
  top: 1rem;
}
.top-\\[10\\%\\] {
  top: 10%;
}
.top-\\[5\\%\\] {
  top: 5%;
}
.top-\\[calc\\(100\\%_\\+_2px\\)\\] {
  top: calc(100% + 2px);
}
.top-\\[calc\\(46\\%\\)\\] {
  top: calc(46%);
}
.top-\\[var\\(--navbar-height\\)\\] {
  top: var(--navbar-height);
}
.-z-30 {
  z-index: -30;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[-1\\] {
  z-index: -1;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[10\\] {
  z-index: 10;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[2000\\] {
  z-index: 2000;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.col-span-full {
  grid-column: 1 / -1;
}
.float-right {
  float: right;
}
.-m-1\\.5 {
  margin: -0.375rem;
}
.-m-2 {
  margin: -0.5rem;
}
.-m-2\\.5 {
  margin: -0.625rem;
}
.m-0 {
  margin: 0px;
}
.m-2 {
  margin: 0.5rem;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-2 {
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-\\[calc\\(\\(theme\\(spacing\\.5\\)-theme\\(spacing\\.1\\)\\)\\/2\\)\\] {
  margin-left: calc((1.25rem - 0.25rem) / 2);
  margin-right: calc((1.25rem - 0.25rem) / 2);
}
.mx-\\[calc\\(\\(theme\\(spacing\\.6\\)-theme\\(spacing\\.3\\)\\)\\/2\\)\\] {
  margin-left: calc((1.5rem - 0.75rem) / 2);
  margin-right: calc((1.5rem - 0.75rem) / 2);
}
.mx-\\[calc\\(\\(theme\\(spacing\\.7\\)-theme\\(spacing\\.5\\)\\)\\/2\\)\\] {
  margin-left: calc((1.75rem - 1.25rem) / 2);
  margin-right: calc((1.75rem - 1.25rem) / 2);
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-16 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-\\[calc\\(\\(theme\\(spacing\\.5\\)-theme\\(spacing\\.1\\)\\)\\/2\\)\\] {
  margin-top: calc((1.25rem - 0.25rem) / 2);
  margin-bottom: calc((1.25rem - 0.25rem) / 2);
}
.my-\\[calc\\(\\(theme\\(spacing\\.6\\)-theme\\(spacing\\.3\\)\\)\\/2\\)\\] {
  margin-top: calc((1.5rem - 0.75rem) / 2);
  margin-bottom: calc((1.5rem - 0.75rem) / 2);
}
.my-\\[calc\\(\\(theme\\(spacing\\.7\\)-theme\\(spacing\\.5\\)\\)\\/2\\)\\] {
  margin-top: calc((1.75rem - 1.25rem) / 2);
  margin-bottom: calc((1.75rem - 1.25rem) / 2);
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.\\!mb-4 {
  margin-bottom: 1rem !important;
}
.-mr-2 {
  margin-right: -0.5rem;
}
.-ms-2 {
  margin-inline-start: -0.5rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-24 {
  margin-bottom: 6rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-\\[-2rem\\] {
  margin-bottom: -2rem;
}
.mb-px {
  margin-bottom: 1px;
}
.me-2 {
  margin-inline-end: 0.5rem;
}
.me-4 {
  margin-inline-end: 1rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-20 {
  margin-left: 5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-\\[2\\.125rem\\] {
  margin-left: 2.125rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.ms-2 {
  margin-inline-start: 0.5rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[-8rem\\] {
  margin-top: -8rem;
}
.mt-\\[auto\\] {
  margin-top: auto;
}
.mt-auto {
  margin-top: auto;
}
.box-border {
  box-sizing: border-box;
}
.box-content {
  box-sizing: content-box;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.flow-root {
  display: flow-root;
}
.grid {
  display: grid;
}
.inline-grid {
  display: inline-grid;
}
.hidden {
  display: none;
}
.size-1 {
  width: 0.25rem;
  height: 0.25rem;
}
.size-1\\.5 {
  width: 0.375rem;
  height: 0.375rem;
}
.size-2 {
  width: 0.5rem;
  height: 0.5rem;
}
.size-4 {
  width: 1rem;
  height: 1rem;
}
.size-6 {
  width: 1.5rem;
  height: 1.5rem;
}
.\\!h-10 {
  height: 2.5rem !important;
}
.\\!h-6 {
  height: 1.5rem !important;
}
.\\!h-auto {
  height: auto !important;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-2\\/3 {
  height: 66.666667%;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[100dvh\\] {
  height: 100dvh;
}
.h-\\[13rem\\] {
  height: 13rem;
}
.h-\\[2\\.625rem\\] {
  height: 2.625rem;
}
.h-\\[20rem\\] {
  height: 20rem;
}
.h-\\[25rem\\] {
  height: 25rem;
}
.h-\\[26rem\\] {
  height: 26rem;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[2rem\\] {
  height: 2rem;
}
.h-\\[3\\.125rem\\] {
  height: 3.125rem;
}
.h-\\[3rem\\] {
  height: 3rem;
}
.h-\\[50\\%\\] {
  height: 50%;
}
.h-\\[5rem\\] {
  height: 5rem;
}
.h-\\[6\\.25rem\\] {
  height: 6.25rem;
}
.h-\\[8\\%\\] {
  height: 8%;
}
.h-\\[8\\.375rem\\] {
  height: 8.375rem;
}
.h-\\[9rem\\] {
  height: 9rem;
}
.h-\\[auto\\] {
  height: auto;
}
.h-\\[calc\\(100\\%-1\\.25rem\\)\\] {
  height: calc(100% - 1.25rem);
}
.h-\\[calc\\(100dvh_-_var\\(--navbar-height\\)\\)\\] {
  height: calc(100dvh - var(--navbar-height));
}
.h-\\[var\\(--navbar-height\\)\\] {
  height: var(--navbar-height);
}
.h-\\[var\\(--picker-height\\)\\] {
  height: var(--picker-height);
}
.h-auto {
  height: auto;
}
.h-divider {
  height: var(--heroui-divider-weight);
}
.h-dvh {
  height: 100dvh;
}
.h-fit {
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-\\[20rem\\] {
  max-height: 20rem;
}
.max-h-\\[24rem\\] {
  max-height: 24rem;
}
.max-h-\\[28rem\\] {
  max-height: 28rem;
}
.max-h-\\[30rem\\] {
  max-height: 30rem;
}
.max-h-\\[32rem\\] {
  max-height: 32rem;
}
.max-h-\\[36rem\\] {
  max-height: 36rem;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.max-h-\\[42rem\\] {
  max-height: 42rem;
}
.max-h-\\[48rem\\] {
  max-height: 48rem;
}
.max-h-\\[56rem\\] {
  max-height: 56rem;
}
.max-h-\\[64rem\\] {
  max-height: 64rem;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[calc\\(100\\%_-_8rem\\)\\] {
  max-height: calc(100% - 8rem);
}
.max-h-\\[none\\] {
  max-height: none;
}
.max-h-full {
  max-height: 100%;
}
.min-h-10 {
  min-height: 2.5rem;
}
.min-h-12 {
  min-height: 3rem;
}
.min-h-14 {
  min-height: 3.5rem;
}
.min-h-16 {
  min-height: 4rem;
}
.min-h-3 {
  min-height: 0.75rem;
}
.min-h-3\\.5 {
  min-height: 0.875rem;
}
.min-h-4 {
  min-height: 1rem;
}
.min-h-5 {
  min-height: 1.25rem;
}
.min-h-6 {
  min-height: 1.5rem;
}
.min-h-7 {
  min-height: 1.75rem;
}
.min-h-8 {
  min-height: 2rem;
}
.min-h-\\[100dvh\\] {
  min-height: 100dvh;
}
.min-h-\\[2\\.5rem\\] {
  min-height: 2.5rem;
}
.min-h-\\[3\\.125rem\\] {
  min-height: 3.125rem;
}
.min-h-\\[32px\\] {
  min-height: 32px;
}
.min-h-\\[3rem\\] {
  min-height: 3rem;
}
.min-h-dvh {
  min-height: 100dvh;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-10 {
  width: 2.5rem !important;
}
.\\!w-6 {
  width: 1.5rem !important;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/4 {
  width: 25%;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-32 {
  width: 8rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[1\\.625rem\\] {
  width: 1.625rem;
}
.w-\\[11\\.25rem\\] {
  width: 11.25rem;
}
.w-\\[15\\.625rem\\] {
  width: 15.625rem;
}
.w-\\[25\\%\\] {
  width: 25%;
}
.w-\\[2px\\] {
  width: 2px;
}
.w-\\[2rem\\] {
  width: 2rem;
}
.w-\\[3rem\\] {
  width: 3rem;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[5rem\\] {
  width: 5rem;
}
.w-\\[6\\.25rem\\] {
  width: 6.25rem;
}
.w-\\[6rem\\] {
  width: 6rem;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-\\[86\\%\\] {
  width: 86%;
}
.w-\\[8rem\\] {
  width: 8rem;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[9rem\\] {
  width: 9rem;
}
.w-\\[calc\\(100\\%-2\\.5rem\\)\\] {
  width: calc(100% - 2.5rem);
}
.w-\\[calc\\(100\\%-2\\.625rem\\)\\] {
  width: calc(100% - 2.625rem);
}
.w-\\[calc\\(100\\%-3\\.5rem\\)\\] {
  width: calc(100% - 3.5rem);
}
.w-\\[calc\\(100\\%-3rem\\)\\] {
  width: calc(100% - 3rem);
}
.w-\\[calc\\(100\\%-6rem\\)\\] {
  width: calc(100% - 6rem);
}
.w-\\[calc\\(100\\%_-_16px\\)\\] {
  width: calc(100% - 16px);
}
.w-\\[calc\\(100\\%_-theme\\(spacing\\.6\\)\\)\\] {
  width: calc(100% - 1.5rem);
}
.w-\\[calc\\(var\\(--visible-months\\)_\\*_var\\(--calendar-width\\)\\)\\] {
  width: calc(var(--visible-months) * var(--calendar-width));
}
.w-auto {
  width: auto;
}
.w-divider {
  width: var(--heroui-divider-weight);
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.w-screen {
  width: 100vw;
}
.\\!min-w-6 {
  min-width: 1.5rem !important;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-10 {
  min-width: 2.5rem;
}
.min-w-12 {
  min-width: 3rem;
}
.min-w-16 {
  min-width: 4rem;
}
.min-w-20 {
  min-width: 5rem;
}
.min-w-24 {
  min-width: 6rem;
}
.min-w-28 {
  min-width: 7rem;
}
.min-w-3 {
  min-width: 0.75rem;
}
.min-w-3\\.5 {
  min-width: 0.875rem;
}
.min-w-4 {
  min-width: 1rem;
}
.min-w-40 {
  min-width: 10rem;
}
.min-w-5 {
  min-width: 1.25rem;
}
.min-w-6 {
  min-width: 1.5rem;
}
.min-w-7 {
  min-width: 1.75rem;
}
.min-w-8 {
  min-width: 2rem;
}
.min-w-9 {
  min-width: 2.25rem;
}
.min-w-\\[12rem\\] {
  min-width: 12rem;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[9\\.5rem\\] {
  min-width: 9.5rem;
}
.min-w-full {
  min-width: 100%;
}
.min-w-max {
  min-width: max-content;
}
.min-w-min {
  min-width: min-content;
}
.\\!max-w-\\[13rem\\] {
  max-width: 13rem !important;
}
.\\!max-w-full {
  max-width: 100% !important;
}
.max-w-10 {
  max-width: 2.5rem;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[1024px\\] {
  max-width: 1024px;
}
.max-w-\\[1280px\\] {
  max-width: 1280px;
}
.max-w-\\[13\\.75rem\\] {
  max-width: 13.75rem;
}
.max-w-\\[1536px\\] {
  max-width: 1536px;
}
.max-w-\\[15rem\\] {
  max-width: 15rem;
}
.max-w-\\[18\\.75rem\\] {
  max-width: 18.75rem;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[25rem\\] {
  max-width: 25rem;
}
.max-w-\\[270px\\] {
  max-width: 270px;
}
.max-w-\\[27rem\\] {
  max-width: 27rem;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[28rem\\] {
  max-width: 28rem;
}
.max-w-\\[31rem\\] {
  max-width: 31rem;
}
.max-w-\\[38rem\\] {
  max-width: 38rem;
}
.max-w-\\[640px\\] {
  max-width: 640px;
}
.max-w-\\[768px\\] {
  max-width: 768px;
}
.max-w-\\[8rem\\] {
  max-width: 8rem;
}
.max-w-\\[none\\] {
  max-width: none;
}
.max-w-fit {
  max-width: fit-content;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-auto {
  flex: 1 1 auto;
}
.flex-initial {
  flex: 0 1 auto;
}
.flex-none {
  flex: none;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.basis-0 {
  flex-basis: 0px;
}
.table-auto {
  table-layout: auto;
}
.table-fixed {
  table-layout: fixed;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-center {
  transform-origin: center;
}
.origin-left {
  transform-origin: left;
}
.origin-right {
  transform-origin: right;
}
.origin-top {
  transform-origin: top;
}
.origin-top-left {
  transform-origin: top left;
}
.\\!-translate-y-1\\/2 {
  --tw-translate-y: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1 {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/2 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1 {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1\\/2 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2\\/4 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-3\\/4 {
  --tw-translate-y: 75%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-0 {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-50 {
  --tw-scale-x: .5;
  --tw-scale-y: .5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-90 {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform-gpu {
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes appearance-in {

  0% {
    opacity: 0;
    transform: translateZ(0)  scale(0.95);
  }

  60% {
    opacity: 0.75;
    backface-visibility: hidden;
    webkit-font-smoothing: antialiased;
    transform: translateZ(0) scale(1.05);
  }

  100% {
    opacity: 1;
    transform: translateZ(0) scale(1);
  }
}
.animate-\\[appearance-in_1s_infinite\\] {
  animation: appearance-in 1s infinite;
}
@keyframes blink {

  0% {
    opacity: 1;
  }

  20% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }

  50% {
    background-color: #00FF7F;
    color: #000;
  }
}
.animate-blink {
  animation: blink 800ms infinite;
}
@keyframes drip-expand {

  0% {
    opacity: 0.2;
    transform: scale(0);
  }

  100% {
    opacity: 0;
    transform: scale(2);
  }
}
.animate-drip-expand {
  animation: drip-expand 420ms linear;
}
@keyframes indeterminate-bar {

  0% {
    transform: translateX(-50%) scaleX(0.2);
  }

  100% {
    transform: translateX(100%) scaleX(1);
  }
}
.animate-indeterminate-bar {
  animation: indeterminate-bar 1.5s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite normal none running;
}
.animate-none {
  animation: none;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
@keyframes spinner-spin {

  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.animate-spinner-ease-spin {
  animation: spinner-spin 0.8s ease infinite;
}
@keyframes spinner-spin {

  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.animate-spinner-linear-spin {
  animation: spinner-spin 0.8s linear infinite;
}
@keyframes sway {

  0% {
    transform: translate(0px, 0px);
  }

  50% {
    transform: translate(0px, -150%);
  }

  100% {
    transform: translate(0px, 0px);
  }
}
.animate-sway {
  animation: sway 750ms ease infinite;
}
.cursor-auto {
  cursor: auto;
}
.cursor-default {
  cursor: default;
}
.cursor-grab {
  cursor: grab;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-text {
  cursor: text;
}
.touch-none {
  touch-action: none;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.snap-y {
  scroll-snap-type: y var(--tw-scroll-snap-strictness);
}
.snap-mandatory {
  --tw-scroll-snap-strictness: mandatory;
}
.snap-center {
  scroll-snap-align: center;
}
.scroll-py-6 {
  scroll-padding-top: 1.5rem;
  scroll-padding-bottom: 1.5rem;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.\\!appearance-none {
  appearance: none !important;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.place-content-center {
  place-content: center;
}
.place-items-center {
  place-items: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.\\!gap-0 {
  gap: 0px !important;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-20 {
  gap: 5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-0 {
  column-gap: 0px;
}
.gap-x-0\\.5 {
  column-gap: 0.125rem;
}
.gap-x-1 {
  column-gap: 0.25rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-y-0 {
  row-gap: 0px;
}
.gap-y-1\\.5 {
  row-gap: 0.375rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.-space-x-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(-1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.125rem * var(--tw-space-x-reverse));
  margin-left: calc(0.125rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.self-center {
  align-self: center;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-clip {
  overflow: clip;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.\\!rounded-none {
  border-radius: 0px !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[0\\.625rem\\] {
  border-radius: 0.625rem;
}
.rounded-\\[5rem\\] {
  border-radius: 5rem;
}
.rounded-\\[calc\\(var\\(--heroui-radius-large\\)\\/1\\.5\\)\\] {
  border-radius: calc(var(--heroui-radius-large) / 1.5);
}
.rounded-\\[calc\\(var\\(--heroui-radius-medium\\)\\*0\\.5\\)\\] {
  border-radius: calc(var(--heroui-radius-medium) * 0.5);
}
.rounded-\\[calc\\(var\\(--heroui-radius-medium\\)\\*0\\.6\\)\\] {
  border-radius: calc(var(--heroui-radius-medium) * 0.6);
}
.rounded-\\[calc\\(var\\(--heroui-radius-medium\\)\\*0\\.7\\)\\] {
  border-radius: calc(var(--heroui-radius-medium) * 0.7);
}
.rounded-\\[calc\\(var\\(--heroui-radius-medium\\)\\/2\\)\\] {
  border-radius: calc(var(--heroui-radius-medium) / 2);
}
.rounded-\\[calc\\(var\\(--heroui-radius-small\\)\\/2\\)\\] {
  border-radius: calc(var(--heroui-radius-small) / 2);
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-large {
  border-radius: var(--heroui-radius-large);
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-medium {
  border-radius: var(--heroui-radius-medium);
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-small {
  border-radius: var(--heroui-radius-small);
}
.rounded-xl {
  border-radius: 0.75rem;
}
.\\!rounded-e-none {
  border-start-end-radius: 0px !important;
  border-end-end-radius: 0px !important;
}
.\\!rounded-s-none {
  border-start-start-radius: 0px !important;
  border-end-start-radius: 0px !important;
}
.rounded-b-2xl {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-large {
  border-bottom-right-radius: var(--heroui-radius-large);
  border-bottom-left-radius: var(--heroui-radius-large);
}
.rounded-b-medium {
  border-bottom-right-radius: var(--heroui-radius-medium);
  border-bottom-left-radius: var(--heroui-radius-medium);
}
.rounded-b-none {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-b-small {
  border-bottom-right-radius: var(--heroui-radius-small);
  border-bottom-left-radius: var(--heroui-radius-small);
}
.rounded-e-lg {
  border-start-end-radius: 0.5rem;
  border-end-end-radius: 0.5rem;
}
.rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-none {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.rounded-s-lg {
  border-start-start-radius: 0.5rem;
  border-end-start-radius: 0.5rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-large {
  border-top-left-radius: var(--heroui-radius-large);
  border-top-right-radius: var(--heroui-radius-large);
}
.rounded-t-medium {
  border-top-left-radius: var(--heroui-radius-medium);
  border-top-right-radius: var(--heroui-radius-medium);
}
.rounded-t-none {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.rounded-t-small {
  border-top-left-radius: var(--heroui-radius-small);
  border-top-right-radius: var(--heroui-radius-small);
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-1 {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-3 {
  border-width: 3px;
}
.border-4 {
  border-width: 4px;
}
.border-\\[0\\.75rem\\] {
  border-width: 0.75rem;
}
.border-medium {
  border-width: var(--heroui-border-width-medium);
}
.border-small {
  border-width: var(--heroui-border-width-small);
}
.border-x-\\[calc\\(theme\\(spacing\\.5\\)\\/2\\)\\] {
  border-left-width: calc(1.25rem / 2);
  border-right-width: calc(1.25rem / 2);
}
.border-x-\\[calc\\(theme\\(spacing\\.6\\)\\/2\\)\\] {
  border-left-width: calc(1.5rem / 2);
  border-right-width: calc(1.5rem / 2);
}
.border-x-\\[calc\\(theme\\(spacing\\.7\\)\\/2\\)\\] {
  border-left-width: calc(1.75rem / 2);
  border-right-width: calc(1.75rem / 2);
}
.border-y-\\[calc\\(theme\\(spacing\\.5\\)\\/2\\)\\] {
  border-top-width: calc(1.25rem / 2);
  border-bottom-width: calc(1.25rem / 2);
}
.border-y-\\[calc\\(theme\\(spacing\\.6\\)\\/2\\)\\] {
  border-top-width: calc(1.5rem / 2);
  border-bottom-width: calc(1.5rem / 2);
}
.border-y-\\[calc\\(theme\\(spacing\\.7\\)\\/2\\)\\] {
  border-top-width: calc(1.75rem / 2);
  border-bottom-width: calc(1.75rem / 2);
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-b-medium {
  border-bottom-width: var(--heroui-border-width-medium);
}
.border-l-0 {
  border-left-width: 0px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-t {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-dotted {
  border-style: dotted;
}
.\\!border-none {
  border-style: none !important;
}
.border-none {
  border-style: none;
}
.\\!border-black {
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-danger {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#00000066\\] {
  border-color: #00000066;
}
.border-\\[\\#000000\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-\\[\\#0000FF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1FEF68\\] {
  --tw-border-opacity: 1;
  border-color: rgb(31 239 104 / var(--tw-border-opacity, 1));
}
.border-\\[\\#C2C2C2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(194 194 194 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F5D113\\] {
  --tw-border-opacity: 1;
  border-color: rgb(245 209 19 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FCEDFD\\] {
  --tw-border-opacity: 1;
  border-color: rgb(252 237 253 / var(--tw-border-opacity, 1));
}
.border-background {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-background) / var(--tw-border-opacity, 1));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-current {
  border-color: currentColor;
}
.border-danger {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.border-danger-100 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger-100) / var(--tw-border-opacity, 1));
}
.border-danger-200 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger-200) / var(--tw-border-opacity, 1));
}
.border-danger-400 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger-400) / var(--tw-border-opacity, 1));
}
.border-default {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default) / var(--tw-border-opacity, 1));
}
.border-default-100 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-100) / var(--tw-border-opacity, 1));
}
.border-default-200 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-200) / var(--tw-border-opacity, 1));
}
.border-default-300 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-300) / var(--tw-border-opacity, 1));
}
.border-default-400 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-400) / var(--tw-border-opacity, 1));
}
.border-divider {
  border-color: hsl(var(--heroui-divider) / 0.15);
}
.border-foreground {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-foreground) / var(--tw-border-opacity, 1));
}
.border-foreground-400 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-foreground-400) / var(--tw-border-opacity, 1));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-primary {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.border-primary-100 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary-100) / var(--tw-border-opacity, 1));
}
.border-primary-200 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary-200) / var(--tw-border-opacity, 1));
}
.border-primary-400 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary-400) / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-secondary {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.border-secondary-100 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary-100) / var(--tw-border-opacity, 1));
}
.border-secondary-200 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary-200) / var(--tw-border-opacity, 1));
}
.border-secondary-400 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary-400) / var(--tw-border-opacity, 1));
}
.border-success {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.border-success-100 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success-100) / var(--tw-border-opacity, 1));
}
.border-success-200 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success-200) / var(--tw-border-opacity, 1));
}
.border-success-300 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success-300) / var(--tw-border-opacity, 1));
}
.border-success-400 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success-400) / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-warning {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.border-warning-100 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning-100) / var(--tw-border-opacity, 1));
}
.border-warning-200 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning-200) / var(--tw-border-opacity, 1));
}
.border-warning-300 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning-300) / var(--tw-border-opacity, 1));
}
.border-warning-400 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning-400) / var(--tw-border-opacity, 1));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-yellowbuy {
  --tw-border-opacity: 1;
  border-color: rgb(0 255 127 / var(--tw-border-opacity, 1));
}
.border-x-transparent {
  border-left-color: transparent;
  border-right-color: transparent;
}
.border-y-transparent {
  border-top-color: transparent;
  border-bottom-color: transparent;
}
.\\!border-b-yellowbuy {
  --tw-border-opacity: 1 !important;
  border-bottom-color: rgb(0 255 127 / var(--tw-border-opacity, 1)) !important;
}
.border-b-current {
  border-bottom-color: currentColor;
}
.border-b-danger {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.border-b-default {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-default) / var(--tw-border-opacity, 1));
}
.border-b-primary {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.border-b-secondary {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.border-b-success {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.border-b-warning {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.border-b-white {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-r-transparent {
  border-right-color: transparent;
}
.border-t-transparent {
  border-top-color: transparent;
}
.\\!bg-danger-50 {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-danger-50) / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.bg-\\[\\#0000004d\\] {
  background-color: #0000004d;
}
.bg-\\[\\#000000E5\\] {
  background-color: #000000E5;
}
.bg-\\[\\#000000\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#00FF7F\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 255 127 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1E4800\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 72 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1FEF68\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(31 239 104 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#71B243\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(113 178 67 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#C0C0C0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(192 192 192 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#CCCDC6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(204 205 198 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D3D3D3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(211 211 211 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E7E7E7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 231 231 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E9E9E9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(233 233 233 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EBEBEB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(235 235 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F01444\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 20 68 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F4F4FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5D113\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 209 19 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF6C00\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 108 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#b6b1b6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(182 177 182 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4f4f4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[transparent\\] {
  background-color: transparent;
}
.bg-background {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-background) / var(--tw-bg-opacity, 1));
}
.bg-background\\/10 {
  background-color: hsl(var(--heroui-background) / 0.1);
}
.bg-background\\/70 {
  background-color: hsl(var(--heroui-background) / 0.7);
}
.bg-background\\/80 {
  background-color: hsl(var(--heroui-background) / 0.8);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-content1 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-content1) / var(--tw-bg-opacity, 1));
}
.bg-content3 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-content3) / var(--tw-bg-opacity, 1));
}
.bg-current {
  background-color: currentColor;
}
.bg-danger {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1));
}
.bg-danger-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-100) / var(--tw-bg-opacity, 1));
}
.bg-danger-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-400) / var(--tw-bg-opacity, 1));
}
.bg-danger-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--tw-bg-opacity, 1));
}
.bg-danger\\/20 {
  background-color: hsl(var(--heroui-danger) / 0.2);
}
.bg-default {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default) / var(--tw-bg-opacity, 1));
}
.bg-default-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--tw-bg-opacity, 1));
}
.bg-default-200 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-200) / var(--tw-bg-opacity, 1));
}
.bg-default-300\\/50 {
  background-color: hsl(var(--heroui-default-300) / 0.5);
}
.bg-default-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-400) / var(--tw-bg-opacity, 1));
}
.bg-default-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-50) / var(--tw-bg-opacity, 1));
}
.bg-default-500 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-500) / var(--tw-bg-opacity, 1));
}
.bg-default-800 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-800) / var(--tw-bg-opacity, 1));
}
.bg-default\\/40 {
  background-color: hsl(var(--heroui-default) / 0.4);
}
.bg-divider {
  background-color: hsl(var(--heroui-divider) / 0.15);
}
.bg-foreground {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--tw-bg-opacity, 1));
}
.bg-foreground-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground-100) / var(--tw-bg-opacity, 1));
}
.bg-foreground-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground-400) / var(--tw-bg-opacity, 1));
}
.bg-foreground\\/10 {
  background-color: hsl(var(--heroui-foreground) / 0.1);
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-lytyellow {
  background-color: #00FF7F9C;
}
.bg-overlay\\/30 {
  background-color: hsl(var(--heroui-overlay) / 0.3);
}
.bg-overlay\\/50 {
  background-color: hsl(var(--heroui-overlay) / 0.5);
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--tw-bg-opacity, 1));
}
.bg-primary-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-100) / var(--tw-bg-opacity, 1));
}
.bg-primary-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-400) / var(--tw-bg-opacity, 1));
}
.bg-primary-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-50) / var(--tw-bg-opacity, 1));
}
.bg-primary\\/20 {
  background-color: hsl(var(--heroui-primary) / 0.2);
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/70 {
  background-color: rgb(239 68 68 / 0.7);
}
.bg-secondary {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--tw-bg-opacity, 1));
}
.bg-secondary-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-100) / var(--tw-bg-opacity, 1));
}
.bg-secondary-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-400) / var(--tw-bg-opacity, 1));
}
.bg-secondary-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-50) / var(--tw-bg-opacity, 1));
}
.bg-secondary\\/20 {
  background-color: hsl(var(--heroui-secondary) / 0.2);
}
.bg-success {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--tw-bg-opacity, 1));
}
.bg-success-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-100) / var(--tw-bg-opacity, 1));
}
.bg-success-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-400) / var(--tw-bg-opacity, 1));
}
.bg-success-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-50) / var(--tw-bg-opacity, 1));
}
.bg-success\\/20 {
  background-color: hsl(var(--heroui-success) / 0.2);
}
.bg-transparent {
  background-color: transparent;
}
.bg-warning {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--tw-bg-opacity, 1));
}
.bg-warning-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-100) / var(--tw-bg-opacity, 1));
}
.bg-warning-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-400) / var(--tw-bg-opacity, 1));
}
.bg-warning-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-50) / var(--tw-bg-opacity, 1));
}
.bg-warning\\/20 {
  background-color: hsl(var(--heroui-warning) / 0.2);
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 224 71 / var(--tw-bg-opacity, 1));
}
.bg-yellow-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-yellowbuy {
  --tw-bg-opacity: 1;
  background-color: rgb(0 255 127 / var(--tw-bg-opacity, 1));
}
.bg-opacity-25 {
  --tw-bg-opacity: 0.25;
}
.bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-90 {
  --tw-bg-opacity: 0.9;
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-stripe-gradient-danger {
  background-image: linear-gradient(45deg,  hsl(var(--heroui-danger-200)) 25%,  hsl(var(--heroui-danger)) 25%,  hsl(var(--heroui-danger)) 50%,  hsl(var(--heroui-danger-200)) 50%,  hsl(var(--heroui-danger-200)) 75%,  hsl(var(--heroui-danger)) 75%,  hsl(var(--heroui-danger)));
}
.bg-stripe-gradient-default {
  background-image: linear-gradient(45deg,  hsl(var(--heroui-default-200)) 25%,  hsl(var(--heroui-default-400)) 25%,  hsl(var(--heroui-default-400)) 50%,  hsl(var(--heroui-default-200)) 50%,  hsl(var(--heroui-default-200)) 75%,  hsl(var(--heroui-default-400)) 75%,  hsl(var(--heroui-default-400)));
}
.bg-stripe-gradient-primary {
  background-image: linear-gradient(45deg,  hsl(var(--heroui-primary-200)) 25%,  hsl(var(--heroui-primary)) 25%,  hsl(var(--heroui-primary)) 50%,  hsl(var(--heroui-primary-200)) 50%,  hsl(var(--heroui-primary-200)) 75%,  hsl(var(--heroui-primary)) 75%,  hsl(var(--heroui-primary)));
}
.bg-stripe-gradient-secondary {
  background-image: linear-gradient(45deg,  hsl(var(--heroui-secondary-200)) 25%,  hsl(var(--heroui-secondary)) 25%,  hsl(var(--heroui-secondary)) 50%,  hsl(var(--heroui-secondary-200)) 50%,  hsl(var(--heroui-secondary-200)) 75%,  hsl(var(--heroui-secondary)) 75%,  hsl(var(--heroui-secondary)));
}
.bg-stripe-gradient-success {
  background-image: linear-gradient(45deg,  hsl(var(--heroui-success-200)) 25%,  hsl(var(--heroui-success)) 25%,  hsl(var(--heroui-success)) 50%,  hsl(var(--heroui-success-200)) 50%,  hsl(var(--heroui-success-200)) 75%,  hsl(var(--heroui-success)) 75%,  hsl(var(--heroui-success)));
}
.bg-stripe-gradient-warning {
  background-image: linear-gradient(45deg,  hsl(var(--heroui-warning-200)) 25%,  hsl(var(--heroui-warning)) 25%,  hsl(var(--heroui-warning)) 50%,  hsl(var(--heroui-warning-200)) 50%,  hsl(var(--heroui-warning-200)) 75%,  hsl(var(--heroui-warning)) 75%,  hsl(var(--heroui-warning)));
}
.from-\\[\\#343008\\] {
  --tw-gradient-from: #343008 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(52 48 8 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-50 {
  --tw-gradient-from: #f9fafb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 250 251 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent {
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-transparent {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-black\\/60 {
  --tw-gradient-to: rgb(0 0 0 / 0.6) var(--tw-gradient-to-position);
}
.to-current {
  --tw-gradient-to: currentColor var(--tw-gradient-to-position);
}
.to-danger {
  --tw-gradient-to: hsl(var(--heroui-danger) / 1) var(--tw-gradient-to-position);
}
.to-default {
  --tw-gradient-to: hsl(var(--heroui-default) / 1) var(--tw-gradient-to-position);
}
.to-gray-100 {
  --tw-gradient-to: #f3f4f6 var(--tw-gradient-to-position);
}
.to-primary {
  --tw-gradient-to: hsl(var(--heroui-primary) / 1) var(--tw-gradient-to-position);
}
.to-secondary {
  --tw-gradient-to: hsl(var(--heroui-secondary) / 1) var(--tw-gradient-to-position);
}
.to-success {
  --tw-gradient-to: hsl(var(--heroui-success) / 1) var(--tw-gradient-to-position);
}
.to-warning {
  --tw-gradient-to: hsl(var(--heroui-warning) / 1) var(--tw-gradient-to-position);
}
.to-white {
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.bg-stripe-size {
  background-size: 1.25rem 1.25rem;
}
.bg-clip-text {
  background-clip: text;
}
.fill-current {
  fill: currentColor;
}
.stroke-black {
  stroke: #000;
}
.stroke-current {
  stroke: currentColor;
}
.stroke-default-300\\/50 {
  stroke: hsl(var(--heroui-default-300) / 0.5);
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.\\!px-1 {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[200px\\] {
  padding-top: 200px;
  padding-bottom: 200px;
}
.\\!pb-0 {
  padding-bottom: 0px !important;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-0\\.5 {
  padding-bottom: 0.125rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pe-2 {
  padding-inline-end: 0.5rem;
}
.pe-6 {
  padding-inline-end: 1.5rem;
}
.pl-0\\.5 {
  padding-left: 0.125rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-\\[1px\\] {
  padding-left: 1px;
}
.pl-\\[60px\\] {
  padding-left: 60px;
}
.pr-0\\.5 {
  padding-right: 0.125rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.ps-1 {
  padding-inline-start: 0.25rem;
}
.ps-2 {
  padding-inline-start: 0.5rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.text-end {
  text-align: end;
}
.align-middle {
  vertical-align: middle;
}
.\\!font-sans {
  font-family: "Open Sans", sans-serif !important;
}
.font-albert {
  font-family: "Albert Sans", sans-serif;
}
.font-bruno {
  font-family: "Bruno Ace SC", sans-serif;
}
.font-dm {
  font-family: "DM Sans", sans-serif;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans {
  font-family: "Open Sans", sans-serif;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[0\\.55rem\\] {
  font-size: 0.55rem;
}
.text-\\[0\\.5rem\\] {
  font-size: 0.5rem;
}
.text-\\[0\\.625rem\\] {
  font-size: 0.625rem;
}
.text-\\[0\\.6rem\\] {
  font-size: 0.6rem;
}
.text-\\[1\\.5rem\\] {
  font-size: 1.5rem;
}
.text-\\[1\\.625rem\\] {
  font-size: 1.625rem;
}
.text-\\[100\\%\\] {
  font-size: 100%;
}
.text-\\[1rem\\] {
  font-size: 1rem;
}
.text-\\[390px\\] {
  font-size: 390px;
}
.text-\\[3rem\\] {
  font-size: 3rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-extralight {
  font-weight: 200;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-\\[1\\.15\\] {
  line-height: 1.15;
}
.leading-\\[1\\.5\\] {
  line-height: 1.5;
}
.leading-\\[1\\.6\\] {
  line-height: 1.6;
}
.leading-\\[1\\] {
  line-height: 1;
}
.leading-\\[32px\\] {
  line-height: 32px;
}
.leading-\\[60px\\] {
  line-height: 60px;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.1em\\] {
  letter-spacing: 0.1em;
}
.tracking-\\[0\\.3rem\\] {
  letter-spacing: 0.3rem;
}
.\\!text-danger {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--heroui-danger) / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#0000009C\\] {
  color: #0000009C;
}
.text-\\[\\#000000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0000FF\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#573800\\] {
  --tw-text-opacity: 1;
  color: rgb(87 56 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6A6A6A\\] {
  --tw-text-opacity: 1;
  color: rgb(106 106 106 / var(--tw-text-opacity, 1));
}
.text-\\[\\#717A8C\\] {
  --tw-text-opacity: 1;
  color: rgb(113 122 140 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9747FF\\] {
  --tw-text-opacity: 1;
  color: rgb(151 71 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFFFFF9E\\] {
  color: #FFFFFF9E;
}
.text-\\[\\#FFFFFFB0\\] {
  color: #FFFFFFB0;
}
.text-\\[\\#FFFFFF\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#fff\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-background {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-background) / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-current {
  color: currentColor;
}
.text-danger {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--tw-text-opacity, 1));
}
.text-danger-300 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-300) / var(--tw-text-opacity, 1));
}
.text-danger-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-400) / var(--tw-text-opacity, 1));
}
.text-danger-500 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-500) / var(--tw-text-opacity, 1));
}
.text-danger-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-600) / var(--tw-text-opacity, 1));
}
.text-danger-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--tw-text-opacity, 1));
}
.text-danger\\/80 {
  color: hsl(var(--heroui-danger) / 0.8);
}
.text-default {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default) / var(--tw-text-opacity, 1));
}
.text-default-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-400) / var(--tw-text-opacity, 1));
}
.text-default-500 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-500) / var(--tw-text-opacity, 1));
}
.text-default-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-600) / var(--tw-text-opacity, 1));
}
.text-default-700 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-700) / var(--tw-text-opacity, 1));
}
.text-default-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--tw-text-opacity, 1));
}
.text-dollarColor {
  color: #00FF7099;
}
.text-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground) / var(--tw-text-opacity, 1));
}
.text-foreground-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-400) / var(--tw-text-opacity, 1));
}
.text-foreground-500 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-500) / var(--tw-text-opacity, 1));
}
.text-foreground-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-600) / var(--tw-text-opacity, 1));
}
.text-foreground\\/50 {
  color: hsl(var(--heroui-foreground) / 0.5);
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-inherit {
  color: inherit;
}
.text-neutral-500 {
  --tw-text-opacity: 1;
  color: rgb(115 115 115 / var(--tw-text-opacity, 1));
}
.text-neutral-600 {
  --tw-text-opacity: 1;
  color: rgb(82 82 82 / var(--tw-text-opacity, 1));
}
.text-primary {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--tw-text-opacity, 1));
}
.text-primary-300 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-300) / var(--tw-text-opacity, 1));
}
.text-primary-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-400) / var(--tw-text-opacity, 1));
}
.text-primary-500 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-500) / var(--tw-text-opacity, 1));
}
.text-primary-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-600) / var(--tw-text-opacity, 1));
}
.text-primary-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--tw-text-opacity, 1));
}
.text-primary\\/80 {
  color: hsl(var(--heroui-primary) / 0.8);
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-secondary {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--tw-text-opacity, 1));
}
.text-secondary-300 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-300) / var(--tw-text-opacity, 1));
}
.text-secondary-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-400) / var(--tw-text-opacity, 1));
}
.text-secondary-500 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-500) / var(--tw-text-opacity, 1));
}
.text-secondary-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-600) / var(--tw-text-opacity, 1));
}
.text-secondary-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--tw-text-opacity, 1));
}
.text-secondary\\/80 {
  color: hsl(var(--heroui-secondary) / 0.8);
}
.text-success {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success) / var(--tw-text-opacity, 1));
}
.text-success-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-400) / var(--tw-text-opacity, 1));
}
.text-success-500 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-500) / var(--tw-text-opacity, 1));
}
.text-success-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-600) / var(--tw-text-opacity, 1));
}
.text-success-700 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-700) / var(--tw-text-opacity, 1));
}
.text-success-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--tw-text-opacity, 1));
}
.text-success\\/80 {
  color: hsl(var(--heroui-success) / 0.8);
}
.text-transparent {
  color: transparent;
}
.text-warning {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning) / var(--tw-text-opacity, 1));
}
.text-warning-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-400) / var(--tw-text-opacity, 1));
}
.text-warning-500 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-500) / var(--tw-text-opacity, 1));
}
.text-warning-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-600) / var(--tw-text-opacity, 1));
}
.text-warning-700 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-700) / var(--tw-text-opacity, 1));
}
.text-warning-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--tw-text-opacity, 1));
}
.text-warning\\/80 {
  color: hsl(var(--heroui-warning) / 0.8);
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.text-yellowbuy {
  --tw-text-opacity: 1;
  color: rgb(0 255 127 / var(--tw-text-opacity, 1));
}
.text-zinc-500 {
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.no-underline {
  text-decoration-line: none;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.subpixel-antialiased {
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
}
.placeholder-\\[\\#6A6A6A\\]::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(106 106 106 / var(--tw-placeholder-opacity, 1));
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-\\[0\\.0001\\] {
  opacity: 0.0001;
}
.opacity-\\[value\\] {
  opacity: value;
}
.opacity-disabled {
  opacity: var(--heroui-disabled-opacity);
}
.\\!shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_0px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\] {
  --tw-shadow: 0 1px 0px 0 rgba(0,0,0,0.05);
  --tw-shadow-colored: 0 1px 0px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_20px_20px_0px_rgb\\(0_0_0\\/0\\.05\\)\\] {
  --tw-shadow: 0px 20px 20px 0px rgb(0 0 0/0.05);
  --tw-shadow-colored: 0px 20px 20px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-large {
  --tw-shadow: var(--heroui-box-shadow-large);
  --tw-shadow-colored: var(--heroui-box-shadow-large);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-medium {
  --tw-shadow: var(--heroui-box-shadow-medium);
  --tw-shadow-colored: var(--heroui-box-shadow-medium);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-small {
  --tw-shadow: var(--heroui-box-shadow-small);
  --tw-shadow-colored: var(--heroui-box-shadow-small);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-black\\/5 {
  --tw-shadow-color: rgb(0 0 0 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-danger\\/40 {
  --tw-shadow-color: hsl(var(--heroui-danger) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-default\\/50 {
  --tw-shadow-color: hsl(var(--heroui-default) / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-foreground\\/40 {
  --tw-shadow-color: hsl(var(--heroui-foreground) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary\\/40 {
  --tw-shadow-color: hsl(var(--heroui-primary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-secondary\\/40 {
  --tw-shadow-color: hsl(var(--heroui-secondary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-success\\/40 {
  --tw-shadow-color: hsl(var(--heroui-success) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-warning\\/40 {
  --tw-shadow-color: hsl(var(--heroui-warning) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline-transparent {
  outline-color: transparent;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-\\[\\#cbb702\\] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(203 183 2 / var(--tw-ring-opacity, 1));
}
.ring-background {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-background) / var(--tw-ring-opacity, 1));
}
.ring-danger {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-danger) / var(--tw-ring-opacity, 1));
}
.ring-default {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-default) / var(--tw-ring-opacity, 1));
}
.ring-focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-focus) / var(--tw-ring-opacity, 1));
}
.ring-indigo-700\\/10 {
  --tw-ring-color: rgb(67 56 202 / 0.1);
}
.ring-primary {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-primary) / var(--tw-ring-opacity, 1));
}
.ring-secondary {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-secondary) / var(--tw-ring-opacity, 1));
}
.ring-success {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-success) / var(--tw-ring-opacity, 1));
}
.ring-transparent {
  --tw-ring-color: transparent;
}
.ring-warning {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-warning) / var(--tw-ring-opacity, 1));
}
.ring-yellow-600\\/20 {
  --tw-ring-color: rgb(202 138 4 / 0.2);
}
.ring-offset-0 {
  --tw-ring-offset-width: 0px;
}
.ring-offset-2 {
  --tw-ring-offset-width: 2px;
}
.ring-offset-background {
  --tw-ring-offset-color: hsl(var(--heroui-background) / 1);
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-lg {
  --tw-blur: blur(16px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-md {
  --tw-blur: blur(12px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.saturate-150 {
  --tw-saturate: saturate(1.5);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-lg {
  --tw-backdrop-blur: blur(16px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-opacity-disabled {
  --tw-backdrop-opacity: opacity(var(--heroui-disabled-opacity));
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-saturate-150 {
  --tw-backdrop-saturate: saturate(1.5);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.\\!transition-none {
  transition-property: none !important;
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[color\\2c opacity\\] {
  transition-property: color,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[opacity\\2c transform\\] {
  transition-property: opacity,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c background-color\\2c color\\] {
  transition-property: transform,background-color,color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c color\\2c left\\2c opacity\\2c translate\\2c scale\\] {
  transition-property: transform,color,left,opacity,translate,scale;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-none {
  transition-property: none;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.\\!duration-100 {
  transition-duration: 100ms !important;
}
.\\!duration-150 {
  transition-duration: 150ms !important;
}
.\\!duration-200 {
  transition-duration: 200ms !important;
}
.\\!duration-250 {
  transition-duration: 250ms !important;
}
.\\!duration-300 {
  transition-duration: 300ms !important;
}
.\\!duration-500 {
  transition-duration: 500ms !important;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.\\!ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
}
.\\!ease-soft-spring {
  transition-timing-function: cubic-bezier(0.155, 1.105, 0.295, 1.12) !important;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.will-change-\\[transform\\2c width\\2c height\\] {
  will-change: transform,width,height;
}
.will-change-auto {
  will-change: auto;
}
.will-change-transform {
  will-change: transform;
}
.light {
  color-scheme: light;
  --heroui-background: 0 0% 100%;
  --heroui-foreground-50: 0 0% 98.04%;
  --heroui-foreground-100: 240 4.76% 95.88%;
  --heroui-foreground-200: 240 5.88% 90%;
  --heroui-foreground-300: 240 4.88% 83.92%;
  --heroui-foreground-400: 240 5.03% 64.9%;
  --heroui-foreground-500: 240 3.83% 46.08%;
  --heroui-foreground-600: 240 5.2% 33.92%;
  --heroui-foreground-700: 240 5.26% 26.08%;
  --heroui-foreground-800: 240 3.7% 15.88%;
  --heroui-foreground-900: 240 5.88% 10%;
  --heroui-foreground: 201.81999999999994 24.44% 8.82%;
  --heroui-divider: 0 0% 6.67%;
  --heroui-focus: 212.01999999999998 100% 46.67%;
  --heroui-overlay: 0 0% 0%;
  --heroui-content1: 0 0% 100%;
  --heroui-content1-foreground: 201.81999999999994 24.44% 8.82%;
  --heroui-content2: 240 4.76% 95.88%;
  --heroui-content2-foreground: 240 3.7% 15.88%;
  --heroui-content3: 240 5.88% 90%;
  --heroui-content3-foreground: 240 5.26% 26.08%;
  --heroui-content4: 240 4.88% 83.92%;
  --heroui-content4-foreground: 240 5.2% 33.92%;
  --heroui-default-50: 0 0% 98.04%;
  --heroui-default-100: 240 4.76% 95.88%;
  --heroui-default-200: 240 5.88% 90%;
  --heroui-default-300: 240 4.88% 83.92%;
  --heroui-default-400: 240 5.03% 64.9%;
  --heroui-default-500: 240 3.83% 46.08%;
  --heroui-default-600: 240 5.2% 33.92%;
  --heroui-default-700: 240 5.26% 26.08%;
  --heroui-default-800: 240 3.7% 15.88%;
  --heroui-default-900: 240 5.88% 10%;
  --heroui-default-foreground: 0 0% 0%;
  --heroui-default: 240 4.88% 83.92%;
  --heroui-primary-50: 212.5 92.31% 94.9%;
  --heroui-primary-100: 211.84000000000003 92.45% 89.61%;
  --heroui-primary-200: 211.84000000000003 92.45% 79.22%;
  --heroui-primary-300: 212.24 92.45% 68.82%;
  --heroui-primary-400: 212.14 92.45% 58.43%;
  --heroui-primary-500: 212.01999999999998 100% 46.67%;
  --heroui-primary-600: 212.14 100% 38.43%;
  --heroui-primary-700: 212.24 100% 28.82%;
  --heroui-primary-800: 211.84000000000003 100% 19.22%;
  --heroui-primary-900: 211.84000000000003 100% 9.61%;
  --heroui-primary-foreground: 0 0% 100%;
  --heroui-primary: 212.01999999999998 100% 46.67%;
  --heroui-secondary-50: 270 61.54% 94.9%;
  --heroui-secondary-100: 270 59.26% 89.41%;
  --heroui-secondary-200: 270 59.26% 78.82%;
  --heroui-secondary-300: 270 59.26% 68.24%;
  --heroui-secondary-400: 270 59.26% 57.65%;
  --heroui-secondary-500: 270 66.67% 47.06%;
  --heroui-secondary-600: 270 66.67% 37.65%;
  --heroui-secondary-700: 270 66.67% 28.24%;
  --heroui-secondary-800: 270 66.67% 18.82%;
  --heroui-secondary-900: 270 66.67% 9.41%;
  --heroui-secondary-foreground: 0 0% 100%;
  --heroui-secondary: 270 66.67% 47.06%;
  --heroui-success-50: 146.66999999999996 64.29% 94.51%;
  --heroui-success-100: 145.71000000000004 61.4% 88.82%;
  --heroui-success-200: 146.2 61.74% 77.45%;
  --heroui-success-300: 145.78999999999996 62.57% 66.47%;
  --heroui-success-400: 146.01 62.45% 55.1%;
  --heroui-success-500: 145.96000000000004 79.46% 43.92%;
  --heroui-success-600: 146.01 79.89% 35.1%;
  --heroui-success-700: 145.78999999999996 79.26% 26.47%;
  --heroui-success-800: 146.2 79.78% 17.45%;
  --heroui-success-900: 145.71000000000004 77.78% 8.82%;
  --heroui-success-foreground: 0 0% 0%;
  --heroui-success: 145.96000000000004 79.46% 43.92%;
  --heroui-warning-50: 54.55000000000001 91.67% 95.29%;
  --heroui-warning-100: 37.139999999999986 91.3% 90.98%;
  --heroui-warning-200: 37.139999999999986 91.3% 81.96%;
  --heroui-warning-300: 36.95999999999998 91.24% 73.14%;
  --heroui-warning-400: 37.00999999999999 91.26% 64.12%;
  --heroui-warning-500: 37.02999999999997 91.27% 55.1%;
  --heroui-warning-600: 37.00999999999999 74.22% 44.12%;
  --heroui-warning-700: 36.95999999999998 73.96% 33.14%;
  --heroui-warning-800: 37.139999999999986 75% 21.96%;
  --heroui-warning-900: 37.139999999999986 75% 10.98%;
  --heroui-warning-foreground: 0 0% 0%;
  --heroui-warning: 37.02999999999997 91.27% 55.1%;
  --heroui-danger-50: 339.13 92% 95.1%;
  --heroui-danger-100: 340 91.84% 90.39%;
  --heroui-danger-200: 339.3299999999999 90% 80.39%;
  --heroui-danger-300: 339.11 90.6% 70.78%;
  --heroui-danger-400: 339 90% 60.78%;
  --heroui-danger-500: 339.20000000000005 90.36% 51.18%;
  --heroui-danger-600: 339 86.54% 40.78%;
  --heroui-danger-700: 339.11 85.99% 30.78%;
  --heroui-danger-800: 339.3299999999999 86.54% 20.39%;
  --heroui-danger-900: 340 84.91% 10.39%;
  --heroui-danger-foreground: 0 0% 100%;
  --heroui-danger: 339.20000000000005 90.36% 51.18%;
  --heroui-divider-weight: 1px;
  --heroui-disabled-opacity: .5;
  --heroui-font-size-tiny: 0.75rem;
  --heroui-font-size-small: 0.875rem;
  --heroui-font-size-medium: 1rem;
  --heroui-font-size-large: 1.125rem;
  --heroui-line-height-tiny: 1rem;
  --heroui-line-height-small: 1.25rem;
  --heroui-line-height-medium: 1.5rem;
  --heroui-line-height-large: 1.75rem;
  --heroui-radius-small: 8px;
  --heroui-radius-medium: 12px;
  --heroui-radius-large: 14px;
  --heroui-border-width-small: 1px;
  --heroui-border-width-medium: 2px;
  --heroui-border-width-large: 3px;
  --heroui-box-shadow-small: 0px 0px 5px 0px rgb(0 0 0 / 0.02), 0px 2px 10px 0px rgb(0 0 0 / 0.06), 0px 0px 1px 0px rgb(0 0 0 / 0.3);
  --heroui-box-shadow-medium: 0px 0px 15px 0px rgb(0 0 0 / 0.03), 0px 2px 30px 0px rgb(0 0 0 / 0.08), 0px 0px 1px 0px rgb(0 0 0 / 0.3);
  --heroui-box-shadow-large: 0px 0px 30px 0px rgb(0 0 0 / 0.04), 0px 30px 60px 0px rgb(0 0 0 / 0.12), 0px 0px 1px 0px rgb(0 0 0 / 0.3);
  --heroui-hover-opacity: .8;
}
.dark {
  color-scheme: dark;
  --heroui-background: 0 0% 0%;
  --heroui-foreground-50: 240 5.88% 10%;
  --heroui-foreground-100: 240 3.7% 15.88%;
  --heroui-foreground-200: 240 5.26% 26.08%;
  --heroui-foreground-300: 240 5.2% 33.92%;
  --heroui-foreground-400: 240 3.83% 46.08%;
  --heroui-foreground-500: 240 5.03% 64.9%;
  --heroui-foreground-600: 240 4.88% 83.92%;
  --heroui-foreground-700: 240 5.88% 90%;
  --heroui-foreground-800: 240 4.76% 95.88%;
  --heroui-foreground-900: 0 0% 98.04%;
  --heroui-foreground: 210 5.56% 92.94%;
  --heroui-focus: 212.01999999999998 100% 46.67%;
  --heroui-overlay: 0 0% 0%;
  --heroui-divider: 0 0% 100%;
  --heroui-content1: 240 5.88% 10%;
  --heroui-content1-foreground: 0 0% 98.04%;
  --heroui-content2: 240 3.7% 15.88%;
  --heroui-content2-foreground: 240 4.76% 95.88%;
  --heroui-content3: 240 5.26% 26.08%;
  --heroui-content3-foreground: 240 5.88% 90%;
  --heroui-content4: 240 5.2% 33.92%;
  --heroui-content4-foreground: 240 4.88% 83.92%;
  --heroui-default-50: 240 5.88% 10%;
  --heroui-default-100: 240 3.7% 15.88%;
  --heroui-default-200: 240 5.26% 26.08%;
  --heroui-default-300: 240 5.2% 33.92%;
  --heroui-default-400: 240 3.83% 46.08%;
  --heroui-default-500: 240 5.03% 64.9%;
  --heroui-default-600: 240 4.88% 83.92%;
  --heroui-default-700: 240 5.88% 90%;
  --heroui-default-800: 240 4.76% 95.88%;
  --heroui-default-900: 0 0% 98.04%;
  --heroui-default-foreground: 0 0% 100%;
  --heroui-default: 240 5.26% 26.08%;
  --heroui-primary-50: 211.84000000000003 100% 9.61%;
  --heroui-primary-100: 211.84000000000003 100% 19.22%;
  --heroui-primary-200: 212.24 100% 28.82%;
  --heroui-primary-300: 212.14 100% 38.43%;
  --heroui-primary-400: 212.01999999999998 100% 46.67%;
  --heroui-primary-500: 212.14 92.45% 58.43%;
  --heroui-primary-600: 212.24 92.45% 68.82%;
  --heroui-primary-700: 211.84000000000003 92.45% 79.22%;
  --heroui-primary-800: 211.84000000000003 92.45% 89.61%;
  --heroui-primary-900: 212.5 92.31% 94.9%;
  --heroui-primary-foreground: 0 0% 100%;
  --heroui-primary: 212.01999999999998 100% 46.67%;
  --heroui-secondary-50: 270 66.67% 9.41%;
  --heroui-secondary-100: 270 66.67% 18.82%;
  --heroui-secondary-200: 270 66.67% 28.24%;
  --heroui-secondary-300: 270 66.67% 37.65%;
  --heroui-secondary-400: 270 66.67% 47.06%;
  --heroui-secondary-500: 270 59.26% 57.65%;
  --heroui-secondary-600: 270 59.26% 68.24%;
  --heroui-secondary-700: 270 59.26% 78.82%;
  --heroui-secondary-800: 270 59.26% 89.41%;
  --heroui-secondary-900: 270 61.54% 94.9%;
  --heroui-secondary-foreground: 0 0% 100%;
  --heroui-secondary: 270 59.26% 57.65%;
  --heroui-success-50: 145.71000000000004 77.78% 8.82%;
  --heroui-success-100: 146.2 79.78% 17.45%;
  --heroui-success-200: 145.78999999999996 79.26% 26.47%;
  --heroui-success-300: 146.01 79.89% 35.1%;
  --heroui-success-400: 145.96000000000004 79.46% 43.92%;
  --heroui-success-500: 146.01 62.45% 55.1%;
  --heroui-success-600: 145.78999999999996 62.57% 66.47%;
  --heroui-success-700: 146.2 61.74% 77.45%;
  --heroui-success-800: 145.71000000000004 61.4% 88.82%;
  --heroui-success-900: 146.66999999999996 64.29% 94.51%;
  --heroui-success-foreground: 0 0% 0%;
  --heroui-success: 145.96000000000004 79.46% 43.92%;
  --heroui-warning-50: 37.139999999999986 75% 10.98%;
  --heroui-warning-100: 37.139999999999986 75% 21.96%;
  --heroui-warning-200: 36.95999999999998 73.96% 33.14%;
  --heroui-warning-300: 37.00999999999999 74.22% 44.12%;
  --heroui-warning-400: 37.02999999999997 91.27% 55.1%;
  --heroui-warning-500: 37.00999999999999 91.26% 64.12%;
  --heroui-warning-600: 36.95999999999998 91.24% 73.14%;
  --heroui-warning-700: 37.139999999999986 91.3% 81.96%;
  --heroui-warning-800: 37.139999999999986 91.3% 90.98%;
  --heroui-warning-900: 54.55000000000001 91.67% 95.29%;
  --heroui-warning-foreground: 0 0% 0%;
  --heroui-warning: 37.02999999999997 91.27% 55.1%;
  --heroui-danger-50: 340 84.91% 10.39%;
  --heroui-danger-100: 339.3299999999999 86.54% 20.39%;
  --heroui-danger-200: 339.11 85.99% 30.78%;
  --heroui-danger-300: 339 86.54% 40.78%;
  --heroui-danger-400: 339.20000000000005 90.36% 51.18%;
  --heroui-danger-500: 339 90% 60.78%;
  --heroui-danger-600: 339.11 90.6% 70.78%;
  --heroui-danger-700: 339.3299999999999 90% 80.39%;
  --heroui-danger-800: 340 91.84% 90.39%;
  --heroui-danger-900: 339.13 92% 95.1%;
  --heroui-danger-foreground: 0 0% 100%;
  --heroui-danger: 339.20000000000005 90.36% 51.18%;
  --heroui-divider-weight: 1px;
  --heroui-disabled-opacity: .5;
  --heroui-font-size-tiny: 0.75rem;
  --heroui-font-size-small: 0.875rem;
  --heroui-font-size-medium: 1rem;
  --heroui-font-size-large: 1.125rem;
  --heroui-line-height-tiny: 1rem;
  --heroui-line-height-small: 1.25rem;
  --heroui-line-height-medium: 1.5rem;
  --heroui-line-height-large: 1.75rem;
  --heroui-radius-small: 8px;
  --heroui-radius-medium: 12px;
  --heroui-radius-large: 14px;
  --heroui-border-width-small: 1px;
  --heroui-border-width-medium: 2px;
  --heroui-border-width-large: 3px;
  --heroui-box-shadow-small: 0px 0px 5px 0px rgb(0 0 0 / 0.05), 0px 2px 10px 0px rgb(0 0 0 / 0.2), inset 0px 0px 1px 0px rgb(255 255 255 / 0.15);
  --heroui-box-shadow-medium: 0px 0px 15px 0px rgb(0 0 0 / 0.06), 0px 2px 30px 0px rgb(0 0 0 / 0.22), inset 0px 0px 1px 0px rgb(255 255 255 / 0.15);
  --heroui-box-shadow-large: 0px 0px 30px 0px rgb(0 0 0 / 0.07), 0px 30px 60px 0px rgb(0 0 0 / 0.26), inset 0px 0px 1px 0px rgb(255 255 255 / 0.15);
  --heroui-hover-opacity: .9;
}
.leading-inherit {
  line-height: inherit;
}
.bg-img-inherit {
  background-image: inherit;
}
.bg-clip-inherit {
  background-clip: inherit;
}
.text-fill-inherit {
  -webkit-text-fill-color: inherit;
}
.tap-highlight-transparent {
  -webkit-tap-highlight-color: transparent;
}
.input-search-cancel-button-none::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
.transition-background {
  transition-property: background;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-colors-opacity {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-width {
  transition-property: width;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-height {
  transition-property: height;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-size {
  transition-property: width, height;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-left {
  transition-property: left;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-transform-opacity {
  transition-property: transform, scale, opacity rotate;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-transform-background {
  transition-property: transform, scale, background;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-transform-colors {
  transition-property: transform, scale, color, background, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.transition-transform-colors-opacity {
  transition-property: transform, scale, color, background, background-color, border-color, text-decoration-color, fill, stroke, opacity;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
.scrollbar-default {
  -ms-overflow-style: auto;
  scrollbar-width: auto;
}
.scrollbar-default::-webkit-scrollbar {
  display: block;
}
.text-tiny {
  font-size: var(--heroui-font-size-tiny);
  line-height: var(--heroui-line-height-tiny);
}
.text-small {
  font-size: var(--heroui-font-size-small);
  line-height: var(--heroui-line-height-small);
}
.text-medium {
  font-size: var(--heroui-font-size-medium);
  line-height: var(--heroui-line-height-medium);
}
.text-large {
  font-size: var(--heroui-font-size-large);
  line-height: var(--heroui-line-height-large);
}
.spinner-bar-animation {
  animation: fade-out 1.2s linear infinite;
  animation-delay: calc(-1.2s + (0.1s * var(--bar-index)));
  transform: rotate(calc(30deg * var(--bar-index))) translate(140%);
}
.spinner-dot-animation {
  animation-delay: calc(250ms * var(--dot-index));
}
.spinner-dot-blink-animation {
  animation-delay: calc(200ms * var(--dot-index));
}
.\\[--picker-height\\:224px\\] {
  --picker-height: 224px;
}
.\\[--scale-enter\\:100\\%\\] {
  --scale-enter: 100%;
}
.\\[--scale-exit\\:100\\%\\] {
  --scale-exit: 100%;
}
.\\[--scroll-shadow-size\\:100px\\] {
  --scroll-shadow-size: 100px;
}
.\\[--slide-enter\\:0px\\] {
  --slide-enter: 0px;
}
.\\[--slide-exit\\:80px\\] {
  --slide-exit: 80px;
}
.\\[-webkit-mask\\:radial-gradient\\(closest-side\\2c rgba\\(0\\2c 0\\2c 0\\2c 0\\.0\\)calc\\(100\\%-3px\\)\\2c rgba\\(0\\2c 0\\2c 0\\2c 1\\)calc\\(100\\%-3px\\)\\)\\] {
  -webkit-mask: radial-gradient(closest-side,rgba(0,0,0,0.0)calc(100% - 3px),rgba(0,0,0,1)calc(100% - 3px));
}
.\\[animation-duration\\:1s\\] {
  animation-duration: 1s;
}
.\\[mask-image\\:linear-gradient\\(\\#000\\2c \\#000\\2c transparent_0\\2c \\#000_var\\(--scroll-shadow-size\\)\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\] {
  mask-image: linear-gradient(#000,#000,transparent 0,#000 var(--scroll-shadow-size),#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.\\[transform-origin\\:var\\(--trigger-anchor-point\\)\\] {
  transform-origin: var(--trigger-anchor-point);
}
.file\\:cursor-pointer::file-selector-button {
  cursor: pointer;
}
.file\\:border-0::file-selector-button {
  border-width: 0px;
}
.file\\:bg-transparent::file-selector-button {
  background-color: transparent;
}
.placeholder\\:text-danger::placeholder {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--tw-text-opacity, 1));
}
.placeholder\\:text-foreground-500::placeholder {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-500) / var(--tw-text-opacity, 1));
}
.placeholder\\:text-primary::placeholder {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--tw-text-opacity, 1));
}
.placeholder\\:text-secondary::placeholder {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--tw-text-opacity, 1));
}
.placeholder\\:text-success-600::placeholder {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-600) / var(--tw-text-opacity, 1));
}
.placeholder\\:text-warning-600::placeholder {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-600) / var(--tw-text-opacity, 1));
}
.before\\:pointer-events-none::before {
  content: var(--tw-content);
  pointer-events: none;
}
.before\\:pointer-events-auto::before {
  content: var(--tw-content);
  pointer-events: auto;
}
.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}
.before\\:inset-0::before {
  content: var(--tw-content);
  inset: 0px;
}
.before\\:left-0::before {
  content: var(--tw-content);
  left: 0px;
}
.before\\:right-0::before {
  content: var(--tw-content);
  right: 0px;
}
.before\\:z-0::before {
  content: var(--tw-content);
  z-index: 0;
}
.before\\:z-\\[-1\\]::before {
  content: var(--tw-content);
  z-index: -1;
}
.before\\:box-border::before {
  content: var(--tw-content);
  box-sizing: border-box;
}
.before\\:block::before {
  content: var(--tw-content);
  display: block;
}
.before\\:hidden::before {
  content: var(--tw-content);
  display: none;
}
.before\\:h-0\\.5::before {
  content: var(--tw-content);
  height: 0.125rem;
}
.before\\:h-11::before {
  content: var(--tw-content);
  height: 2.75rem;
}
.before\\:h-2\\.5::before {
  content: var(--tw-content);
  height: 0.625rem;
}
.before\\:h-4::before {
  content: var(--tw-content);
  height: 1rem;
}
.before\\:h-6::before {
  content: var(--tw-content);
  height: 1.5rem;
}
.before\\:h-8::before {
  content: var(--tw-content);
  height: 2rem;
}
.before\\:h-px::before {
  content: var(--tw-content);
  height: 1px;
}
.before\\:w-0::before {
  content: var(--tw-content);
  width: 0px;
}
.before\\:w-11::before {
  content: var(--tw-content);
  width: 2.75rem;
}
.before\\:w-2\\.5::before {
  content: var(--tw-content);
  width: 0.625rem;
}
.before\\:w-6::before {
  content: var(--tw-content);
  width: 1.5rem;
}
.before\\:w-8::before {
  content: var(--tw-content);
  width: 2rem;
}
.before\\:-translate-x-full::before {
  content: var(--tw-content);
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:-translate-y-1::before {
  content: var(--tw-content);
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:rotate-0::before {
  content: var(--tw-content);
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:rotate-45::before {
  content: var(--tw-content);
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:animate-none::before {
  content: var(--tw-content);
  animation: none;
}
@keyframes shimmer {

  100% {
    content: var(--tw-content);
    transform: translateX(200%);
  }
}
.before\\:animate-shimmer::before {
  content: var(--tw-content);
  animation: shimmer 2s infinite;
}
.before\\:rounded-\\[calc\\(var\\(--heroui-radius-medium\\)\\*0\\.5\\)\\]::before {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-medium) * 0.5);
}
.before\\:rounded-\\[calc\\(var\\(--heroui-radius-medium\\)\\*0\\.6\\)\\]::before {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-medium) * 0.6);
}
.before\\:rounded-\\[calc\\(var\\(--heroui-radius-medium\\)\\*0\\.7\\)\\]::before {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-medium) * 0.7);
}
.before\\:rounded-full::before {
  content: var(--tw-content);
  border-radius: 9999px;
}
.before\\:rounded-none::before {
  content: var(--tw-content);
  border-radius: 0px;
}
.before\\:rounded-sm::before {
  content: var(--tw-content);
  border-radius: 0.125rem;
}
.before\\:border-2::before {
  content: var(--tw-content);
  border-width: 2px;
}
.before\\:border-t::before {
  content: var(--tw-content);
  border-top-width: 1px;
}
.before\\:border-solid::before {
  content: var(--tw-content);
  border-style: solid;
}
.before\\:border-content4\\/30::before {
  content: var(--tw-content);
  border-color: hsl(var(--heroui-content4) / 0.3);
}
.before\\:border-danger::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.before\\:border-default::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default) / var(--tw-border-opacity, 1));
}
.before\\:bg-content1::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-content1) / var(--tw-bg-opacity, 1));
}
.before\\:bg-current::before {
  content: var(--tw-content);
  background-color: currentColor;
}
.before\\:bg-danger::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1));
}
.before\\:bg-danger\\/20::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-danger) / 0.2);
}
.before\\:bg-default-200::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-200) / var(--tw-bg-opacity, 1));
}
.before\\:bg-default\\/60::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-default) / 0.6);
}
.before\\:bg-foreground::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--tw-bg-opacity, 1));
}
.before\\:bg-primary::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--tw-bg-opacity, 1));
}
.before\\:bg-primary\\/20::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-primary) / 0.2);
}
.before\\:bg-secondary::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--tw-bg-opacity, 1));
}
.before\\:bg-secondary\\/20::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-secondary) / 0.2);
}
.before\\:bg-success::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--tw-bg-opacity, 1));
}
.before\\:bg-success\\/20::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-success) / 0.2);
}
.before\\:bg-transparent::before {
  content: var(--tw-content);
  background-color: transparent;
}
.before\\:bg-warning::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--tw-bg-opacity, 1));
}
.before\\:bg-warning\\/20::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-warning) / 0.2);
}
.before\\:bg-gradient-to-r::before {
  content: var(--tw-content);
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.before\\:from-transparent::before {
  content: var(--tw-content);
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.before\\:via-content4::before {
  content: var(--tw-content);
  --tw-gradient-to: hsl(var(--heroui-content4) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--heroui-content4) / 1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.before\\:to-transparent::before {
  content: var(--tw-content);
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.before\\:opacity-0::before {
  content: var(--tw-content);
  opacity: 0;
}
.before\\:opacity-100::before {
  content: var(--tw-content);
  opacity: 1;
}
.before\\:shadow-small::before {
  content: var(--tw-content);
  --tw-shadow: var(--heroui-box-shadow-small);
  --tw-shadow-colored: var(--heroui-box-shadow-small);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.before\\:transition-colors::before {
  content: var(--tw-content);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.before\\:transition-none::before {
  content: var(--tw-content);
  transition-property: none;
}
.before\\:transition-transform::before {
  content: var(--tw-content);
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.before\\:duration-150::before {
  content: var(--tw-content);
  transition-duration: 150ms;
}
.before\\:content-\\[\\'\\'\\]::before {
  --tw-content: '';
  content: var(--tw-content);
}
.before\\:transition-width::before {
  content: var(--tw-content);
  transition-property: width;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.after\\:pointer-events-auto::after {
  content: var(--tw-content);
  pointer-events: auto;
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-0::after {
  content: var(--tw-content);
  inset: 0px;
}
.after\\:-bottom-1::after {
  content: var(--tw-content);
  bottom: -0.25rem;
}
.after\\:-bottom-\\[2px\\]::after {
  content: var(--tw-content);
  bottom: -2px;
}
.after\\:-bottom-\\[7rem\\]::after {
  content: var(--tw-content);
  bottom: -7rem;
}
.after\\:bottom-0::after {
  content: var(--tw-content);
  bottom: 0px;
}
.after\\:left-0::after {
  content: var(--tw-content);
  left: 0px;
}
.after\\:left-1\\/2::after {
  content: var(--tw-content);
  left: 50%;
}
.after\\:left-4::after {
  content: var(--tw-content);
  left: 1rem;
}
.after\\:right-0::after {
  content: var(--tw-content);
  right: 0px;
}
.after\\:top-0::after {
  content: var(--tw-content);
  top: 0px;
}
.after\\:-z-10::after {
  content: var(--tw-content);
  z-index: -10;
}
.after\\:z-0::after {
  content: var(--tw-content);
  z-index: 0;
}
.after\\:z-\\[-1\\]::after {
  content: var(--tw-content);
  z-index: -1;
}
.after\\:ml-0\\.5::after {
  content: var(--tw-content);
  margin-left: 0.125rem;
}
.after\\:ms-0\\.5::after {
  content: var(--tw-content);
  margin-inline-start: 0.125rem;
}
.after\\:block::after {
  content: var(--tw-content);
  display: block;
}
.after\\:inline-block::after {
  content: var(--tw-content);
  display: inline-block;
}
.after\\:table-row::after {
  content: var(--tw-content);
  display: table-row;
}
.after\\:h-0::after {
  content: var(--tw-content);
  height: 0px;
}
.after\\:h-4::after {
  content: var(--tw-content);
  height: 1rem;
}
.after\\:h-5::after {
  content: var(--tw-content);
  height: 1.25rem;
}
.after\\:h-\\[2px\\]::after {
  content: var(--tw-content);
  height: 2px;
}
.after\\:h-\\[5px\\]::after {
  content: var(--tw-content);
  height: 5px;
}
.after\\:h-\\[9rem\\]::after {
  content: var(--tw-content);
  height: 9rem;
}
.after\\:h-divider::after {
  content: var(--tw-content);
  height: var(--heroui-divider-weight);
}
.after\\:h-full::after {
  content: var(--tw-content);
  height: 100%;
}
.after\\:h-px::after {
  content: var(--tw-content);
  height: 1px;
}
.after\\:w-0::after {
  content: var(--tw-content);
  width: 0px;
}
.after\\:w-0\\.5::after {
  content: var(--tw-content);
  width: 0.125rem;
}
.after\\:w-4::after {
  content: var(--tw-content);
  width: 1rem;
}
.after\\:w-5::after {
  content: var(--tw-content);
  width: 1.25rem;
}
.after\\:w-6::after {
  content: var(--tw-content);
  width: 1.5rem;
}
.after\\:w-\\[80\\%\\]::after {
  content: var(--tw-content);
  width: 80%;
}
.after\\:w-full::after {
  content: var(--tw-content);
  width: 100%;
}
.after\\:origin-center::after {
  content: var(--tw-content);
  transform-origin: center;
}
.after\\:-translate-x-1\\/2::after {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:translate-y-1::after {
  content: var(--tw-content);
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:rotate-0::after {
  content: var(--tw-content);
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:scale-50::after {
  content: var(--tw-content);
  --tw-scale-x: .5;
  --tw-scale-y: .5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:rounded-\\[calc\\(var\\(--heroui-radius-large\\)\\/2\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-large) / 2);
}
.after\\:rounded-\\[calc\\(var\\(--heroui-radius-medium\\)\\*0\\.5\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-medium) * 0.5);
}
.after\\:rounded-\\[calc\\(var\\(--heroui-radius-medium\\)\\*0\\.6\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-medium) * 0.6);
}
.after\\:rounded-\\[calc\\(var\\(--heroui-radius-medium\\)\\*0\\.7\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-medium) * 0.7);
}
.after\\:rounded-\\[calc\\(var\\(--heroui-radius-medium\\)\\/3\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-medium) / 3);
}
.after\\:rounded-\\[calc\\(var\\(--heroui-radius-small\\)\\/3\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--heroui-radius-small) / 3);
}
.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}
.after\\:rounded-none::after {
  content: var(--tw-content);
  border-radius: 0px;
}
.after\\:rounded-xl::after {
  content: var(--tw-content);
  border-radius: 0.75rem;
}
.after\\:\\!bg-danger::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1)) !important;
}
.after\\:bg-background::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-background) / var(--tw-bg-opacity, 1));
}
.after\\:bg-content1::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-content1) / var(--tw-bg-opacity, 1));
}
.after\\:bg-content3::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-content3) / var(--tw-bg-opacity, 1));
}
.after\\:bg-current::after {
  content: var(--tw-content);
  background-color: currentColor;
}
.after\\:bg-danger::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1));
}
.after\\:bg-default::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default) / var(--tw-bg-opacity, 1));
}
.after\\:bg-default-foreground::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-foreground) / var(--tw-bg-opacity, 1));
}
.after\\:bg-divider::after {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-divider) / 0.15);
}
.after\\:bg-foreground::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--tw-bg-opacity, 1));
}
.after\\:bg-gray-200::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.after\\:bg-primary::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--tw-bg-opacity, 1));
}
.after\\:bg-secondary::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--tw-bg-opacity, 1));
}
.after\\:bg-success::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--tw-bg-opacity, 1));
}
.after\\:bg-transparent::after {
  content: var(--tw-content);
  background-color: transparent;
}
.after\\:bg-warning::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--tw-bg-opacity, 1));
}
.after\\:bg-yellowbuy::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 255 127 / var(--tw-bg-opacity, 1));
}
.after\\:text-danger::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--tw-text-opacity, 1));
}
.after\\:text-danger-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--tw-text-opacity, 1));
}
.after\\:text-default-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--tw-text-opacity, 1));
}
.after\\:text-primary-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--tw-text-opacity, 1));
}
.after\\:text-secondary-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--tw-text-opacity, 1));
}
.after\\:text-success-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--tw-text-opacity, 1));
}
.after\\:text-warning-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--tw-text-opacity, 1));
}
.after\\:opacity-0::after {
  content: var(--tw-content);
  opacity: 0;
}
.after\\:opacity-100::after {
  content: var(--tw-content);
  opacity: 1;
}
.after\\:shadow-\\[0_1px_0px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\]::after {
  content: var(--tw-content);
  --tw-shadow: 0 1px 0px 0 rgba(0,0,0,0.05);
  --tw-shadow-colored: 0 1px 0px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.after\\:shadow-small::after {
  content: var(--tw-content);
  --tw-shadow: var(--heroui-box-shadow-small);
  --tw-shadow-colored: var(--heroui-box-shadow-small);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:transition-none::after {
  content: var(--tw-content);
  transition-property: none;
}
.after\\:transition-transform::after {
  content: var(--tw-content);
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:\\!duration-200::after {
  content: var(--tw-content);
  transition-duration: 200ms !important;
}
.after\\:duration-150::after {
  content: var(--tw-content);
  transition-duration: 150ms;
}
.after\\:\\!ease-linear::after {
  content: var(--tw-content);
  transition-timing-function: linear !important;
}
.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}
.after\\:content-\\[\\'\\*\\'\\]::after {
  --tw-content: '*';
  content: var(--tw-content);
}
.after\\:transition-background::after {
  content: var(--tw-content);
  transition-property: background;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.after\\:transition-width::after {
  content: var(--tw-content);
  transition-property: width;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.after\\:transition-height::after {
  content: var(--tw-content);
  transition-property: height;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.after\\:transition-transform-opacity::after {
  content: var(--tw-content);
  transition-property: transform, scale, opacity rotate;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.first\\:-ml-0\\.5:first-child {
  margin-left: -0.125rem;
}
.first\\:mt-2:first-child {
  margin-top: 0.5rem;
}
.first\\:rounded-s-full:first-child {
  border-start-start-radius: 9999px;
  border-end-start-radius: 9999px;
}
.first\\:rounded-s-large:first-child {
  border-start-start-radius: var(--heroui-radius-large);
  border-end-start-radius: var(--heroui-radius-large);
}
.first\\:rounded-s-lg:first-child {
  border-start-start-radius: 0.5rem;
  border-end-start-radius: 0.5rem;
}
.first\\:rounded-s-medium:first-child {
  border-start-start-radius: var(--heroui-radius-medium);
  border-end-start-radius: var(--heroui-radius-medium);
}
.first\\:rounded-s-none:first-child {
  border-start-start-radius: 0px;
  border-end-start-radius: 0px;
}
.first\\:rounded-s-small:first-child {
  border-start-start-radius: var(--heroui-radius-small);
  border-end-start-radius: var(--heroui-radius-small);
}
.first\\:before\\:rounded-s-lg:first-child::before {
  content: var(--tw-content);
  border-start-start-radius: 0.5rem;
  border-end-start-radius: 0.5rem;
}
.first\\:before\\:rounded-s-none:first-child::before {
  content: var(--tw-content);
  border-start-start-radius: 0px;
  border-end-start-radius: 0px;
}
.last\\:rounded-e-full:last-child {
  border-start-end-radius: 9999px;
  border-end-end-radius: 9999px;
}
.last\\:rounded-e-large:last-child {
  border-start-end-radius: var(--heroui-radius-large);
  border-end-end-radius: var(--heroui-radius-large);
}
.last\\:rounded-e-lg:last-child {
  border-start-end-radius: 0.5rem;
  border-end-end-radius: 0.5rem;
}
.last\\:rounded-e-medium:last-child {
  border-start-end-radius: var(--heroui-radius-medium);
  border-end-end-radius: var(--heroui-radius-medium);
}
.last\\:rounded-e-none:last-child {
  border-start-end-radius: 0px;
  border-end-end-radius: 0px;
}
.last\\:rounded-e-small:last-child {
  border-start-end-radius: var(--heroui-radius-small);
  border-end-end-radius: var(--heroui-radius-small);
}
.last\\:before\\:rounded-e-lg:last-child::before {
  content: var(--tw-content);
  border-start-end-radius: 0.5rem;
  border-end-end-radius: 0.5rem;
}
.last\\:before\\:rounded-e-none:last-child::before {
  content: var(--tw-content);
  border-start-end-radius: 0px;
  border-end-end-radius: 0px;
}
.first-of-type\\:rounded-e-none:first-of-type {
  border-start-end-radius: 0px;
  border-end-end-radius: 0px;
}
.last-of-type\\:rounded-s-none:last-of-type {
  border-start-start-radius: 0px;
  border-end-start-radius: 0px;
}
.autofill\\:bg-transparent:autofill {
  background-color: transparent;
}
.focus-within\\:border-danger:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.focus-within\\:border-default-400:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-400) / var(--tw-border-opacity, 1));
}
.focus-within\\:border-default-foreground:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-foreground) / var(--tw-border-opacity, 1));
}
.focus-within\\:border-primary:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.focus-within\\:border-secondary:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.focus-within\\:border-success:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.focus-within\\:border-warning:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.focus-within\\:bg-danger-50:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--tw-bg-opacity, 1));
}
.focus-within\\:bg-primary-50:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-50) / var(--tw-bg-opacity, 1));
}
.focus-within\\:bg-secondary-50:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-50) / var(--tw-bg-opacity, 1));
}
.focus-within\\:bg-success-50:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-50) / var(--tw-bg-opacity, 1));
}
.focus-within\\:bg-warning-50:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-50) / var(--tw-bg-opacity, 1));
}
.focus-within\\:after\\:w-full:focus-within::after {
  content: var(--tw-content);
  width: 100%;
}
.hover\\:-translate-x-0:hover {
  --tw-translate-x: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-\\[1px\\]:hover {
  --tw-translate-y: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-125:hover {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-\\[\\#C2C2C2\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(194 194 194 / var(--tw-border-opacity, 1));
}
.hover\\:border-danger:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.hover\\:border-default:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default) / var(--tw-border-opacity, 1));
}
.hover\\:border-default-300:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-300) / var(--tw-border-opacity, 1));
}
.hover\\:border-default-400:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-400) / var(--tw-border-opacity, 1));
}
.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.hover\\:border-primary:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.hover\\:border-secondary:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.hover\\:border-success:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.hover\\:border-warning:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.hover\\:\\!bg-foreground:hover {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-foreground) / var(--tw-bg-opacity, 1)) !important;
}
.hover\\:bg-\\[\\#DDDDDD\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(221 221 221 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FFD000\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 208 0 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#e6cf00\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(230 207 0 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-black\\/90:hover {
  background-color: rgb(0 0 0 / 0.9);
}
.hover\\:bg-danger:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-danger-50:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-default-100:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-default-200:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-200) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-neutral-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 82 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary-50:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-50) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-600\\/90:hover {
  background-color: rgb(220 38 38 / 0.9);
}
.hover\\:bg-secondary-50:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-50) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-success-50:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-50) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-warning-50:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-50) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-yellow-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.hover\\:text-blue-800:hover {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.hover\\:text-danger-600:hover {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-600) / var(--tw-text-opacity, 1));
}
.hover\\:text-default-600:hover {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-600) / var(--tw-text-opacity, 1));
}
.hover\\:text-foreground-600:hover {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-600) / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.hover\\:text-primary-600:hover {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-600) / var(--tw-text-opacity, 1));
}
.hover\\:text-secondary-600:hover {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-600) / var(--tw-text-opacity, 1));
}
.hover\\:text-success-600:hover {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-600) / var(--tw-text-opacity, 1));
}
.hover\\:text-warning-600:hover {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-600) / var(--tw-text-opacity, 1));
}
.hover\\:text-yellow-400:hover {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.hover\\:text-yellowbuy:hover {
  --tw-text-opacity: 1;
  color: rgb(0 255 127 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:\\!opacity-100:hover {
  opacity: 1 !important;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.hover\\:opacity-90:hover {
  opacity: 0.9;
}
.hover\\:opacity-hover:hover {
  opacity: var(--heroui-hover-opacity);
}
.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:after\\:bg-danger\\/20:hover::after {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-danger) / 0.2);
}
.hover\\:after\\:bg-foreground\\/10:hover::after {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-foreground) / 0.1);
}
.hover\\:after\\:bg-primary\\/20:hover::after {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-primary) / 0.2);
}
.hover\\:after\\:bg-secondary\\/20:hover::after {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-secondary) / 0.2);
}
.hover\\:after\\:bg-success\\/20:hover::after {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-success) / 0.2);
}
.hover\\:after\\:bg-warning\\/20:hover::after {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-warning) / 0.2);
}
.hover\\:after\\:opacity-100:hover::after {
  content: var(--tw-content);
  opacity: 1;
}
.focus-within\\:hover\\:border-danger:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.focus-within\\:hover\\:border-default-foreground:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-foreground) / var(--tw-border-opacity, 1));
}
.focus-within\\:hover\\:border-primary:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.focus-within\\:hover\\:border-secondary:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.focus-within\\:hover\\:border-success:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.focus-within\\:hover\\:border-warning:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.focus-within\\:hover\\:bg-default-100:hover:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--tw-bg-opacity, 1));
}
.focus\\:border-\\[\\#C2C2C2\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(194 194 194 / var(--tw-border-opacity, 1));
}
.focus\\:bg-danger-400\\/50:focus {
  background-color: hsl(var(--heroui-danger-400) / 0.5);
}
.focus\\:bg-default-400\\/50:focus {
  background-color: hsl(var(--heroui-default-400) / 0.5);
}
.focus\\:bg-primary-400\\/50:focus {
  background-color: hsl(var(--heroui-primary-400) / 0.5);
}
.focus\\:bg-secondary-400\\/50:focus {
  background-color: hsl(var(--heroui-secondary-400) / 0.5);
}
.focus\\:bg-success-400\\/50:focus {
  background-color: hsl(var(--heroui-success-400) / 0.5);
}
.focus\\:bg-warning-400\\/50:focus {
  background-color: hsl(var(--heroui-warning-400) / 0.5);
}
.focus\\:underline:focus {
  text-decoration-line: underline;
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:z-10:focus-visible {
  z-index: 10;
}
.focus-visible\\:outline-2:focus-visible {
  outline-width: 2px;
}
.focus-visible\\:outline-offset-2:focus-visible {
  outline-offset: 2px;
}
.focus-visible\\:outline-focus:focus-visible {
  outline-color: hsl(var(--heroui-focus) / 1);
}
.active\\:translate-y-0:active {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:bg-default-200:active {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-200) / var(--tw-bg-opacity, 1));
}
.active\\:bg-default-300:active {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-300) / var(--tw-bg-opacity, 1));
}
.active\\:bg-yellow-600:active {
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
}
.active\\:underline:active {
  text-decoration-line: underline;
}
.active\\:\\!opacity-70:active {
  opacity: 0.7 !important;
}
.active\\:opacity-disabled:active {
  opacity: var(--heroui-disabled-opacity);
}
.disabled\\:cursor-default:disabled {
  cursor: default;
}
.disabled\\:bg-\\[\\#D3D3D3\\]:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(211 211 211 / var(--tw-bg-opacity, 1));
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.group:hover .group-hover\\:pointer-events-auto {
  pointer-events: auto;
}
.group:hover .group-hover\\:block {
  display: block;
}
.group:hover .group-hover\\:hidden {
  display: none;
}
.group:hover .group-hover\\:border-current {
  border-color: currentColor;
}
.group:hover .group-hover\\:text-current {
  color: currentColor;
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.has-\\[\\:disabled\\]\\:opacity-60:has(:disabled) {
  opacity: 0.6;
}
.aria-expanded\\:scale-\\[0\\.97\\][aria-expanded="true"] {
  --tw-scale-x: 0.97;
  --tw-scale-y: 0.97;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.aria-expanded\\:opacity-70[aria-expanded="true"] {
  opacity: 0.7;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"] {
  pointer-events: none;
}
.data-\\[loaded\\=true\\]\\:pointer-events-auto[data-loaded="true"] {
  pointer-events: auto;
}
.data-\\[visible\\=true\\]\\:pointer-events-auto[data-visible="true"] {
  pointer-events: auto;
}
.data-\\[initialized\\=true\\]\\:visible[data-initialized="true"] {
  visibility: visible;
}
.data-\\[placement\\=bottom-center\\]\\:fixed[data-placement="bottom-center"] {
  position: fixed;
}
.data-\\[placement\\=bottom-left\\]\\:fixed[data-placement="bottom-left"] {
  position: fixed;
}
.data-\\[placement\\=bottom-right\\]\\:fixed[data-placement="bottom-right"] {
  position: fixed;
}
.data-\\[placement\\=top-center\\]\\:fixed[data-placement="top-center"] {
  position: fixed;
}
.data-\\[placement\\=top-left\\]\\:fixed[data-placement="top-left"] {
  position: fixed;
}
.data-\\[placement\\=top-right\\]\\:fixed[data-placement="top-right"] {
  position: fixed;
}
.data-\\[placement\\=bottom-center\\]\\:bottom-0[data-placement="bottom-center"] {
  bottom: 0px;
}
.data-\\[placement\\=bottom-center\\]\\:left-0[data-placement="bottom-center"] {
  left: 0px;
}
.data-\\[placement\\=bottom-center\\]\\:left-1\\/2[data-placement="bottom-center"] {
  left: 50%;
}
.data-\\[placement\\=bottom-center\\]\\:right-0[data-placement="bottom-center"] {
  right: 0px;
}
.data-\\[placement\\=bottom-left\\]\\:bottom-0[data-placement="bottom-left"] {
  bottom: 0px;
}
.data-\\[placement\\=bottom-left\\]\\:left-0[data-placement="bottom-left"] {
  left: 0px;
}
.data-\\[placement\\=bottom-right\\]\\:bottom-0[data-placement="bottom-right"] {
  bottom: 0px;
}
.data-\\[placement\\=bottom-right\\]\\:right-0[data-placement="bottom-right"] {
  right: 0px;
}
.data-\\[placement\\=top-center\\]\\:left-0[data-placement="top-center"] {
  left: 0px;
}
.data-\\[placement\\=top-center\\]\\:left-1\\/2[data-placement="top-center"] {
  left: 50%;
}
.data-\\[placement\\=top-center\\]\\:right-0[data-placement="top-center"] {
  right: 0px;
}
.data-\\[placement\\=top-center\\]\\:top-0[data-placement="top-center"] {
  top: 0px;
}
.data-\\[placement\\=top-left\\]\\:left-0[data-placement="top-left"] {
  left: 0px;
}
.data-\\[placement\\=top-left\\]\\:top-0[data-placement="top-left"] {
  top: 0px;
}
.data-\\[placement\\=top-right\\]\\:right-0[data-placement="top-right"] {
  right: 0px;
}
.data-\\[placement\\=top-right\\]\\:top-0[data-placement="top-right"] {
  top: 0px;
}
.data-\\[focus-visible\\=true\\]\\:z-10[data-focus-visible="true"] {
  z-index: 10;
}
.data-\\[focused\\=true\\]\\:z-10[data-focused="true"] {
  z-index: 10;
}
.data-\\[placement\\=bottom-left\\]\\:mx-auto[data-placement="bottom-left"] {
  margin-left: auto;
  margin-right: auto;
}
.data-\\[placement\\=bottom-right\\]\\:mx-auto[data-placement="bottom-right"] {
  margin-left: auto;
  margin-right: auto;
}
.data-\\[placement\\=top-left\\]\\:mx-auto[data-placement="top-left"] {
  margin-left: auto;
  margin-right: auto;
}
.data-\\[placement\\=top-right\\]\\:mx-auto[data-placement="top-right"] {
  margin-left: auto;
  margin-right: auto;
}
.data-\\[has-label\\=true\\]\\:mt-0[data-has-label="true"] {
  margin-top: 0px;
}
.data-\\[has-label\\=true\\]\\:mt-\\[calc\\(0_\\+_0px\\)\\][data-has-label="true"] {
  margin-top: calc(0 + 0px);
}
.data-\\[has-label\\=true\\]\\:mt-\\[calc\\(var\\(--heroui-font-size-small\\)_\\+_10px\\)\\][data-has-label="true"] {
  margin-top: calc(var(--heroui-font-size-small) + 10px);
}
.data-\\[has-label\\=true\\]\\:mt-\\[calc\\(var\\(--heroui-font-size-small\\)_\\+_12px\\)\\][data-has-label="true"] {
  margin-top: calc(var(--heroui-font-size-small) + 12px);
}
.data-\\[has-label\\=true\\]\\:mt-\\[calc\\(var\\(--heroui-font-size-small\\)_\\+_8px\\)\\][data-has-label="true"] {
  margin-top: calc(var(--heroui-font-size-small) + 8px);
}
.data-\\[open\\=true\\]\\:block[data-open="true"] {
  display: block;
}
.data-\\[open\\=true\\]\\:flex[data-open="true"] {
  display: flex;
}
.data-\\[placement\\=bottom-center\\]\\:flex[data-placement="bottom-center"] {
  display: flex;
}
.data-\\[placement\\=bottom-left\\]\\:flex[data-placement="bottom-left"] {
  display: flex;
}
.data-\\[placement\\=bottom-right\\]\\:flex[data-placement="bottom-right"] {
  display: flex;
}
.data-\\[placement\\=top-center\\]\\:flex[data-placement="top-center"] {
  display: flex;
}
.data-\\[placement\\=top-left\\]\\:flex[data-placement="top-left"] {
  display: flex;
}
.data-\\[placement\\=top-right\\]\\:flex[data-placement="top-right"] {
  display: flex;
}
.data-\\[hidden\\=true\\]\\:hidden[data-hidden="true"] {
  display: none;
}
.data-\\[inert\\=true\\]\\:hidden[data-inert="true"] {
  display: none;
}
.data-\\[justify\\=end\\]\\:flex-grow[data-justify="end"] {
  flex-grow: 1;
}
.data-\\[justify\\=start\\]\\:flex-grow[data-justify="start"] {
  flex-grow: 1;
}
.data-\\[justify\\=end\\]\\:basis-0[data-justify="end"] {
  flex-basis: 0px;
}
.data-\\[justify\\=start\\]\\:basis-0[data-justify="start"] {
  flex-basis: 0px;
}
.data-\\[focus-visible\\=true\\]\\:-translate-x-3[data-focus-visible="true"] {
  --tw-translate-x: -0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[focus-visible\\=true\\]\\:translate-x-0[data-focus-visible="true"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[hover\\=true\\]\\:-translate-x-3[data-hover="true"] {
  --tw-translate-x: -0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[hover\\=true\\]\\:translate-x-0[data-hover="true"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[placement\\=bottom-center\\]\\:-translate-x-1\\/2[data-placement="bottom-center"] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[placement\\=top-center\\]\\:-translate-x-1\\/2[data-placement="top-center"] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[toast-exiting\\=true\\]\\:data-\\[placement\\=bottom-center\\]\\:translate-y-full[data-placement="bottom-center"][data-toast-exiting="true"] {
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[toast-exiting\\=true\\]\\:data-\\[placement\\=bottom-left\\]\\:-translate-x-full[data-placement="bottom-left"][data-toast-exiting="true"] {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[toast-exiting\\=true\\]\\:data-\\[placement\\=bottom-right\\]\\:translate-x-full[data-placement="bottom-right"][data-toast-exiting="true"] {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[toast-exiting\\=true\\]\\:data-\\[placement\\=top-center\\]\\:-translate-y-full[data-placement="top-center"][data-toast-exiting="true"] {
  --tw-translate-y: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[toast-exiting\\=true\\]\\:data-\\[placement\\=top-left\\]\\:-translate-x-full[data-placement="top-left"][data-toast-exiting="true"] {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[toast-exiting\\=true\\]\\:data-\\[placement\\=top-right\\]\\:translate-x-full[data-placement="top-right"][data-toast-exiting="true"] {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[before\\=true\\]\\:rotate-180[data-before="true"] {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[direction\\=ascending\\]\\:rotate-180[data-direction="ascending"] {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[open\\=true\\]\\:-rotate-90[data-open="true"] {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[open\\=true\\]\\:rotate-180[data-open="true"] {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[open\\=true\\]\\:rotate-90[data-open="true"] {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[active\\=true\\]\\:scale-100[data-active="true"] {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[active\\=true\\]\\:scale-110[data-active="true"] {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[invisible\\=true\\]\\:scale-0[data-invisible="true"] {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[pressed\\=true\\]\\:scale-100[data-pressed="true"] {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[pressed\\=true\\]\\:scale-\\[0\\.97\\][data-pressed="true"] {
  --tw-scale-x: 0.97;
  --tw-scale-y: 0.97;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[toast-exiting\\=true\\]\\:transform-gpu[data-toast-exiting="true"] {
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[disabled\\=true\\]\\:cursor-default[data-disabled="true"] {
  cursor: default;
}
.data-\\[disabled\\=true\\]\\:cursor-not-allowed[data-disabled="true"] {
  cursor: not-allowed;
}
.data-\\[dragging\\=true\\]\\:cursor-grabbing[data-dragging="true"] {
  cursor: grabbing;
}
.data-\\[readonly\\=true\\]\\:cursor-default[data-readonly="true"] {
  cursor: default;
}
.data-\\[sortable\\=true\\]\\:cursor-pointer[data-sortable="true"] {
  cursor: pointer;
}
.data-\\[unavailable\\=true\\]\\:cursor-default[data-unavailable="true"] {
  cursor: default;
}
.data-\\[visible\\=true\\]\\:cursor-pointer[data-visible="true"] {
  cursor: pointer;
}
.data-\\[orientation\\=horizontal\\]\\:flex-row[data-orientation="horizontal"] {
  flex-direction: row;
}
.data-\\[placement\\=bottom-center\\]\\:flex-col[data-placement="bottom-center"] {
  flex-direction: column;
}
.data-\\[placement\\=bottom-left\\]\\:flex-col[data-placement="bottom-left"] {
  flex-direction: column;
}
.data-\\[placement\\=bottom-right\\]\\:flex-col[data-placement="bottom-right"] {
  flex-direction: column;
}
.data-\\[placement\\=top-center\\]\\:flex-col[data-placement="top-center"] {
  flex-direction: column;
}
.data-\\[placement\\=top-left\\]\\:flex-col[data-placement="top-left"] {
  flex-direction: column;
}
.data-\\[placement\\=top-right\\]\\:flex-col[data-placement="top-right"] {
  flex-direction: column;
}
.data-\\[has-helper\\=true\\]\\:items-start[data-has-helper="true"] {
  align-items: flex-start;
}
.data-\\[justify\\=start\\]\\:justify-start[data-justify="start"] {
  justify-content: flex-start;
}
.data-\\[justify\\=end\\]\\:justify-end[data-justify="end"] {
  justify-content: flex-end;
}
.data-\\[justify\\=center\\]\\:justify-center[data-justify="center"] {
  justify-content: center;
}
.data-\\[loaded\\=true\\]\\:overflow-visible[data-loaded="true"] {
  overflow: visible;
}
.data-\\[has-multiple-rows\\=true\\]\\:rounded-large[data-has-multiple-rows="true"] {
  border-radius: var(--heroui-radius-large);
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:rounded-full[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  border-radius: 9999px;
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:rounded-full[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  border-radius: 9999px;
}
.data-\\[type\\=color\\]\\:rounded-none[data-type="color"] {
  border-radius: 0px;
}
.data-\\[menu-open\\=true\\]\\:border-none[data-menu-open="true"] {
  border-style: none;
}
.data-\\[active\\=true\\]\\:border-danger[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.data-\\[active\\=true\\]\\:border-danger-400[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger-400) / var(--tw-border-opacity, 1));
}
.data-\\[active\\=true\\]\\:border-default-300[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-300) / var(--tw-border-opacity, 1));
}
.data-\\[active\\=true\\]\\:border-default-400[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-400) / var(--tw-border-opacity, 1));
}
.data-\\[active\\=true\\]\\:border-foreground[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-foreground) / var(--tw-border-opacity, 1));
}
.data-\\[active\\=true\\]\\:border-primary[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.data-\\[active\\=true\\]\\:border-secondary[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.data-\\[active\\=true\\]\\:border-success[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.data-\\[active\\=true\\]\\:border-warning[data-active="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.data-\\[focus\\=true\\]\\:border-black[data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.data-\\[focus\\=true\\]\\:border-danger[data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.data-\\[focus\\=true\\]\\:border-default-400[data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-400) / var(--tw-border-opacity, 1));
}
.data-\\[focus\\=true\\]\\:border-default-foreground[data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-foreground) / var(--tw-border-opacity, 1));
}
.data-\\[focus\\=true\\]\\:border-primary[data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.data-\\[focus\\=true\\]\\:border-secondary[data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.data-\\[focus\\=true\\]\\:border-success[data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.data-\\[focus\\=true\\]\\:border-warning[data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.data-\\[focus\\=true\\]\\:data-\\[hover\\=true\\]\\:border-danger[data-hover="true"][data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.data-\\[focus\\=true\\]\\:data-\\[hover\\=true\\]\\:border-default-foreground[data-hover="true"][data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-foreground) / var(--tw-border-opacity, 1));
}
.data-\\[focus\\=true\\]\\:data-\\[hover\\=true\\]\\:border-primary[data-hover="true"][data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.data-\\[focus\\=true\\]\\:data-\\[hover\\=true\\]\\:border-secondary[data-hover="true"][data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.data-\\[focus\\=true\\]\\:data-\\[hover\\=true\\]\\:border-success[data-hover="true"][data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.data-\\[focus\\=true\\]\\:data-\\[hover\\=true\\]\\:border-warning[data-hover="true"][data-focus="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.data-\\[hover\\=true\\]\\:border-\\[\\#C2C2C2\\][data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(194 194 194 / var(--tw-border-opacity, 1));
}
.data-\\[hover\\=true\\]\\:border-black[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.data-\\[hover\\=true\\]\\:border-danger[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.data-\\[hover\\=true\\]\\:border-default[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default) / var(--tw-border-opacity, 1));
}
.data-\\[hover\\=true\\]\\:border-default-400[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-400) / var(--tw-border-opacity, 1));
}
.data-\\[hover\\=true\\]\\:border-primary[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.data-\\[hover\\=true\\]\\:border-secondary[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.data-\\[hover\\=true\\]\\:border-success[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.data-\\[hover\\=true\\]\\:border-warning[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.data-\\[open\\=true\\]\\:border-black[data-open="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.data-\\[open\\=true\\]\\:border-danger[data-open="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.data-\\[open\\=true\\]\\:border-default-400[data-open="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-400) / var(--tw-border-opacity, 1));
}
.data-\\[open\\=true\\]\\:border-default-foreground[data-open="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-foreground) / var(--tw-border-opacity, 1));
}
.data-\\[open\\=true\\]\\:border-primary[data-open="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.data-\\[open\\=true\\]\\:border-secondary[data-open="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.data-\\[open\\=true\\]\\:border-success[data-open="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.data-\\[open\\=true\\]\\:border-warning[data-open="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.data-\\[fill-end\\=true\\]\\:border-e-danger[data-fill-end="true"] {
  --tw-border-opacity: 1;
  border-inline-end-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.data-\\[fill-end\\=true\\]\\:border-e-foreground[data-fill-end="true"] {
  --tw-border-opacity: 1;
  border-inline-end-color: hsl(var(--heroui-foreground) / var(--tw-border-opacity, 1));
}
.data-\\[fill-end\\=true\\]\\:border-e-primary[data-fill-end="true"] {
  --tw-border-opacity: 1;
  border-inline-end-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.data-\\[fill-end\\=true\\]\\:border-e-secondary[data-fill-end="true"] {
  --tw-border-opacity: 1;
  border-inline-end-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.data-\\[fill-end\\=true\\]\\:border-e-success[data-fill-end="true"] {
  --tw-border-opacity: 1;
  border-inline-end-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.data-\\[fill-end\\=true\\]\\:border-e-warning[data-fill-end="true"] {
  --tw-border-opacity: 1;
  border-inline-end-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.data-\\[fill-end\\=true\\]\\:border-t-danger[data-fill-end="true"] {
  --tw-border-opacity: 1;
  border-top-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.data-\\[fill-end\\=true\\]\\:border-t-foreground[data-fill-end="true"] {
  --tw-border-opacity: 1;
  border-top-color: hsl(var(--heroui-foreground) / var(--tw-border-opacity, 1));
}
.data-\\[fill-end\\=true\\]\\:border-t-primary[data-fill-end="true"] {
  --tw-border-opacity: 1;
  border-top-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.data-\\[fill-end\\=true\\]\\:border-t-secondary[data-fill-end="true"] {
  --tw-border-opacity: 1;
  border-top-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.data-\\[fill-end\\=true\\]\\:border-t-success[data-fill-end="true"] {
  --tw-border-opacity: 1;
  border-top-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.data-\\[fill-end\\=true\\]\\:border-t-warning[data-fill-end="true"] {
  --tw-border-opacity: 1;
  border-top-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.data-\\[fill-start\\=true\\]\\:border-b-danger[data-fill-start="true"] {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.data-\\[fill-start\\=true\\]\\:border-b-foreground[data-fill-start="true"] {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-foreground) / var(--tw-border-opacity, 1));
}
.data-\\[fill-start\\=true\\]\\:border-b-primary[data-fill-start="true"] {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.data-\\[fill-start\\=true\\]\\:border-b-secondary[data-fill-start="true"] {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.data-\\[fill-start\\=true\\]\\:border-b-success[data-fill-start="true"] {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.data-\\[fill-start\\=true\\]\\:border-b-warning[data-fill-start="true"] {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.data-\\[fill-start\\=true\\]\\:border-s-danger[data-fill-start="true"] {
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.data-\\[fill-start\\=true\\]\\:border-s-foreground[data-fill-start="true"] {
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--heroui-foreground) / var(--tw-border-opacity, 1));
}
.data-\\[fill-start\\=true\\]\\:border-s-primary[data-fill-start="true"] {
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.data-\\[fill-start\\=true\\]\\:border-s-secondary[data-fill-start="true"] {
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.data-\\[fill-start\\=true\\]\\:border-s-success[data-fill-start="true"] {
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.data-\\[fill-start\\=true\\]\\:border-s-warning[data-fill-start="true"] {
  --tw-border-opacity: 1;
  border-inline-start-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.data-\\[active\\=true\\]\\:bg-danger[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1));
}
.data-\\[active\\=true\\]\\:bg-danger-100[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-100) / var(--tw-bg-opacity, 1));
}
.data-\\[active\\=true\\]\\:bg-danger-200[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-200) / var(--tw-bg-opacity, 1));
}
.data-\\[active\\=true\\]\\:bg-default-200[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-200) / var(--tw-bg-opacity, 1));
}
.data-\\[active\\=true\\]\\:bg-default-400[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-400) / var(--tw-bg-opacity, 1));
}
.data-\\[active\\=true\\]\\:bg-primary[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--tw-bg-opacity, 1));
}
.data-\\[active\\=true\\]\\:bg-primary-200[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-200) / var(--tw-bg-opacity, 1));
}
.data-\\[active\\=true\\]\\:bg-secondary[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--tw-bg-opacity, 1));
}
.data-\\[active\\=true\\]\\:bg-secondary-200[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-200) / var(--tw-bg-opacity, 1));
}
.data-\\[active\\=true\\]\\:bg-success[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--tw-bg-opacity, 1));
}
.data-\\[active\\=true\\]\\:bg-success-200[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-200) / var(--tw-bg-opacity, 1));
}
.data-\\[active\\=true\\]\\:bg-warning[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--tw-bg-opacity, 1));
}
.data-\\[active\\=true\\]\\:bg-warning-200[data-active="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-200) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:\\!bg-danger[data-hover="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1)) !important;
}
.data-\\[hover\\=true\\]\\:\\!bg-danger-100[data-hover="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-danger-100) / var(--tw-bg-opacity, 1)) !important;
}
.data-\\[hover\\=true\\]\\:\\!bg-default[data-hover="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-default) / var(--tw-bg-opacity, 1)) !important;
}
.data-\\[hover\\=true\\]\\:\\!bg-primary[data-hover="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-primary) / var(--tw-bg-opacity, 1)) !important;
}
.data-\\[hover\\=true\\]\\:\\!bg-secondary[data-hover="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-secondary) / var(--tw-bg-opacity, 1)) !important;
}
.data-\\[hover\\=true\\]\\:\\!bg-success[data-hover="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-success) / var(--tw-bg-opacity, 1)) !important;
}
.data-\\[hover\\=true\\]\\:\\!bg-warning[data-hover="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-warning) / var(--tw-bg-opacity, 1)) !important;
}
.data-\\[hover\\=true\\]\\:bg-\\[transparent\\][data-hover="true"] {
  background-color: transparent;
}
.data-\\[hover\\=true\\]\\:bg-content2[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-content2) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-danger[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-danger-100[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-100) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-danger-50[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-danger\\/20[data-hover="true"] {
  background-color: hsl(var(--heroui-danger) / 0.2);
}
.data-\\[hover\\=true\\]\\:bg-default[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-default-100[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-default-200[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-200) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-default\\/40[data-hover="true"] {
  background-color: hsl(var(--heroui-default) / 0.4);
}
.data-\\[hover\\=true\\]\\:bg-foreground-200[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground-200) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-primary[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-primary-50[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-50) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-primary\\/20[data-hover="true"] {
  background-color: hsl(var(--heroui-primary) / 0.2);
}
.data-\\[hover\\=true\\]\\:bg-secondary[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-secondary-50[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-50) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-secondary\\/20[data-hover="true"] {
  background-color: hsl(var(--heroui-secondary) / 0.2);
}
.data-\\[hover\\=true\\]\\:bg-success[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-success-100[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-100) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-success-50[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-50) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-success\\/20[data-hover="true"] {
  background-color: hsl(var(--heroui-success) / 0.2);
}
.data-\\[hover\\=true\\]\\:bg-transparent[data-hover="true"] {
  background-color: transparent;
}
.data-\\[hover\\=true\\]\\:bg-warning[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-warning-100[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-100) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-warning-50[data-hover="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-50) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\=true\\]\\:bg-warning\\/20[data-hover="true"] {
  background-color: hsl(var(--heroui-warning) / 0.2);
}
.data-\\[hover\\]\\:bg-danger-200[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-200) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\]\\:bg-danger-50[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\]\\:bg-default-100[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\]\\:bg-primary-200[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-200) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\]\\:bg-primary-50[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-50) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\]\\:bg-secondary-200[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-200) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\]\\:bg-secondary-50[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-50) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\]\\:bg-success-200[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-200) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\]\\:bg-success-50[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-50) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\]\\:bg-warning-100[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-100) / var(--tw-bg-opacity, 1));
}
.data-\\[hover\\]\\:bg-warning-200[data-hover] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-200) / var(--tw-bg-opacity, 1));
}
.data-\\[in-range\\=false\\]\\:bg-default-200[data-in-range="false"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-200) / var(--tw-bg-opacity, 1));
}
.data-\\[in-range\\=true\\]\\:bg-background\\/50[data-in-range="true"] {
  background-color: hsl(var(--heroui-background) / 0.5);
}
.data-\\[in-range\\=true\\]\\:bg-danger[data-in-range="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1));
}
.data-\\[in-range\\=true\\]\\:bg-foreground[data-in-range="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--tw-bg-opacity, 1));
}
.data-\\[in-range\\=true\\]\\:bg-primary[data-in-range="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--tw-bg-opacity, 1));
}
.data-\\[in-range\\=true\\]\\:bg-secondary[data-in-range="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--tw-bg-opacity, 1));
}
.data-\\[in-range\\=true\\]\\:bg-success[data-in-range="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--tw-bg-opacity, 1));
}
.data-\\[in-range\\=true\\]\\:bg-warning[data-in-range="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--tw-bg-opacity, 1));
}
.data-\\[loaded\\=true\\]\\:\\!bg-transparent[data-loaded="true"] {
  background-color: transparent !important;
}
.data-\\[selected\\=true\\]\\:bg-danger[data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:bg-default[data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:bg-foreground[data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:bg-primary[data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:bg-secondary[data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:bg-success[data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:bg-warning[data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-danger[data-hover="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-foreground[data-hover="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-primary[data-hover="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-secondary[data-hover="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-success[data-hover="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-warning[data-hover="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-transparent[data-range-selection="true"][data-selected="true"] {
  background-color: transparent;
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:data-\\[outside-month\\=true\\]\\:bg-transparent[data-outside-month="true"][data-range-selection="true"][data-selected="true"] {
  background-color: transparent;
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-danger[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-primary[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-secondary[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-success[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-warning[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-danger[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-primary[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-secondary[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-success[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:bg-warning[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--tw-bg-opacity, 1));
}
.data-\\[has-end-content\\=true\\]\\:pe-1\\.5[data-has-end-content="true"] {
  padding-inline-end: 0.375rem;
}
.data-\\[has-helper\\=true\\]\\:pb-\\[calc\\(var\\(--heroui-font-size-tiny\\)_\\+8px\\)\\][data-has-helper="true"] {
  padding-bottom: calc(var(--heroui-font-size-tiny) + 8px);
}
.data-\\[has-helper\\=true\\]\\:pb-\\[calc\\(var\\(--heroui-font-size-tiny\\)_\\+_8px\\)\\][data-has-helper="true"] {
  padding-bottom: calc(var(--heroui-font-size-tiny) + 8px);
}
.data-\\[has-start-content\\=true\\]\\:ps-1\\.5[data-has-start-content="true"] {
  padding-inline-start: 0.375rem;
}
.data-\\[has-title\\=true\\]\\:pt-1[data-has-title="true"] {
  padding-top: 0.25rem;
}
.data-\\[active\\=true\\]\\:font-semibold[data-active="true"] {
  font-weight: 600;
}
.data-\\[active\\=true\\]\\:text-danger-foreground[data-active="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[active\\=true\\]\\:text-default-foreground[data-active="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[active\\=true\\]\\:text-primary-foreground[data-active="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[active\\=true\\]\\:text-secondary-foreground[data-active="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[active\\=true\\]\\:text-success-foreground[data-active="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[active\\=true\\]\\:text-warning-foreground[data-active="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[disabled\\=true\\]\\:text-default-300[data-disabled="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-300) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-danger-300[data-placeholder="true"][data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-300) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-foreground-500[data-placeholder="true"][data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-500) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-primary-300[data-placeholder="true"][data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-300) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-secondary-300[data-placeholder="true"][data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-300) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-success-400[data-placeholder="true"][data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-400) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:text-warning-400[data-placeholder="true"][data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-400) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:text-danger[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:text-foreground[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:text-primary[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:text-secondary[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:text-success-600[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-600) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:text-warning-600[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-600) / var(--tw-text-opacity, 1));
}
.data-\\[has-value\\=true\\]\\:text-default-foreground[data-has-value="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:\\!text-danger-foreground[data-hover="true"] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--heroui-danger-foreground) / var(--tw-text-opacity, 1)) !important;
}
.data-\\[hover\\=true\\]\\:\\!text-primary-foreground[data-hover="true"] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--heroui-primary-foreground) / var(--tw-text-opacity, 1)) !important;
}
.data-\\[hover\\=true\\]\\:\\!text-secondary-foreground[data-hover="true"] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--heroui-secondary-foreground) / var(--tw-text-opacity, 1)) !important;
}
.data-\\[hover\\=true\\]\\:\\!text-success-foreground[data-hover="true"] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--heroui-success-foreground) / var(--tw-text-opacity, 1)) !important;
}
.data-\\[hover\\=true\\]\\:\\!text-warning-foreground[data-hover="true"] {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--heroui-warning-foreground) / var(--tw-text-opacity, 1)) !important;
}
.data-\\[hover\\=true\\]\\:text-danger[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-danger-500[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-500) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-danger-foreground[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-default-500[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-500) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-default-foreground[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-foreground[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-foreground-400[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-400) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-foreground-600[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-600) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-primary[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-primary-400[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-400) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-primary-foreground[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-secondary[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-secondary-400[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-400) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-secondary-foreground[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-success[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-success-600[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-600) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-success-foreground[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-warning[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-warning-600[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-600) / var(--tw-text-opacity, 1));
}
.data-\\[hover\\=true\\]\\:text-warning-foreground[data-hover="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[invalid\\=true\\]\\:data-\\[editable\\=true\\]\\:text-danger[data-editable="true"][data-invalid="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--tw-text-opacity, 1));
}
.data-\\[invalid\\=true\\]\\:text-danger-300[data-invalid="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-300) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-background[data-hover="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-background) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-danger-foreground[data-hover="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-primary-foreground[data-hover="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-secondary-foreground[data-hover="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-success-foreground[data-hover="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-warning-foreground[data-hover="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:data-\\[outside-month\\=true\\]\\:text-default-300[data-outside-month="true"][data-range-selection="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-300) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-danger-500[data-range-selection="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-500) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-foreground[data-range-selection="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-primary[data-range-selection="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-secondary[data-range-selection="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-600[data-range-selection="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-600) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-warning-500[data-range-selection="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-500) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-background[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-background) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-danger-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-primary-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-secondary-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-warning-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-background[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-background) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-danger-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-primary-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-secondary-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-warning-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:text-background[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-background) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:text-danger[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:text-danger-foreground[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:text-default-foreground[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:text-primary[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:text-primary-foreground[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:text-secondary[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:text-secondary-foreground[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:text-success-600[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-600) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:text-success-foreground[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:text-warning-600[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-600) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:text-warning-foreground[data-selected="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[unavailable\\=true\\]\\:text-default-300[data-unavailable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-300) / var(--tw-text-opacity, 1));
}
.data-\\[unavailable\\=true\\]\\:line-through[data-unavailable="true"] {
  text-decoration-line: line-through;
}
.data-\\[animation\\=exiting\\]\\:opacity-0[data-animation="exiting"] {
  opacity: 0;
}
.data-\\[disabled\\=true\\]\\:data-\\[outside-month\\=true\\]\\:opacity-0[data-outside-month="true"][data-disabled="true"] {
  opacity: 0;
}
.data-\\[disabled\\=true\\]\\:opacity-30[data-disabled="true"] {
  opacity: 0.3;
}
.data-\\[hover-unselected\\=true\\]\\:opacity-disabled[data-hover-unselected="true"] {
  opacity: var(--heroui-disabled-opacity);
}
.data-\\[hover\\=true\\]\\:opacity-70[data-hover="true"] {
  opacity: 0.7;
}
.data-\\[hover\\=true\\]\\:opacity-hover[data-hover="true"] {
  opacity: var(--heroui-hover-opacity);
}
.data-\\[in-range\\=true\\]\\:opacity-100[data-in-range="true"] {
  opacity: 1;
}
.data-\\[invisible\\=true\\]\\:opacity-0[data-invisible="true"] {
  opacity: 0;
}
.data-\\[loaded\\=true\\]\\:opacity-100[data-loaded="true"] {
  opacity: 1;
}
.data-\\[moving\\]\\:opacity-100[data-moving] {
  opacity: 1;
}
.data-\\[pressed\\=true\\]\\:opacity-50[data-pressed="true"] {
  opacity: 0.5;
}
.data-\\[pressed\\=true\\]\\:opacity-70[data-pressed="true"] {
  opacity: 0.7;
}
.data-\\[pressed\\=true\\]\\:opacity-disabled[data-pressed="true"] {
  opacity: var(--heroui-disabled-opacity);
}
.data-\\[toast-exiting\\=true\\]\\:opacity-0[data-toast-exiting="true"] {
  opacity: 0;
}
.data-\\[visible\\=true\\]\\:opacity-100[data-visible="true"] {
  opacity: 1;
}
.data-\\[active\\=true\\]\\:shadow-md[data-active="true"] {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[hover\\=true\\]\\:shadow-lg[data-hover="true"] {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:shadow-md[data-selection-end="true"][data-selected="true"] {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:shadow-md[data-selection-start="true"][data-selected="true"] {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[selected\\=true\\]\\:shadow-md[data-selected="true"] {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[selected\\=true\\]\\:shadow-none[data-selected="true"] {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[active\\=true\\]\\:shadow-danger\\/40[data-active="true"] {
  --tw-shadow-color: hsl(var(--heroui-danger) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[active\\=true\\]\\:shadow-default\\/50[data-active="true"] {
  --tw-shadow-color: hsl(var(--heroui-default) / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[active\\=true\\]\\:shadow-primary\\/40[data-active="true"] {
  --tw-shadow-color: hsl(var(--heroui-primary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[active\\=true\\]\\:shadow-secondary\\/40[data-active="true"] {
  --tw-shadow-color: hsl(var(--heroui-secondary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[active\\=true\\]\\:shadow-success\\/40[data-active="true"] {
  --tw-shadow-color: hsl(var(--heroui-success) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[active\\=true\\]\\:shadow-warning\\/40[data-active="true"] {
  --tw-shadow-color: hsl(var(--heroui-warning) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:shadow-danger\\/30[data-hover="true"] {
  --tw-shadow-color: hsl(var(--heroui-danger) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:shadow-default\\/50[data-hover="true"] {
  --tw-shadow-color: hsl(var(--heroui-default) / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:shadow-primary\\/30[data-hover="true"] {
  --tw-shadow-color: hsl(var(--heroui-primary) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:shadow-secondary\\/30[data-hover="true"] {
  --tw-shadow-color: hsl(var(--heroui-secondary) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:shadow-success\\/30[data-hover="true"] {
  --tw-shadow-color: hsl(var(--heroui-success) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:shadow-warning\\/30[data-hover="true"] {
  --tw-shadow-color: hsl(var(--heroui-warning) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:shadow-danger\\/40[data-selected="true"] {
  --tw-shadow-color: hsl(var(--heroui-danger) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:shadow-foreground\\/40[data-selected="true"] {
  --tw-shadow-color: hsl(var(--heroui-foreground) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:shadow-primary\\/40[data-selected="true"] {
  --tw-shadow-color: hsl(var(--heroui-primary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:shadow-secondary\\/40[data-selected="true"] {
  --tw-shadow-color: hsl(var(--heroui-secondary) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:shadow-success\\/40[data-selected="true"] {
  --tw-shadow-color: hsl(var(--heroui-success) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:shadow-warning\\/40[data-selected="true"] {
  --tw-shadow-color: hsl(var(--heroui-warning) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[focus-visible\\=true\\]\\:outline-2[data-focus-visible="true"] {
  outline-width: 2px;
}
.data-\\[focus-visible\\=true\\]\\:outline-offset-2[data-focus-visible="true"] {
  outline-offset: 2px;
}
.data-\\[focus-visible\\=true\\]\\:outline-focus[data-focus-visible="true"] {
  outline-color: hsl(var(--heroui-focus) / 1);
}
.data-\\[focus-visible\\=true\\]\\:outline-transparent[data-focus-visible="true"] {
  outline-color: transparent;
}
.data-\\[focus-visible\\]\\:outline-danger-foreground[data-focus-visible] {
  outline-color: hsl(var(--heroui-danger-foreground) / 1);
}
.data-\\[focus-visible\\]\\:outline-default-foreground[data-focus-visible] {
  outline-color: hsl(var(--heroui-default-foreground) / 1);
}
.data-\\[focus-visible\\]\\:outline-primary-foreground[data-focus-visible] {
  outline-color: hsl(var(--heroui-primary-foreground) / 1);
}
.data-\\[focus-visible\\]\\:outline-secondary-foreground[data-focus-visible] {
  outline-color: hsl(var(--heroui-secondary-foreground) / 1);
}
.data-\\[focus-visible\\]\\:outline-success-foreground[data-focus-visible] {
  outline-color: hsl(var(--heroui-success-foreground) / 1);
}
.data-\\[focus-visible\\]\\:outline-warning-foreground[data-focus-visible] {
  outline-color: hsl(var(--heroui-warning-foreground) / 1);
}
.data-\\[focus-visible\\=true\\]\\:ring-default-500[data-focus-visible="true"] {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-default-500) / var(--tw-ring-opacity, 1));
}
.data-\\[menu-open\\=true\\]\\:backdrop-blur-xl[data-menu-open="true"] {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.data-\\[animated\\=true\\]\\:transition-\\[left\\2c top\\2c width\\2c height\\][data-animated="true"] {
  transition-property: left,top,width,height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.data-\\[disabled\\=true\\]\\:transition-none[data-disabled="true"] {
  transition-property: none;
}
.data-\\[hover\\=true\\]\\:transition-colors[data-hover="true"] {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.data-\\[moving\\=true\\]\\:transition-transform[data-moving="true"] {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.data-\\[toast-exiting\\=true\\]\\:transition-all[data-toast-exiting="true"] {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.data-\\[animated\\=true\\]\\:duration-250[data-animated="true"] {
  transition-duration: 250ms;
}
.data-\\[toast-exiting\\=true\\]\\:duration-300[data-toast-exiting="true"] {
  transition-duration: 300ms;
}
.data-\\[animated\\=true\\]\\:ease-out[data-animated="true"] {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.data-\\[toast-exiting\\=true\\]\\:ease-out[data-toast-exiting="true"] {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.data-\\[toast-exiting\\=true\\]\\:will-change-transform[data-toast-exiting="true"] {
  will-change: transform;
}
.data-\\[hide-scroll\\=true\\]\\:scrollbar-hide[data-hide-scroll="true"] {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.data-\\[hide-scroll\\=true\\]\\:scrollbar-hide[data-hide-scroll="true"]::-webkit-scrollbar {
  display: none;
}
.data-\\[top-bottom-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(\\#000\\2c \\#000\\2c transparent_0\\2c \\#000_var\\(--scroll-shadow-size\\)\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-top-bottom-scroll="true"] {
  mask-image: linear-gradient(#000,#000,transparent 0,#000 var(--scroll-shadow-size),#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[top-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(0deg\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-top-scroll="true"] {
  mask-image: linear-gradient(0deg,#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[bottom-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(180deg\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-bottom-scroll="true"] {
  mask-image: linear-gradient(180deg,#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[left-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(270deg\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-left-scroll="true"] {
  mask-image: linear-gradient(270deg,#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[right-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(90deg\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-right-scroll="true"] {
  mask-image: linear-gradient(90deg,#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[left-right-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(to_right\\2c \\#000\\2c \\#000\\2c transparent_0\\2c \\#000_var\\(--scroll-shadow-size\\)\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-left-right-scroll="true"] {
  mask-image: linear-gradient(to right,#000,#000,transparent 0,#000 var(--scroll-shadow-size),#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[placement\\=bottom-center\\]\\:before\\:top-\\[calc\\(-1\\*var\\(--top-extension\\2c 16px\\)\\)\\][data-placement="bottom-center"]::before {
  content: var(--tw-content);
  top: calc(-1 * var(--top-extension,16px));
}
.data-\\[placement\\=bottom-end\\]\\:before\\:-top-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="bottom-end"]::before {
  content: var(--tw-content);
  top: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=bottom-end\\]\\:before\\:right-3[data-placement="bottom-end"]::before {
  content: var(--tw-content);
  right: 0.75rem;
}
.data-\\[placement\\=bottom-left\\]\\:before\\:top-\\[calc\\(-1\\*var\\(--top-extension\\2c 16px\\)\\)\\][data-placement="bottom-left"]::before {
  content: var(--tw-content);
  top: calc(-1 * var(--top-extension,16px));
}
.data-\\[placement\\=bottom-right\\]\\:before\\:top-\\[calc\\(-1\\*var\\(--top-extension\\2c 16px\\)\\)\\][data-placement="bottom-right"]::before {
  content: var(--tw-content);
  top: calc(-1 * var(--top-extension,16px));
}
.data-\\[placement\\=bottom-start\\]\\:before\\:-top-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="bottom-start"]::before {
  content: var(--tw-content);
  top: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=bottom-start\\]\\:before\\:left-3[data-placement="bottom-start"]::before {
  content: var(--tw-content);
  left: 0.75rem;
}
.data-\\[placement\\=bottom\\]\\:before\\:-top-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="bottom"]::before {
  content: var(--tw-content);
  top: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=bottom\\]\\:before\\:left-1\\/2[data-placement="bottom"]::before {
  content: var(--tw-content);
  left: 50%;
}
.data-\\[placement\\=left-end\\]\\:before\\:-right-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_3px\\)\\][data-placement="left-end"]::before {
  content: var(--tw-content);
  right: calc(calc(1.25rem / 4 - 3px) * -1);
}
.data-\\[placement\\=left-end\\]\\:before\\:bottom-1\\/4[data-placement="left-end"]::before {
  content: var(--tw-content);
  bottom: 25%;
}
.data-\\[placement\\=left-start\\]\\:before\\:-right-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_3px\\)\\][data-placement="left-start"]::before {
  content: var(--tw-content);
  right: calc(calc(1.25rem / 4 - 3px) * -1);
}
.data-\\[placement\\=left-start\\]\\:before\\:top-1\\/4[data-placement="left-start"]::before {
  content: var(--tw-content);
  top: 25%;
}
.data-\\[placement\\=left\\]\\:before\\:-right-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_2px\\)\\][data-placement="left"]::before {
  content: var(--tw-content);
  right: calc(calc(1.25rem / 4 - 2px) * -1);
}
.data-\\[placement\\=left\\]\\:before\\:top-1\\/2[data-placement="left"]::before {
  content: var(--tw-content);
  top: 50%;
}
.data-\\[placement\\=right-end\\]\\:before\\:-left-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_3px\\)\\][data-placement="right-end"]::before {
  content: var(--tw-content);
  left: calc(calc(1.25rem / 4 - 3px) * -1);
}
.data-\\[placement\\=right-end\\]\\:before\\:bottom-1\\/4[data-placement="right-end"]::before {
  content: var(--tw-content);
  bottom: 25%;
}
.data-\\[placement\\=right-start\\]\\:before\\:-left-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_3px\\)\\][data-placement="right-start"]::before {
  content: var(--tw-content);
  left: calc(calc(1.25rem / 4 - 3px) * -1);
}
.data-\\[placement\\=right-start\\]\\:before\\:top-1\\/4[data-placement="right-start"]::before {
  content: var(--tw-content);
  top: 25%;
}
.data-\\[placement\\=right\\]\\:before\\:-left-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_2px\\)\\][data-placement="right"]::before {
  content: var(--tw-content);
  left: calc(calc(1.25rem / 4 - 2px) * -1);
}
.data-\\[placement\\=right\\]\\:before\\:top-1\\/2[data-placement="right"]::before {
  content: var(--tw-content);
  top: 50%;
}
.data-\\[placement\\=top-end\\]\\:before\\:-bottom-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="top-end"]::before {
  content: var(--tw-content);
  bottom: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=top-end\\]\\:before\\:right-3[data-placement="top-end"]::before {
  content: var(--tw-content);
  right: 0.75rem;
}
.data-\\[placement\\=top-start\\]\\:before\\:-bottom-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="top-start"]::before {
  content: var(--tw-content);
  bottom: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=top-start\\]\\:before\\:left-3[data-placement="top-start"]::before {
  content: var(--tw-content);
  left: 0.75rem;
}
.data-\\[placement\\=top\\]\\:before\\:-bottom-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement="top"]::before {
  content: var(--tw-content);
  bottom: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=top\\]\\:before\\:left-1\\/2[data-placement="top"]::before {
  content: var(--tw-content);
  left: 50%;
}
.data-\\[loaded\\=true\\]\\:before\\:-z-10[data-loaded="true"]::before {
  content: var(--tw-content);
  z-index: -10;
}
.data-\\[arrow\\=true\\]\\:before\\:block[data-arrow="true"]::before {
  content: var(--tw-content);
  display: block;
}
.data-\\[outside-month\\=true\\]\\:before\\:hidden[data-outside-month="true"]::before {
  content: var(--tw-content);
  display: none;
}
.data-\\[placement\\=bottom-center\\]\\:before\\:h-\\[var\\(--top-extension\\2c 16px\\)\\][data-placement="bottom-center"]::before {
  content: var(--tw-content);
  height: var(--top-extension,16px);
}
.data-\\[placement\\=bottom-left\\]\\:before\\:h-\\[var\\(--top-extension\\2c 16px\\)\\][data-placement="bottom-left"]::before {
  content: var(--tw-content);
  height: var(--top-extension,16px);
}
.data-\\[placement\\=bottom-right\\]\\:before\\:h-\\[var\\(--top-extension\\2c 16px\\)\\][data-placement="bottom-right"]::before {
  content: var(--tw-content);
  height: var(--top-extension,16px);
}
.data-\\[placement\\=bottom\\]\\:before\\:-translate-x-1\\/2[data-placement="bottom"]::before {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[placement\\=left\\]\\:before\\:-translate-y-1\\/2[data-placement="left"]::before {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[placement\\=right\\]\\:before\\:-translate-y-1\\/2[data-placement="right"]::before {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[placement\\=top\\]\\:before\\:-translate-x-1\\/2[data-placement="top"]::before {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[loaded\\=true\\]\\:before\\:animate-none[data-loaded="true"]::before {
  content: var(--tw-content);
  animation: none;
}
.data-\\[range-end\\=true\\]\\:before\\:rounded-e-full[data-range-end="true"]::before {
  content: var(--tw-content);
  border-start-end-radius: 9999px;
  border-end-end-radius: 9999px;
}
.data-\\[range-start\\=true\\]\\:before\\:rounded-s-full[data-range-start="true"]::before {
  content: var(--tw-content);
  border-start-start-radius: 9999px;
  border-end-start-radius: 9999px;
}
.data-\\[selection-end\\=true\\]\\:before\\:rounded-e-full[data-selection-end="true"]::before {
  content: var(--tw-content);
  border-start-end-radius: 9999px;
  border-end-end-radius: 9999px;
}
.data-\\[selection-start\\=true\\]\\:before\\:rounded-s-full[data-selection-start="true"]::before {
  content: var(--tw-content);
  border-start-start-radius: 9999px;
  border-end-start-radius: 9999px;
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-danger-50[data-range-selection="true"][data-selected="true"]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-foreground\\/10[data-range-selection="true"][data-selected="true"]::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-foreground) / 0.1);
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-primary-50[data-range-selection="true"][data-selected="true"]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-50) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-secondary-50[data-range-selection="true"][data-selected="true"]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-50) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-success-100[data-range-selection="true"][data-selected="true"]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-100) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-warning-100[data-range-selection="true"][data-selected="true"]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-100) / var(--tw-bg-opacity, 1));
}
.data-\\[loaded\\=true\\]\\:before\\:opacity-0[data-loaded="true"]::before {
  content: var(--tw-content);
  opacity: 0;
}
.data-\\[selected\\=true\\]\\:before\\:opacity-100[data-selected="true"]::before {
  content: var(--tw-content);
  opacity: 1;
}
.data-\\[placement\\=bottom-center\\]\\:after\\:bottom-\\[calc\\(-1\\*var\\(--bottom-extension\\2c 16px\\)\\)\\][data-placement="bottom-center"]::after {
  content: var(--tw-content);
  bottom: calc(-1 * var(--bottom-extension,16px));
}
.data-\\[placement\\=bottom-left\\]\\:after\\:bottom-\\[calc\\(-1\\*var\\(--bottom-extension\\2c 16px\\)\\)\\][data-placement="bottom-left"]::after {
  content: var(--tw-content);
  bottom: calc(-1 * var(--bottom-extension,16px));
}
.data-\\[placement\\=bottom-right\\]\\:after\\:bottom-\\[calc\\(-1\\*var\\(--bottom-extension\\2c 16px\\)\\)\\][data-placement="bottom-right"]::after {
  content: var(--tw-content);
  bottom: calc(-1 * var(--bottom-extension,16px));
}
.data-\\[placement\\=bottom-center\\]\\:after\\:h-\\[var\\(--bottom-extension\\2c 16px\\)\\][data-placement="bottom-center"]::after {
  content: var(--tw-content);
  height: var(--bottom-extension,16px);
}
.data-\\[placement\\=bottom-left\\]\\:after\\:h-\\[var\\(--bottom-extension\\2c 16px\\)\\][data-placement="bottom-left"]::after {
  content: var(--tw-content);
  height: var(--bottom-extension,16px);
}
.data-\\[placement\\=bottom-right\\]\\:after\\:h-\\[var\\(--bottom-extension\\2c 16px\\)\\][data-placement="bottom-right"]::after {
  content: var(--tw-content);
  height: var(--bottom-extension,16px);
}
.data-\\[active\\=true\\]\\:after\\:w-full[data-active="true"]::after {
  content: var(--tw-content);
  width: 100%;
}
.data-\\[focus\\=true\\]\\:after\\:w-full[data-focus="true"]::after {
  content: var(--tw-content);
  width: 100%;
}
.data-\\[open\\=true\\]\\:after\\:w-full[data-open="true"]::after {
  content: var(--tw-content);
  width: 100%;
}
.data-\\[dragging\\=true\\]\\:after\\:scale-100[data-dragging="true"]::after {
  content: var(--tw-content);
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[dragging\\=true\\]\\:after\\:scale-80[data-dragging="true"]::after {
  content: var(--tw-content);
  --tw-scale-x: 0.8;
  --tw-scale-y: 0.8;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[active\\=true\\]\\:after\\:bg-danger-400[data-active="true"]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-400) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:after\\:bg-danger[data-selected="true"]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:after\\:bg-foreground[data-selected="true"]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-foreground) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:after\\:bg-primary[data-selected="true"]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:after\\:bg-secondary[data-selected="true"]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:after\\:bg-success[data-selected="true"]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\=true\\]\\:after\\:bg-warning[data-selected="true"]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--tw-bg-opacity, 1));
}
.data-\\[loaded\\=true\\]\\:after\\:opacity-0[data-loaded="true"]::after {
  content: var(--tw-content);
  opacity: 0;
}
.data-\\[selected\\=true\\]\\:after\\:opacity-100[data-selected="true"]::after {
  content: var(--tw-content);
  opacity: 1;
}
.data-\\[selectable\\=true\\]\\:focus\\:border-danger:focus[data-selectable="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:border-default:focus[data-selectable="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default) / var(--tw-border-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:border-primary:focus[data-selectable="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:border-secondary:focus[data-selectable="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:border-success:focus[data-selectable="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:border-warning:focus[data-selectable="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.data-\\[invalid\\=true\\]\\:focus\\:bg-danger-400\\/50:focus[data-invalid="true"] {
  background-color: hsl(var(--heroui-danger-400) / 0.5);
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-\\[transparent\\]:focus[data-selectable="true"] {
  background-color: transparent;
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-danger:focus[data-selectable="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-danger\\/20:focus[data-selectable="true"] {
  background-color: hsl(var(--heroui-danger) / 0.2);
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-default:focus[data-selectable="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default) / var(--tw-bg-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-default-100:focus[data-selectable="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--tw-bg-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-default-50:focus[data-selectable="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-50) / var(--tw-bg-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-default\\/40:focus[data-selectable="true"] {
  background-color: hsl(var(--heroui-default) / 0.4);
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-primary:focus[data-selectable="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--tw-bg-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-primary\\/20:focus[data-selectable="true"] {
  background-color: hsl(var(--heroui-primary) / 0.2);
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-secondary:focus[data-selectable="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--tw-bg-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-secondary\\/20:focus[data-selectable="true"] {
  background-color: hsl(var(--heroui-secondary) / 0.2);
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-success:focus[data-selectable="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--tw-bg-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-success\\/20:focus[data-selectable="true"] {
  background-color: hsl(var(--heroui-success) / 0.2);
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-warning:focus[data-selectable="true"] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--tw-bg-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:bg-warning\\/20:focus[data-selectable="true"] {
  background-color: hsl(var(--heroui-warning) / 0.2);
}
.data-\\[editable\\=true\\]\\:focus\\:text-danger:focus[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:focus\\:text-default-foreground:focus[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:focus\\:text-primary:focus[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:focus\\:text-secondary:focus[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:focus\\:text-success:focus[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:focus\\:text-success-600:focus[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-600) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:focus\\:text-warning:focus[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning) / var(--tw-text-opacity, 1));
}
.data-\\[editable\\=true\\]\\:focus\\:text-warning-600:focus[data-editable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-600) / var(--tw-text-opacity, 1));
}
.data-\\[invalid\\=true\\]\\:data-\\[editable\\=true\\]\\:focus\\:text-danger:focus[data-editable="true"][data-invalid="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--tw-text-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-danger:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--tw-text-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-danger-foreground:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-default-500:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-500) / var(--tw-text-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-default-foreground:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-primary:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--tw-text-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-primary-foreground:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-secondary:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--tw-text-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-secondary-foreground:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-success:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success) / var(--tw-text-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-success-foreground:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-warning:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning) / var(--tw-text-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:text-warning-foreground:focus[data-selectable="true"] {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selectable\\=true\\]\\:focus\\:shadow-danger\\/30:focus[data-selectable="true"] {
  --tw-shadow-color: hsl(var(--heroui-danger) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selectable\\=true\\]\\:focus\\:shadow-default\\/50:focus[data-selectable="true"] {
  --tw-shadow-color: hsl(var(--heroui-default) / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selectable\\=true\\]\\:focus\\:shadow-primary\\/30:focus[data-selectable="true"] {
  --tw-shadow-color: hsl(var(--heroui-primary) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selectable\\=true\\]\\:focus\\:shadow-secondary\\/30:focus[data-selectable="true"] {
  --tw-shadow-color: hsl(var(--heroui-secondary) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selectable\\=true\\]\\:focus\\:shadow-success\\/30:focus[data-selectable="true"] {
  --tw-shadow-color: hsl(var(--heroui-success) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selectable\\=true\\]\\:focus\\:shadow-warning\\/30:focus[data-selectable="true"] {
  --tw-shadow-color: hsl(var(--heroui-warning) / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:pointer-events-auto {
  pointer-events: auto;
}
.group[data-has-label-outside="true"] .group-data-\\[has-label-outside\\=true\\]\\:pointer-events-auto {
  pointer-events: auto;
}
.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:pointer-events-auto {
  pointer-events: auto;
}
.group[data-has-helper="true"] .group-data-\\[has-helper\\=true\\]\\:relative {
  position: relative;
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:start-0 {
  inset-inline-start: 0px;
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:start-0 {
  inset-inline-start: 0px;
}
.group[data-has-end-content="true"] .group-data-\\[has-end-content\\=true\\]\\:left-2 {
  left: 0.5rem;
}
.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:z-10 {
  z-index: 10;
}
.group[data-has-end-content="true"] .group-data-\\[has-end-content\\=true\\]\\:mt-4 {
  margin-top: 1rem;
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:ms-4 {
  margin-inline-start: 1rem;
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:ms-5 {
  margin-inline-start: 1.25rem;
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:ms-6 {
  margin-inline-start: 1.5rem;
}
.group[data-selected][data-pressed] .group-data-\\[selected\\]\\:group-data-\\[pressed\\]\\:ml-3 {
  margin-left: 0.75rem;
}
.group[data-selected][data-pressed] .group-data-\\[selected\\]\\:group-data-\\[pressed\\]\\:ml-4 {
  margin-left: 1rem;
}
.group[data-selected][data-pressed] .group-data-\\[selected\\]\\:group-data-\\[pressed\\]\\:ml-5 {
  margin-left: 1.25rem;
}
.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:block {
  display: block;
}
.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:block {
  display: block;
}
.group[data-has-helper="true"] .group-data-\\[has-helper\\=true\\]\\:flex {
  display: flex;
}
.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:hidden {
  display: none;
}
.group[data-pressed="true"] .group-data-\\[pressed\\=true\\]\\:w-5 {
  width: 1.25rem;
}
.group[data-pressed="true"] .group-data-\\[pressed\\=true\\]\\:w-6 {
  width: 1.5rem;
}
.group[data-pressed="true"] .group-data-\\[pressed\\=true\\]\\:w-7 {
  width: 1.75rem;
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_1\\.5rem\\/2_\\+_20px\\)\\] {
  --tw-translate-y: calc(calc(100% + 1.5rem / 2 + 20px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_var\\(--heroui-font-size-small\\)\\/2_\\+_20px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--heroui-font-size-small) / 2 + 20px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_var\\(--heroui-font-size-small\\)\\/2_\\+_24px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--heroui-font-size-small) / 2 + 24px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_var\\(--heroui-font-size-tiny\\)\\/2_\\+_16px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--heroui-font-size-tiny) / 2 + 16px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-small\\)\\/2_-_3\\.5px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 3.5px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-small\\)\\/2_-_4px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 4px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-small\\)\\/2_-_6px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 6px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-small\\)\\/2_-_6px_-_var\\(--heroui-border-width-medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 6px - var(--heroui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-small\\)\\/2_-_8px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 8px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-small\\)\\/2_-_8px_-_var\\(--heroui-border-width-medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 8px - var(--heroui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-tiny\\)\\/2_-_5px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-tiny) / 2 - 5px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-tiny\\)\\/2_-_8px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-tiny) / 2 - 8px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-tiny\\)\\/2_-_8px_-_var\\(--heroui-border-width-medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-tiny) / 2 - 8px - var(--heroui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-0 {
  --tw-translate-y: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_var\\(--heroui-font-size-small\\)\\/2_\\+_20px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--heroui-font-size-small) / 2 + 20px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+_var\\(--heroui-font-size-small\\)\\/2_\\+_24px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--heroui-font-size-small) / 2 + 24px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(100\\%_\\+var\\(--heroui-font-size-tiny\\)\\/2_\\+_16px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--heroui-font-size-tiny) / 2 + 16px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-small\\)\\/2_-_3\\.5px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 3.5px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-small\\)\\/2_-_4px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 4px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-small\\)\\/2_-_6px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 6px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-small\\)\\/2_-_6px_-_var\\(--heroui-border-width-medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 6px - var(--heroui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-small\\)\\/2_-_8px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 8px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-small\\)\\/2_-_8px_-_var\\(--heroui-border-width-medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-small) / 2 - 8px - var(--heroui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-tiny\\)\\/2_-_5px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-tiny) / 2 - 5px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-tiny\\)\\/2_-_8px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-tiny) / 2 - 8px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:-translate-y-\\[calc\\(50\\%_\\+_var\\(--heroui-font-size-tiny\\)\\/2_-_8px_-_var\\(--heroui-border-width-medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--heroui-font-size-tiny) / 2 - 8px - var(--heroui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-has-helper="true"] .group-data-\\[has-helper\\=true\\]\\:-translate-y-0 {
  --tw-translate-y: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:translate-x-3 {
  --tw-translate-x: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-copied="true"] .group-data-\\[copied\\=true\\]\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-copied="true"] .group-data-\\[copied\\=true\\]\\:scale-50 {
  --tw-scale-x: .5;
  --tw-scale-y: .5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:scale-85 {
  --tw-scale-x: 0.85;
  --tw-scale-y: 0.85;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:scale-85 {
  --tw-scale-x: 0.85;
  --tw-scale-y: 0.85;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-pressed="true"] .group-data-\\[pressed\\=true\\]\\:scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group\\/tr[data-disabled="true"] .group-data-\\[disabled\\=true\\]\\/tr\\:cursor-not-allowed {
  cursor: not-allowed;
}
.group[data-has-multiple-months="true"] .group-data-\\[has-multiple-months\\=true\\]\\:flex-row {
  flex-direction: row;
}
.group[data-has-label="true"] .group-data-\\[has-label\\=true\\]\\:items-start {
  align-items: flex-start;
}
.group[data-has-label="true"] .group-data-\\[has-label\\=true\\]\\:items-end {
  align-items: flex-end;
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:\\!border-danger {
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1)) !important;
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-\\[\\#C2C2C2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(194 194 194 / var(--tw-border-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-danger {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-default-foreground {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-foreground) / var(--tw-border-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-primary {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-secondary {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-success {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:border-warning {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:border-danger {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-danger {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-default-500 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-500) / var(--tw-border-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-primary {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-secondary {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-success {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:border-warning {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:\\!bg-danger-50 {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--heroui-danger-50) / var(--tw-bg-opacity, 1)) !important;
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-danger-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--tw-bg-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-default-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--tw-bg-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-default-200 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-200) / var(--tw-bg-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-primary-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary-50) / var(--tw-bg-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-secondary-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary-50) / var(--tw-bg-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-success-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success-50) / var(--tw-bg-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-transparent {
  background-color: transparent;
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:bg-warning-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning-50) / var(--tw-bg-opacity, 1));
}
.group[data-hover-unselected="true"] .group-data-\\[hover-unselected\\=true\\]\\:bg-default-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--tw-bg-opacity, 1));
}
.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:bg-danger-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--tw-bg-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:\\!bg-yellowbuy {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 255 127 / var(--tw-bg-opacity, 1)) !important;
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-danger {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-default-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-400) / var(--tw-bg-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-primary {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-primary) / var(--tw-bg-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-secondary {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-secondary) / var(--tw-bg-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-success {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-success) / var(--tw-bg-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:bg-warning {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-warning) / var(--tw-bg-opacity, 1));
}
.group[data-has-helper="true"] .group-data-\\[has-helper\\=true\\]\\:pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.group[data-has-helper="true"] .group-data-\\[has-helper\\=true\\]\\:pe-2 {
  padding-inline-end: 0.5rem;
}
.group[data-has-helper="true"] .group-data-\\[has-helper\\=true\\]\\:pt-2 {
  padding-top: 0.5rem;
}
.group[data-has-helper="true"] .group-data-\\[has-helper\\=true\\]\\:pt-3 {
  padding-top: 0.75rem;
}
.group[data-has-helper="true"] .group-data-\\[has-helper\\=true\\]\\:pt-4 {
  padding-top: 1rem;
}
.group[data-has-label="true"] .group-data-\\[has-label\\=true\\]\\:pt-4 {
  padding-top: 1rem;
}
.group[data-has-label="true"] .group-data-\\[has-label\\=true\\]\\:pt-5 {
  padding-top: 1.25rem;
}
.group\\/tr[data-disabled="true"] .group-data-\\[disabled\\=true\\]\\/tr\\:text-foreground-300 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground-300) / var(--tw-text-opacity, 1));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:text-\\[\\#6A6A6A\\] {
  --tw-text-opacity: 1;
  color: rgb(106 106 106 / var(--tw-text-opacity, 1));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:text-default-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-600) / var(--tw-text-opacity, 1));
}
.group[data-filled-within="true"] .group-data-\\[filled-within\\=true\\]\\:text-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground) / var(--tw-text-opacity, 1));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:text-default-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-600) / var(--tw-text-opacity, 1));
}
.group[data-filled="true"] .group-data-\\[filled\\=true\\]\\:text-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground) / var(--tw-text-opacity, 1));
}
.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:text-default-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--tw-text-opacity, 1));
}
.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:text-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground) / var(--tw-text-opacity, 1));
}
.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:text-danger {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--tw-text-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-danger {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--tw-text-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-danger-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger-foreground) / var(--tw-text-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-default-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-default-foreground) / var(--tw-text-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-foreground) / var(--tw-text-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-primary {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary) / var(--tw-text-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-primary-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-primary-foreground) / var(--tw-text-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-secondary {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary) / var(--tw-text-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-secondary-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-secondary-foreground) / var(--tw-text-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-success {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success) / var(--tw-text-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-success-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-success-foreground) / var(--tw-text-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-warning {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning) / var(--tw-text-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:text-warning-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-warning-foreground) / var(--tw-text-opacity, 1));
}
.group[data-copied="true"] .group-data-\\[copied\\=true\\]\\:opacity-0 {
  opacity: 0;
}
.group[data-copied="true"] .group-data-\\[copied\\=true\\]\\:opacity-100 {
  opacity: 1;
}
.group[data-has-value="true"] .group-data-\\[has-value\\=true\\]\\:opacity-70 {
  opacity: 0.7;
}
.group\\/th[data-hover="true"] .group-data-\\[hover\\=true\\]\\/th\\:opacity-100 {
  opacity: 1;
}
.group[data-loaded="true"] .group-data-\\[loaded\\=true\\]\\:opacity-100 {
  opacity: 1;
}
.group[data-pressed="true"] .group-data-\\[pressed\\=true\\]\\:opacity-70 {
  opacity: 0.7;
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:opacity-0 {
  opacity: 0;
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:opacity-100 {
  opacity: 1;
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:opacity-60 {
  opacity: 0.6;
}
.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:ring-focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--heroui-focus) / var(--tw-ring-opacity, 1));
}
.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:ring-offset-2 {
  --tw-ring-offset-width: 2px;
}
.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:ring-offset-background {
  --tw-ring-offset-color: hsl(var(--heroui-background) / 1);
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:before\\:-z-10::before {
  content: var(--tw-content);
  z-index: -10;
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:before\\:w-full::before {
  content: var(--tw-content);
  width: 100%;
}
.group[data-open="true"] .group-data-\\[open\\=true\\]\\:before\\:translate-y-px::before {
  content: var(--tw-content);
  --tw-translate-y: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-open="true"] .group-data-\\[open\\=true\\]\\:before\\:rotate-45::before {
  content: var(--tw-content);
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group\\/tr[data-middle="true"] .group-data-\\[middle\\=true\\]\\/tr\\:before\\:rounded-none::before {
  content: var(--tw-content);
  border-radius: 0px;
}
.group[data-hover="true"] .group-data-\\[hover\\=true\\]\\:before\\:bg-default-100::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--tw-bg-opacity, 1));
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:before\\:bg-default-100::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--tw-bg-opacity, 1));
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:before\\:opacity-100::before {
  content: var(--tw-content);
  opacity: 1;
}
.group[data-required="true"] .group-data-\\[required\\=true\\]\\:after\\:ml-0\\.5::after {
  content: var(--tw-content);
  margin-left: 0.125rem;
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:after\\:w-full::after {
  content: var(--tw-content);
  width: 100%;
}
.group[data-open="true"] .group-data-\\[open\\=true\\]\\:after\\:translate-y-0::after {
  content: var(--tw-content);
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-open="true"] .group-data-\\[open\\=true\\]\\:after\\:-rotate-45::after {
  content: var(--tw-content);
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:after\\:scale-100::after {
  content: var(--tw-content);
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:after\\:bg-danger::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1));
}
.group[data-required="true"] .group-data-\\[required\\=true\\]\\:after\\:text-danger::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--heroui-danger) / var(--tw-text-opacity, 1));
}
.group[data-selected="true"] .group-data-\\[selected\\=true\\]\\:after\\:opacity-100::after {
  content: var(--tw-content);
  opacity: 1;
}
.group[data-required="true"] .group-data-\\[required\\=true\\]\\:after\\:content-\\[\\'\\*\\'\\]::after {
  --tw-content: '*';
  content: var(--tw-content);
}
.group\\/tr[data-first="true"] .group-data-\\[first\\=true\\]\\/tr\\:first\\:before\\:rounded-none:first-child::before {
  content: var(--tw-content);
  border-radius: 0px;
}
.group\\/tr[data-last="true"] .group-data-\\[last\\=true\\]\\/tr\\:first\\:before\\:rounded-none:first-child::before {
  content: var(--tw-content);
  border-radius: 0px;
}
.group\\/tr[data-first="true"] .group-data-\\[first\\=true\\]\\/tr\\:first\\:before\\:rounded-ss-lg:first-child::before {
  content: var(--tw-content);
  border-start-start-radius: 0.5rem;
}
.group\\/tr[data-first="true"] .group-data-\\[first\\=true\\]\\/tr\\:first\\:before\\:rounded-ss-none:first-child::before {
  content: var(--tw-content);
  border-start-start-radius: 0px;
}
.group\\/tr[data-last="true"] .group-data-\\[last\\=true\\]\\/tr\\:first\\:before\\:rounded-es-lg:first-child::before {
  content: var(--tw-content);
  border-end-start-radius: 0.5rem;
}
.group\\/tr[data-last="true"] .group-data-\\[last\\=true\\]\\/tr\\:first\\:before\\:rounded-es-none:first-child::before {
  content: var(--tw-content);
  border-end-start-radius: 0px;
}
.group\\/tr[data-first="true"] .group-data-\\[first\\=true\\]\\/tr\\:last\\:before\\:rounded-none:last-child::before {
  content: var(--tw-content);
  border-radius: 0px;
}
.group\\/tr[data-last="true"] .group-data-\\[last\\=true\\]\\/tr\\:last\\:before\\:rounded-none:last-child::before {
  content: var(--tw-content);
  border-radius: 0px;
}
.group\\/tr[data-first="true"] .group-data-\\[first\\=true\\]\\/tr\\:last\\:before\\:rounded-se-lg:last-child::before {
  content: var(--tw-content);
  border-start-end-radius: 0.5rem;
}
.group\\/tr[data-first="true"] .group-data-\\[first\\=true\\]\\/tr\\:last\\:before\\:rounded-se-none:last-child::before {
  content: var(--tw-content);
  border-start-end-radius: 0px;
}
.group\\/tr[data-last="true"] .group-data-\\[last\\=true\\]\\/tr\\:last\\:before\\:rounded-ee-lg:last-child::before {
  content: var(--tw-content);
  border-end-end-radius: 0.5rem;
}
.group\\/tr[data-last="true"] .group-data-\\[last\\=true\\]\\/tr\\:last\\:before\\:rounded-ee-none:last-child::before {
  content: var(--tw-content);
  border-end-end-radius: 0px;
}
.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:hover\\:border-danger:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:hover\\:bg-danger-100:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-100) / var(--tw-bg-opacity, 1));
}
.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:focus-within\\:hover\\:border-danger:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.group[data-invalid="true"] .group-data-\\[invalid\\=true\\]\\:focus-within\\:hover\\:bg-danger-50:hover:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-danger-50) / var(--tw-bg-opacity, 1));
}
.group\\/tr[aria-selected="false"][data-hover="true"] .group-aria-\\[selected\\=false\\]\\/tr\\:group-data-\\[hover\\=true\\]\\/tr\\:before\\:bg-default-100::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--tw-bg-opacity, 1));
}
.group\\/tr[aria-selected="false"][data-hover="true"] .group-aria-\\[selected\\=false\\]\\/tr\\:group-data-\\[hover\\=true\\]\\/tr\\:before\\:opacity-70::before {
  content: var(--tw-content);
  opacity: 0.7;
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:data-\\[hover\\=true\\]\\:border-danger[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-danger) / var(--tw-border-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:data-\\[hover\\=true\\]\\:border-default-foreground[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-default-foreground) / var(--tw-border-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:data-\\[hover\\=true\\]\\:border-primary[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-primary) / var(--tw-border-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:data-\\[hover\\=true\\]\\:border-secondary[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-secondary) / var(--tw-border-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:data-\\[hover\\=true\\]\\:border-success[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-success) / var(--tw-border-opacity, 1));
}
.group[data-focus="true"] .group-data-\\[focus\\=true\\]\\:data-\\[hover\\=true\\]\\:border-warning[data-hover="true"] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--heroui-warning) / var(--tw-border-opacity, 1));
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-danger\\/20[data-selected="true"]::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-danger) / 0.2);
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-default\\/60[data-selected="true"]::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-default) / 0.6);
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-primary\\/20[data-selected="true"]::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-primary) / 0.2);
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-secondary\\/20[data-selected="true"]::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-secondary) / 0.2);
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-success\\/20[data-selected="true"]::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-success) / 0.2);
}
.group\\/tr[data-odd="true"] .group-data-\\[odd\\=true\\]\\/tr\\:data-\\[selected\\=true\\]\\/tr\\:before\\:bg-warning\\/20[data-selected="true"]::before {
  content: var(--tw-content);
  background-color: hsl(var(--heroui-warning) / 0.2);
}
.peer[data-filled="true"] ~ .peer-data-\\[filled\\=true\\]\\:pointer-events-none {
  pointer-events: none;
}
.peer[data-filled="true"] ~ .peer-data-\\[filled\\=true\\]\\:pointer-events-auto {
  pointer-events: auto;
}
.peer[data-filled="true"] ~ .peer-data-\\[filled\\=true\\]\\:block {
  display: block;
}
.peer[data-filled="true"] ~ .peer-data-\\[filled\\=true\\]\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer[data-filled="true"] ~ .peer-data-\\[filled\\=true\\]\\:opacity-70 {
  opacity: 0.7;
}
@media (prefers-reduced-motion: reduce) {

  .motion-reduce\\:scale-100 {
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .motion-reduce\\:transition-none {
    transition-property: none;
  }

  .motion-reduce\\:after\\:transition-none::after {
    content: var(--tw-content);
    transition-property: none;
  }
}
@media (min-width: 360px) {

  .xs\\:gap-4 {
    gap: 1rem;
  }
}
@media (min-width: 576px) {

  .sm\\:absolute {
    position: absolute;
  }

  .sm\\:right-0 {
    right: 0px;
  }

  .sm\\:top-0 {
    top: 0px;
  }

  .sm\\:m-0 {
    margin: 0px;
  }

  .sm\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .sm\\:mx-6 {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .sm\\:my-0 {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .sm\\:my-16 {
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .sm\\:mb-\\[-2\\.75rem\\] {
    margin-bottom: -2.75rem;
  }

  .sm\\:grid {
    display: grid;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-14 {
    height: 3.5rem;
  }

  .sm\\:h-6 {
    height: 1.5rem;
  }

  .sm\\:h-\\[6rem\\] {
    height: 6rem;
  }

  .sm\\:w-14 {
    width: 3.5rem;
  }

  .sm\\:w-6 {
    width: 1.5rem;
  }

  .sm\\:w-\\[356px\\] {
    width: 356px;
  }

  .sm\\:w-\\[6rem\\] {
    width: 6rem;
  }

  .sm\\:w-\\[8rem\\] {
    width: 8rem;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:max-w-\\[100px\\] {
    max-width: 100px;
  }

  .sm\\:max-w-\\[250px\\] {
    max-width: 250px;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-end {
    align-items: flex-end;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:border-\\[0\\.375rem\\] {
    border-width: 0.375rem;
  }

  .sm\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .sm\\:pt-3 {
    padding-top: 0.75rem;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:\\[--scale-enter\\:100\\%\\] {
    --scale-enter: 100%;
  }

  .sm\\:\\[--scale-exit\\:103\\%\\] {
    --scale-exit: 103%;
  }

  .sm\\:\\[--slide-enter\\:0px\\] {
    --slide-enter: 0px;
  }

  .sm\\:\\[--slide-exit\\:0px\\] {
    --slide-exit: 0px;
  }

  .sm\\:data-\\[visible\\=true\\]\\:pointer-events-none[data-visible="true"] {
    pointer-events: none;
  }

  .sm\\:data-\\[placement\\=bottom-center\\]\\:mx-auto[data-placement="bottom-center"] {
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:data-\\[placement\\=top-center\\]\\:mx-auto[data-placement="top-center"] {
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:data-\\[placement\\=bottom-left\\]\\:ml-2[data-placement="bottom-left"] {
    margin-left: 0.5rem;
  }

  .sm\\:data-\\[placement\\=bottom-right\\]\\:mr-2[data-placement="bottom-right"] {
    margin-right: 0.5rem;
  }

  .sm\\:data-\\[placement\\=top-left\\]\\:ml-2[data-placement="top-left"] {
    margin-left: 0.5rem;
  }

  .sm\\:data-\\[placement\\=top-right\\]\\:mr-2[data-placement="top-right"] {
    margin-right: 0.5rem;
  }

  .sm\\:data-\\[placement\\=bottom-center\\]\\:w-max[data-placement="bottom-center"] {
    width: max-content;
  }

  .sm\\:data-\\[placement\\=bottom-left\\]\\:w-max[data-placement="bottom-left"] {
    width: max-content;
  }

  .sm\\:data-\\[placement\\=bottom-right\\]\\:w-max[data-placement="bottom-right"] {
    width: max-content;
  }

  .sm\\:data-\\[placement\\=top-center\\]\\:w-max[data-placement="top-center"] {
    width: max-content;
  }

  .sm\\:data-\\[placement\\=top-left\\]\\:w-max[data-placement="top-left"] {
    width: max-content;
  }

  .sm\\:data-\\[placement\\=top-right\\]\\:w-max[data-placement="top-right"] {
    width: max-content;
  }

  .sm\\:data-\\[visible\\=true\\]\\:opacity-0[data-visible="true"] {
    opacity: 0;
  }

  .group[data-hover="true"] .sm\\:group-data-\\[hover\\=true\\]\\:data-\\[visible\\=true\\]\\:pointer-events-auto[data-visible="true"] {
    pointer-events: auto;
  }

  .group[data-hover="true"] .sm\\:group-data-\\[hover\\=true\\]\\:data-\\[visible\\=true\\]\\:opacity-100[data-visible="true"] {
    opacity: 1;
  }
}
@media (min-width: 767px) {

  .md\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .md\\:mt-\\[-10\\.5rem\\] {
    margin-top: -10.5rem;
  }

  .md\\:h-\\[12rem\\] {
    height: 12rem;
  }

  .md\\:h-\\[16rem\\] {
    height: 16rem;
  }

  .md\\:w-\\[12rem\\] {
    width: 12rem;
  }

  .md\\:w-\\[7rem\\] {
    width: 7rem;
  }

  .md\\:w-\\[calc\\(100\\%-7rem\\)\\] {
    width: calc(100% - 7rem);
  }

  .md\\:w-\\[calc\\(50\\%-0\\.5rem\\)\\] {
    width: calc(50% - 0.5rem);
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:p-5 {
    padding: 1.25rem;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:text-\\[2rem\\] {
    font-size: 2rem;
  }

  .md\\:text-\\[6rem\\] {
    font-size: 6rem;
  }
}
@media (min-width: 992px) {

  .lg\\:static {
    position: static;
  }

  .lg\\:z-\\[0\\] {
    z-index: 0;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-0 {
    height: 0px;
  }

  .lg\\:h-10 {
    height: 2.5rem;
  }

  .lg\\:h-20 {
    height: 5rem;
  }

  .lg\\:h-\\[25\\.25rem\\] {
    height: 25.25rem;
  }

  .lg\\:h-\\[30rem\\] {
    height: 30rem;
  }

  .lg\\:w-10 {
    width: 2.5rem;
  }

  .lg\\:w-20 {
    width: 5rem;
  }

  .lg\\:w-\\[17rem\\] {
    width: 17rem;
  }

  .lg\\:w-\\[50\\%\\] {
    width: 50%;
  }

  .lg\\:w-\\[calc\\(100\\%-17\\.5rem\\)\\] {
    width: calc(100% - 17.5rem);
  }

  .lg\\:min-w-\\[11\\.875rem\\] {
    min-width: 11.875rem;
  }

  .lg\\:max-w-\\[150px\\] {
    max-width: 150px;
  }

  .lg\\:max-w-\\[300px\\] {
    max-width: 300px;
  }

  .lg\\:max-w-\\[30rem\\] {
    max-width: 30rem;
  }

  .lg\\:max-w-md {
    max-width: 28rem;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:gap-12 {
    gap: 3rem;
  }

  .lg\\:gap-16 {
    gap: 4rem;
  }

  .lg\\:gap-8 {
    gap: 2rem;
  }

  .lg\\:gap-x-12 {
    column-gap: 3rem;
  }

  .lg\\:overflow-hidden {
    overflow: hidden;
  }

  .lg\\:rounded-xl {
    border-radius: 0.75rem;
  }

  .lg\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .lg\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .group\\/item:hover .lg\\:group-hover\\/item\\:mt-\\[0\\.25rem\\] {
    margin-top: 0.25rem;
  }

  .group\\/item:hover .lg\\:group-hover\\/item\\:h-0 {
    height: 0px;
  }

  .group\\/item:hover .lg\\:group-hover\\/item\\:h-\\[20\\.5rem\\] {
    height: 20.5rem;
  }

  .group\\/item:hover .lg\\:group-hover\\/item\\:h-\\[2rem\\] {
    height: 2rem;
  }

  @media (min-width: 992px) {

    .group\\/item:hover .lg\\:group-hover\\/item\\:lg\\:h-\\[15\\.625rem\\] {
      height: 15.625rem;
    }
  }

  .group\\/item:hover .lg\\:group-hover\\/item\\:overflow-auto {
    overflow: auto;
  }

  .group\\/item:hover .lg\\:group-hover\\/item\\:overflow-hidden {
    overflow: hidden;
  }
}
@media (min-width: 1200px) {

  .xl\\:flex {
    display: flex;
  }

  .xl\\:hidden {
    display: none;
  }

  .xl\\:w-\\[40\\%\\] {
    width: 40%;
  }

  .xl\\:w-\\[60\\%\\] {
    width: 60%;
  }

  .xl\\:max-w-lg {
    max-width: 32rem;
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:gap-24 {
    gap: 6rem;
  }

  .xl\\:text-\\[7rem\\] {
    font-size: 7rem;
  }
}
.rtl\\:left-2:where([dir="rtl"], [dir="rtl"] *) {
  left: 0.5rem;
}
.rtl\\:right-auto:where([dir="rtl"], [dir="rtl"] *) {
  right: auto;
}
.rtl\\:origin-top-right:where([dir="rtl"], [dir="rtl"] *) {
  transform-origin: top right;
}
.rtl\\:-rotate-180:where([dir="rtl"], [dir="rtl"] *) {
  --tw-rotate: -180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:rotate-180:where([dir="rtl"], [dir="rtl"] *) {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:flex-row-reverse:where([dir="rtl"], [dir="rtl"] *) {
  flex-direction: row-reverse;
}
.rtl\\:space-x-reverse:where([dir="rtl"], [dir="rtl"] *) > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 1;
}
.rtl\\:data-\\[focus-visible\\=true\\]\\:translate-x-3[data-focus-visible="true"]:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:data-\\[hover\\=true\\]\\:translate-x-3[data-hover="true"]:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:data-\\[open\\=true\\]\\:-rotate-90[data-open="true"]:where([dir="rtl"], [dir="rtl"] *) {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@media (prefers-color-scheme: dark) {

  .dark\\:border-danger-100 {
    --tw-border-opacity: 1;
    border-color: hsl(var(--heroui-danger-100) / var(--tw-border-opacity, 1));
  }

  .dark\\:border-default-200 {
    --tw-border-opacity: 1;
    border-color: hsl(var(--heroui-default-200) / var(--tw-border-opacity, 1));
  }

  .dark\\:border-primary-100 {
    --tw-border-opacity: 1;
    border-color: hsl(var(--heroui-primary-100) / var(--tw-border-opacity, 1));
  }

  .dark\\:border-success-100 {
    --tw-border-opacity: 1;
    border-color: hsl(var(--heroui-success-100) / var(--tw-border-opacity, 1));
  }

  .dark\\:border-warning-100 {
    --tw-border-opacity: 1;
    border-color: hsl(var(--heroui-warning-100) / var(--tw-border-opacity, 1));
  }

  .dark\\:bg-background {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-background) / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-background\\/20 {
    background-color: hsl(var(--heroui-background) / 0.2);
  }

  .dark\\:bg-content2 {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-content2) / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-danger-100 {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-danger-100) / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-danger-50 {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-danger-50) / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-danger-50\\/50 {
    background-color: hsl(var(--heroui-danger-50) / 0.5);
  }

  .dark\\:bg-default {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-default) / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-default-100 {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-default-100) / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-default-50\\/50 {
    background-color: hsl(var(--heroui-default-50) / 0.5);
  }

  .dark\\:bg-primary-100 {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-primary-100) / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-primary-50 {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-primary-50) / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-primary-50\\/50 {
    background-color: hsl(var(--heroui-primary-50) / 0.5);
  }

  .dark\\:bg-secondary-100 {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-secondary-100) / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-secondary-50 {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-secondary-50) / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-secondary-50\\/50 {
    background-color: hsl(var(--heroui-secondary-50) / 0.5);
  }

  .dark\\:bg-success-100 {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-success-100) / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-success-50 {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-success-50) / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-success-50\\/50 {
    background-color: hsl(var(--heroui-success-50) / 0.5);
  }

  .dark\\:bg-transparent {
    background-color: transparent;
  }

  .dark\\:bg-warning-100 {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-warning-100) / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-warning-50 {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-warning-50) / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-warning-50\\/50 {
    background-color: hsl(var(--heroui-warning-50) / 0.5);
  }

  .dark\\:text-danger-500 {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-danger-500) / var(--tw-text-opacity, 1));
  }

  .dark\\:text-success {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-success) / var(--tw-text-opacity, 1));
  }

  .dark\\:text-warning {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-warning) / var(--tw-text-opacity, 1));
  }

  .dark\\:placeholder\\:text-danger-500::placeholder {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-danger-500) / var(--tw-text-opacity, 1));
  }

  .dark\\:placeholder\\:text-success::placeholder {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-success) / var(--tw-text-opacity, 1));
  }

  .dark\\:placeholder\\:text-warning::placeholder {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-warning) / var(--tw-text-opacity, 1));
  }

  .dark\\:before\\:via-default-700\\/10::before {
    content: var(--tw-content);
    --tw-gradient-to: hsl(var(--heroui-default-700) / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--heroui-default-700) / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
  }

  .dark\\:after\\:bg-content2::after {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-content2) / var(--tw-bg-opacity, 1));
  }

  .dark\\:autofill\\:\\[-webkit-text-fill-color\\:hsl\\(var\\(--heroui-foreground\\)\\)\\]:autofill {
    -webkit-text-fill-color: hsl(var(--heroui-foreground));
  }

  .dark\\:focus\\:bg-danger-400\\/20:focus {
    background-color: hsl(var(--heroui-danger-400) / 0.2);
  }

  .dark\\:focus\\:bg-success-400\\/20:focus {
    background-color: hsl(var(--heroui-success-400) / 0.2);
  }

  .dark\\:focus\\:bg-warning-400\\/20:focus {
    background-color: hsl(var(--heroui-warning-400) / 0.2);
  }

  .dark\\:data-\\[hover\\=true\\]\\:bg-content2[data-hover="true"] {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-content2) / var(--tw-bg-opacity, 1));
  }

  .dark\\:data-\\[hover\\=true\\]\\:bg-danger-50[data-hover="true"] {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-danger-50) / var(--tw-bg-opacity, 1));
  }

  .dark\\:data-\\[hover\\=true\\]\\:bg-default-50[data-hover="true"] {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-default-50) / var(--tw-bg-opacity, 1));
  }

  .dark\\:data-\\[hover\\=true\\]\\:bg-success-50[data-hover="true"] {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-success-50) / var(--tw-bg-opacity, 1));
  }

  .dark\\:data-\\[hover\\=true\\]\\:bg-warning-50[data-hover="true"] {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-warning-50) / var(--tw-bg-opacity, 1));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-danger[data-hover="true"][data-selected="true"] {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-danger) / var(--tw-bg-opacity, 1));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-success[data-hover="true"][data-selected="true"] {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-success) / var(--tw-bg-opacity, 1));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:bg-warning[data-hover="true"][data-selected="true"] {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-warning) / var(--tw-bg-opacity, 1));
  }

  .dark\\:data-\\[hover\\=true\\]\\:text-danger-500[data-hover="true"] {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-danger-500) / var(--tw-text-opacity, 1));
  }

  .dark\\:data-\\[hover\\=true\\]\\:text-success-500[data-hover="true"] {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-success-500) / var(--tw-text-opacity, 1));
  }

  .dark\\:data-\\[hover\\=true\\]\\:text-warning-500[data-hover="true"] {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-warning-500) / var(--tw-text-opacity, 1));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-danger-foreground[data-hover="true"][data-selected="true"] {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-danger-foreground) / var(--tw-text-opacity, 1));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-success-foreground[data-hover="true"][data-selected="true"] {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-success-foreground) / var(--tw-text-opacity, 1));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:text-warning-foreground[data-hover="true"][data-selected="true"] {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-warning-foreground) / var(--tw-text-opacity, 1));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-500[data-range-selection="true"][data-selected="true"] {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-success-500) / var(--tw-text-opacity, 1));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-foreground[data-range-selection="true"][data-selection-end="true"][data-selected="true"] {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-success-foreground) / var(--tw-text-opacity, 1));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:text-success-foreground[data-range-selection="true"][data-selection-start="true"][data-selected="true"] {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-success-foreground) / var(--tw-text-opacity, 1));
  }

  .dark\\:data-\\[selected\\=true\\]\\:text-danger-500[data-selected="true"] {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-danger-500) / var(--tw-text-opacity, 1));
  }

  .dark\\:data-\\[selected\\=true\\]\\:text-success[data-selected="true"] {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-success) / var(--tw-text-opacity, 1));
  }

  .dark\\:data-\\[selected\\=true\\]\\:text-warning[data-selected="true"] {
    --tw-text-opacity: 1;
    color: hsl(var(--heroui-warning) / var(--tw-text-opacity, 1));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-success-50[data-range-selection="true"][data-selected="true"]::before {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-success-50) / var(--tw-bg-opacity, 1));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:bg-warning-50[data-range-selection="true"][data-selected="true"]::before {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: hsl(var(--heroui-warning-50) / var(--tw-bg-opacity, 1));
  }

  .dark\\:data-\\[invalid\\=true\\]\\:focus\\:bg-danger-400\\/20:focus[data-invalid="true"] {
    background-color: hsl(var(--heroui-danger-400) / 0.2);
  }
}
.\\[\\&\\+\\.border-medium\\.border-danger\\]\\:ms-\\[calc\\(var\\(--heroui-border-width-medium\\)\\*-1\\)\\]+.border-medium.border-danger {
  margin-inline-start: calc(var(--heroui-border-width-medium) * -1);
}
.\\[\\&\\+\\.border-medium\\.border-default\\]\\:ms-\\[calc\\(var\\(--heroui-border-width-medium\\)\\*-1\\)\\]+.border-medium.border-default {
  margin-inline-start: calc(var(--heroui-border-width-medium) * -1);
}
.\\[\\&\\+\\.border-medium\\.border-primary\\]\\:ms-\\[calc\\(var\\(--heroui-border-width-medium\\)\\*-1\\)\\]+.border-medium.border-primary {
  margin-inline-start: calc(var(--heroui-border-width-medium) * -1);
}
.\\[\\&\\+\\.border-medium\\.border-secondary\\]\\:ms-\\[calc\\(var\\(--heroui-border-width-medium\\)\\*-1\\)\\]+.border-medium.border-secondary {
  margin-inline-start: calc(var(--heroui-border-width-medium) * -1);
}
.\\[\\&\\+\\.border-medium\\.border-success\\]\\:ms-\\[calc\\(var\\(--heroui-border-width-medium\\)\\*-1\\)\\]+.border-medium.border-success {
  margin-inline-start: calc(var(--heroui-border-width-medium) * -1);
}
.\\[\\&\\+\\.border-medium\\.border-warning\\]\\:ms-\\[calc\\(var\\(--heroui-border-width-medium\\)\\*-1\\)\\]+.border-medium.border-warning {
  margin-inline-start: calc(var(--heroui-border-width-medium) * -1);
}
.\\[\\&\\:\\:-ms-reveal\\]\\:hidden::-ms-reveal {
  display: none;
}
.\\[\\&\\:not\\(\\:first-child\\)\\:not\\(\\:last-child\\)\\]\\:rounded-none:not(:first-child):not(:last-child) {
  border-radius: 0px;
}
.\\[\\&\\:not\\(\\:first-child\\)\\]\\:-ml-1:not(:first-child) {
  margin-left: -0.25rem;
}
.\\[\\&\\:not\\(\\:first-of-type\\)\\:not\\(\\:last-of-type\\)\\]\\:rounded-none:not(:first-of-type):not(:last-of-type) {
  border-radius: 0px;
}
.\\[\\&\\:not\\(\\:first-of-type\\)\\]\\:ms-\\[calc\\(theme\\(borderWidth\\.2\\)\\*-1\\)\\]:not(:first-of-type) {
  margin-inline-start: calc(2px * -1);
}
.\\[\\&\\>\\*\\]\\:relative>* {
  position: relative;
}
.\\[\\&\\>svg\\]\\:max-w-\\[theme\\(spacing\\.8\\)\\]>svg {
  max-width: 2rem;
}
.\\[\\&\\>tr\\]\\:first\\:rounded-lg:first-child>tr {
  border-radius: 0.5rem;
}
.\\[\\&\\>tr\\]\\:first\\:shadow-small:first-child>tr {
  --tw-shadow: var(--heroui-box-shadow-small);
  --tw-shadow-colored: var(--heroui-box-shadow-small);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\[\\&\\[data-hover\\=true\\]\\:not\\(\\[data-active\\=true\\]\\)\\]\\:bg-default-100[data-hover=true]:not([data-active=true]) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-100) / var(--tw-bg-opacity, 1));
}
.\\[\\&\\[data-hover\\=true\\]\\:not\\(\\[data-active\\=true\\]\\)\\]\\:bg-default-200[data-hover=true]:not([data-active=true]) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--heroui-default-200) / var(--tw-bg-opacity, 1));
}
.\\[\\&_\\.chevron-icon\\]\\:flex-none .chevron-icon {
  flex: none;
}
.\\[\\&_\\.chevron-icon\\]\\:rotate-180 .chevron-icon {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\.chevron-icon\\]\\:transition-transform .chevron-icon {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}


`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,oCAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,oCAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd,8BAAc;EAAd,mCAAc;EAAd,yCAAc;EAAd,sCAAc;EAAd,yCAAc;EAAd,wCAAc;EAAd,yCAAc;EAAd,wCAAc;EAAd,yCAAc;EAAd,wCAAc;EAAd,sCAAc;EAAd,oDAAc;EAAd,4BAAc;EAAd,8CAAc;EAAd,yBAAc;EAAd,4BAAc;EAAd,6DAAc;EAAd,mCAAc;EAAd,6CAAc;EAAd,gCAAc;EAAd,8CAAc;EAAd,mCAAc;EAAd,6CAAc;EAAd,gCAAc;EAAd,sCAAc;EAAd,mCAAc;EAAd,sCAAc;EAAd,qCAAc;EAAd,sCAAc;EAAd,qCAAc;EAAd,sCAAc;EAAd,qCAAc;EAAd,mCAAc;EAAd,oCAAc;EAAd,kCAAc;EAAd,uCAAc;EAAd,sDAAc;EAAd,sDAAc;EAAd,0CAAc;EAAd,0CAAc;EAAd,oDAAc;EAAd,wCAAc;EAAd,wCAAc;EAAd,oDAAc;EAAd,mDAAc;EAAd,sCAAc;EAAd,gDAAc;EAAd,uCAAc;EAAd,yCAAc;EAAd,yCAAc;EAAd,yCAAc;EAAd,yCAAc;EAAd,yCAAc;EAAd,yCAAc;EAAd,yCAAc;EAAd,yCAAc;EAAd,wCAAc;EAAd,wCAAc;EAAd,qCAAc;EAAd,qDAAc;EAAd,qDAAc;EAAd,yCAAc;EAAd,sDAAc;EAAd,yCAAc;EAAd,sDAAc;EAAd,yCAAc;EAAd,sDAAc;EAAd,yCAAc;EAAd,qDAAc;EAAd,oCAAc;EAAd,kDAAc;EAAd,oDAAc;EAAd,qDAAc;EAAd,qDAAc;EAAd,qDAAc;EAAd,qDAAc;EAAd,oDAAc;EAAd,qDAAc;EAAd,qDAAc;EAAd,mDAAc;EAAd,mDAAc;EAAd,oCAAc;EAAd,gDAAc;EAAd,oCAAc;EAAd,sCAAc;EAAd,iDAAc;EAAd,wCAAc;EAAd,mCAAc;EAAd,qDAAc;EAAd,sCAAc;EAAd,yCAAc;EAAd,oDAAc;EAAd,sCAAc;EAAd,qCAAc;EAAd,iDAAc;EAAd,4BAAc;EAAd,6BAAc;EAAd,gCAAc;EAAd,kCAAc;EAAd,+BAAc;EAAd,kCAAc;EAAd,+BAAc;EAAd,mCAAc;EAAd,mCAAc;EAAd,mCAAc;EAAd,0BAAc;EAAd,4BAAc;EAAd,2BAAc;EAAd,gCAAc;EAAd,iCAAc;EAAd,gCAAc;EAAd,kIAAc;EAAd,oIAAc;EAAd,oIAAc;EAAd;AAAc;AAEd;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,UAAmB;IAAnB;EAAmB;;EAAnB;IAAA,aAAmB;IAAnB,2BAAmB;IAAnB,kCAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA,yBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,YAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iEAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,8BAAmB;EAAnB,mCAAmB;EAAnB,yCAAmB;EAAnB,sCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,sCAAmB;EAAnB,oDAAmB;EAAnB,4BAAmB;EAAnB,8CAAmB;EAAnB,yBAAmB;EAAnB,4BAAmB;EAAnB,6DAAmB;EAAnB,mCAAmB;EAAnB,6CAAmB;EAAnB,gCAAmB;EAAnB,8CAAmB;EAAnB,mCAAmB;EAAnB,6CAAmB;EAAnB,gCAAmB;EAAnB,sCAAmB;EAAnB,mCAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,mCAAmB;EAAnB,oCAAmB;EAAnB,kCAAmB;EAAnB,uCAAmB;EAAnB,sDAAmB;EAAnB,sDAAmB;EAAnB,0CAAmB;EAAnB,0CAAmB;EAAnB,oDAAmB;EAAnB,wCAAmB;EAAnB,wCAAmB;EAAnB,oDAAmB;EAAnB,mDAAmB;EAAnB,sCAAmB;EAAnB,gDAAmB;EAAnB,uCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,wCAAmB;EAAnB,qCAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,qDAAmB;EAAnB,oCAAmB;EAAnB,kDAAmB;EAAnB,oDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,oDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,mDAAmB;EAAnB,mDAAmB;EAAnB,oCAAmB;EAAnB,gDAAmB;EAAnB,oCAAmB;EAAnB,sCAAmB;EAAnB,iDAAmB;EAAnB,wCAAmB;EAAnB,mCAAmB;EAAnB,qDAAmB;EAAnB,sCAAmB;EAAnB,yCAAmB;EAAnB,oDAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,iDAAmB;EAAnB,4BAAmB;EAAnB,6BAAmB;EAAnB,gCAAmB;EAAnB,kCAAmB;EAAnB,+BAAmB;EAAnB,kCAAmB;EAAnB,+BAAmB;EAAnB,mCAAmB;EAAnB,mCAAmB;EAAnB,mCAAmB;EAAnB,0BAAmB;EAAnB,4BAAmB;EAAnB,2BAAmB;EAAnB,gCAAmB;EAAnB,iCAAmB;EAAnB,gCAAmB;EAAnB,kIAAmB;EAAnB,oIAAmB;EAAnB,oIAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4BAAmB;EAAnB,qCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,sCAAmB;EAAnB,yCAAmB;EAAnB,oCAAmB;EAAnB,qCAAmB;EAAnB,8CAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,gCAAmB;EAAnB,yCAAmB;EAAnB,kCAAmB;EAAnB,8CAAmB;EAAnB,mCAAmB;EAAnB,2CAAmB;EAAnB,kCAAmB;EAAnB,8CAAmB;EAAnB,kCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,mCAAmB;EAAnB,sCAAmB;EAAnB,iCAAmB;EAAnB,sCAAmB;EAAnB,kCAAmB;EAAnB,kDAAmB;EAAnB,oDAAmB;EAAnB,wCAAmB;EAAnB,wCAAmB;EAAnB,oDAAmB;EAAnB,0CAAmB;EAAnB,0CAAmB;EAAnB,sDAAmB;EAAnB,sDAAmB;EAAnB,wCAAmB;EAAnB,sCAAmB;EAAnB,gDAAmB;EAAnB,uCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,wCAAmB;EAAnB,qCAAmB;EAAnB,oDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,qDAAmB;EAAnB,sDAAmB;EAAnB,oCAAmB;EAAnB,kDAAmB;EAAnB,kDAAmB;EAAnB,mDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,oDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,oCAAmB;EAAnB,gDAAmB;EAAnB,qCAAmB;EAAnB,oDAAmB;EAAnB,yCAAmB;EAAnB,sCAAmB;EAAnB,qDAAmB;EAAnB,mCAAmB;EAAnB,wCAAmB;EAAnB,iDAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,qCAAmB;EAAnB,iDAAmB;EAAnB,4BAAmB;EAAnB,6BAAmB;EAAnB,gCAAmB;EAAnB,kCAAmB;EAAnB,+BAAmB;EAAnB,kCAAmB;EAAnB,+BAAmB;EAAnB,mCAAmB;EAAnB,mCAAmB;EAAnB,mCAAmB;EAAnB,0BAAmB;EAAnB,4BAAmB;EAAnB,2BAAmB;EAAnB,gCAAmB;EAAnB,iCAAmB;EAAnB,gCAAmB;EAAnB,8IAAmB;EAAnB,iJAAmB;EAAnB,iJAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wGAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6HAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sIAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,qBAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,qBAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAFnB;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,uBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,iBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;;EAAA;IAAA,0BAMA;IANA;EAMA;AAAA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,sBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,sBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,gEAMA;EANA,+DAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,iFAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,2CAMA;EANA,mDAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,+FAMA;EANA,wDAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,8BAMA;EANA,wDAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,gBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,0BAMA;EANA,gCAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,sBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,yBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,iBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,gBAMA;EANA,gBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,6BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,oBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,oBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,oBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,oBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,oBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,oBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,oBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,yCAMA;EANA,uDAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,2CAMA;EANA,mDAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,wBAMA;EANA,wDAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,8BAMA;EANA,wDAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,gBAMA;EANA;AAMA;AANA;EAAA,iBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,+BAMA;EANA,gCAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,0BAMA;EANA,gCAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,2BAMA;EANA,gCAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,qDAMA;EANA,gCAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,iCAMA;EANA;AAMA;AANA;EAAA,qDAMA;EANA;AAMA;AANA;EAAA,iCAMA;EANA;AAMA;AANA;EAAA,sDAMA;EANA;AAMA;AANA;EAAA,8BAMA;EANA;AAMA;AANA;EAAA,qDAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,iCAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,8BAMA;EANA;AAMA;AANA;EAAA,+BAMA;EANA;AAMA;AANA;EAAA,mDAMA;EANA;AAMA;AANA;EAAA,+BAMA;EANA;AAMA;AANA;EAAA,oDAMA;EANA;AAMA;AANA;EAAA,4BAMA;EANA;AAMA;AANA;EAAA,mDAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,+BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,4BAMA;EANA;AAMA;AANA;EAAA,4BAMA;EANA;AAMA;AANA;EAAA,8BAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,6BAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,+EAMA;EANA,mGAMA;EANA;AAMA;AANA;EAAA,6EAMA;EANA,iGAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,8BAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,qBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,iBAMA;EANA;AAMA;AANA;EAAA,iBAMA;EANA;AAMA;AANA;EAAA,iBAMA;EANA;AAMA;AANA;EAAA,iBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,qBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,qBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,uBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,uBAMA;EANA;AAMA;AANA;EAAA,uBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,mBAMA;EANA;AAMA;AANA;EAAA,mBAMA;EANA;AAMA;AANA;EAAA,mBAMA;EANA;AAMA;AANA;EAAA,mBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,eAMA;EANA,eAMA;EANA;AAMA;AANA;EAAA,iBAMA;EANA,iBAMA;EANA;AAMA;AANA;EAAA,eAMA;EANA,eAMA;EANA;AAMA;AANA;EAAA,eAMA;EANA,eAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,6BAMA;EANA;AAMA;AANA;EAAA,6BAMA;EANA;AAMA;AANA;EAAA,6BAMA;EANA;AAMA;AANA;EAAA,6BAMA;EANA;AAMA;AANA;EAAA,6BAMA;EANA;AAMA;AANA;EAAA,6BAMA;EANA;AAMA;AANA;EAAA,6BAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,+BAMA;EANA;AAMA;AANA;EAAA,+BAMA;EANA;AAMA;AANA;EAAA,+BAMA;EANA;AAMA;AANA;EAAA,+BAMA;EANA;AAMA;AANA;EAAA,+BAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,6EAMA;EANA,iGAMA;EANA;AAMA;AANA;EAAA,+EAMA;EANA,mGAMA;EANA;AAMA;AANA;EAAA,6EAMA;EANA,iGAMA;EANA;AAMA;AANA;EAAA,6EAMA;EANA,iGAMA;EANA;AAMA;AANA;EAAA,6EAMA;EANA,iGAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA,8BAMA;EANA;AAMA;AANA;EAAA,kDAMA;EANA;AAMA;AANA;EAAA,mDAMA;EANA;AAMA;AANA;EAAA,mDAMA;EANA;AAMA;AANA;EAAA,qDAMA;EANA;AAMA;AANA;EAAA,mDAMA;EANA;AAMA;AANA;EAAA,mDAMA;EANA;AAMA;AANA;EAAA,kDAMA;EANA;AAMA;AANA;EAAA,mDAMA;EANA;AAMA;AANA;EAAA,mDAMA;EANA;AAMA;AANA;EAAA,qDAMA;EANA;AAMA;AANA;EAAA,mDAMA;EANA;AAMA;AANA;EAAA,mDAMA;EANA;AAMA;AANA;EAAA,kDAMA;EANA;AAMA;AANA;EAAA,sDAMA;EANA;AAMA;AANA;EAAA,mDAMA;EANA;AAMA;AANA;EAAA,qDAMA;EANA;AAMA;AANA;EAAA,mDAMA;EANA;AAMA;AANA;EAAA,mDAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,8BAMA;EANA;AAMA;AANA;EAAA,0CAMA;EANA,wDAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,+FAMA;EANA,wDAMA;EANA;AAMA;AANA;EAAA,8BAMA;EANA,wDAMA;EANA;AAMA;AANA;EAAA,wBAMA;EANA,wDAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,wBAMA;EANA,qBAMA;AAAA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,sBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,sBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,sBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,sBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,+BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,iCAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,+BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,iCAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,eAMA;EANA,eAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,iBAMA;EANA,iBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,kDAMA;EANA;AAMA;AANA;EAAA,mDAMA;EANA;AAMA;AANA;EAAA,mDAMA;EANA;AAMA;AANA;EAAA,qDAMA;EANA;AAMA;AANA;EAAA,mDAMA;EANA;AAMA;AANA;EAAA,mDAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,2DAMA;EANA;AAMA;AANA;EAAA,kFAMA;EANA;AAMA;AANA;EAAA,kFAMA;EANA;AAMA;AANA;EAAA,iFAMA;EANA;AAMA;AANA;EAAA,kFAMA;EANA;AAMA;AANA;EAAA,gFAMA;EANA;AAMA;AANA;EAAA,gFAMA;EANA;AAMA;AANA;EAAA,oHAMA;EANA;AAMA;AANA;EAAA,gFAMA;EANA;AAMA;AANA;EAAA,oHAMA;EANA;AAMA;AANA;EAAA,+EAMA;EANA;AAMA;AANA;EAAA,+EAMA;EANA;AAMA;AANA;EAAA,mHAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,kFAMA;EANA;AAMA;AANA;EAAA,kFAMA;EANA;AAMA;AANA;EAAA,iFAMA;EANA;AAMA;AANA;EAAA,kFAMA;EANA;AAMA;AANA;EAAA,gFAMA;EANA;AAMA;AANA;EAAA,gFAMA;EANA;AAMA;AANA;EAAA,oHAMA;EANA;AAMA;AANA;EAAA,gFAMA;EANA;AAMA;AANA;EAAA,oHAMA;EANA;AAMA;AANA;EAAA,+EAMA;EANA;AAMA;AANA;EAAA,+EAMA;EANA;AAMA;AANA;EAAA,mHAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,yBAMA;EANA;AAMA;AANA;EAAA,eAMA;EANA,eAMA;EANA;AAMA;AANA;EAAA,gBAMA;EANA,gBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,eAMA;EANA,eAMA;EANA;AAMA;AANA;EAAA,iBAMA;EANA,iBAMA;EANA;AAMA;AANA;EAAA,eAMA;EANA,eAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,iCAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,6BAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,6BAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,2GAMA;EANA,yGAMA;EANA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,qBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,qBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,mBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,eAMA;EANA,eAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,oBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,iBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA,kBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,sBAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA,0BAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,eAMA;EANA,eAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;;EAAA;IAAA,eAMA;IANA,eAMA;IANA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA,0BAMA;IANA;EAMA;AAAA;AANA;;EAAA;IAAA;EAMA;AAAA;AANA;;EAAA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA,gBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,mBAMA;IANA;EAMA;;EANA;IAAA,eAMA;IANA;EAMA;;EANA;IAAA,gBAMA;IANA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA,uBAMA;IANA,oDAMA;IANA;EAMA;;EANA;IAAA,uBAMA;IANA,2DAMA;IANA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA,iBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,iBAMA;IANA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA,iBAMA;IANA;EAMA;;EANA;IAAA,mBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA,iBAMA;IANA;EAMA;;EANA;IAAA,iBAMA;IANA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;AAAA;AANA;;EAAA;IAAA,iBAMA;IANA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;AAAA;AANA;;EAAA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,iBAMA;IANA;EAMA;;EANA;IAAA,iBAMA;IANA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;;IAAA;MAAA;IAMA;EAAA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;AAAA;AANA;;EAAA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;AAAA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,oBAMA;EANA;AAMA;AANA;EAAA,mBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,yBAMA;EANA;AAMA;AANA;EAAA,yBAMA;EANA;AAMA;AANA;EAAA,mBAMA;EANA;AAMA;AANA;;EAAA;IAAA,sBAMA;IANA;EAMA;;EANA;IAAA,sBAMA;IANA;EAMA;;EANA;IAAA,sBAMA;IANA;EAMA;;EANA;IAAA,sBAMA;IANA;EAMA;;EANA;IAAA,sBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,0BAMA;IANA,oFAMA;IANA;EAMA;;EANA;IAAA,0BAMA;IANA,kBAMA;IANA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,kBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,oBAMA;IANA;EAMA;;EANA;IAAA,0BAMA;IANA,kBAMA;IANA;EAMA;;EANA;IAAA,0BAMA;IANA,kBAMA;IANA;EAMA;;EANA;IAAA;EAMA;AAAA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,2CAMA;EANA,mDAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA,kBAMA;EANA;AAMA;AANA;EAAA;AAMA;AANA;EAAA,mBAMA;EANA;AAMA;AANA;EAAA,8BAMA;EANA,wDAMA;EANA;AAMA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import url('https://fonts.googleapis.com/css2?family=Bruno+Ace+SC&display=swap');\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
